import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const lazyLoadGql = (typeof window !== 'undefined') && (window?.blink?.performanceFlags?.isLazyLoadGqlEnabled === 'true');
export function lazyGql(factory) {
    let cached = null;
    if (!lazyLoadGql) {
        return factory();
    }
    return new Proxy({}, {
        get(_target, prop) {
            if (cached === null) {
                cached = factory();
            }
            return cached[prop];
        },
        set(_target, prop, value) {
            if (cached === null) {
                cached = factory();
            }
            cached[prop] = value;
            return true;
        },
        has(_target, prop) {
            if (cached === null) {
                cached = factory();
            }
            return prop in cached;
        },
        ownKeys() {
            if (cached === null) {
                cached = factory();
            }
            return Reflect.ownKeys(cached);
        },
        getOwnPropertyDescriptor(_target, prop) {
            if (cached === null) {
                cached = factory();
            }
            return Object.getOwnPropertyDescriptor(cached, prop);
        },
        getPrototypeOf() {
            if (cached === null) {
                cached = factory();
            }
            return Object.getPrototypeOf(cached);
        },
        setPrototypeOf(_target, proto) {
            if (cached === null) {
                cached = factory();
            }
            return Object.setPrototypeOf(cached, proto);
        },
        defineProperty(_target, prop, descriptor) {
            if (cached === null) {
                cached = factory();
            }
            return Object.defineProperty(cached, prop, descriptor);
        },
        deleteProperty(_target, prop) {
            if (cached === null) {
                cached = factory();
            }
            return delete cached[prop];
        },
        isExtensible() {
            if (cached === null) {
                cached = factory();
            }
            return Object.isExtensible(cached);
        },
        preventExtensions() {
            if (cached === null) {
                cached = factory();
            }
            Object.preventExtensions(cached);
            return true;
        },
        apply(_target, thisArg, argumentsList) {
            if (cached === null) {
                cached = factory();
            }
            return cached.apply(thisArg, argumentsList);
        },
        construct(_target, argumentsList, newTarget) {
            if (cached === null) {
                cached = factory();
            }
            return Reflect.construct(cached, argumentsList, newTarget);
        }
    });
}
const defaultOptions = {};
export var A3AnalysisTypeEnum;
(function (A3AnalysisTypeEnum) {
    A3AnalysisTypeEnum["AnomalyExplanation"] = "ANOMALY_EXPLANATION";
    A3AnalysisTypeEnum["Change"] = "CHANGE";
    A3AnalysisTypeEnum["Data"] = "DATA";
    A3AnalysisTypeEnum["RelatedInsights"] = "RELATED_INSIGHTS";
    A3AnalysisTypeEnum["Table"] = "TABLE";
    A3AnalysisTypeEnum["Unknown"] = "UNKNOWN";
    A3AnalysisTypeEnum["Visualization"] = "VISUALIZATION";
})(A3AnalysisTypeEnum || (A3AnalysisTypeEnum = {}));
export var A3ColumnType;
(function (A3ColumnType) {
    A3ColumnType["Attribute"] = "ATTRIBUTE";
    A3ColumnType["Measure"] = "MEASURE";
})(A3ColumnType || (A3ColumnType = {}));
export var AiAnswerState;
(function (AiAnswerState) {
    AiAnswerState["Disabled"] = "DISABLED";
    AiAnswerState["Enabled"] = "ENABLED";
    AiAnswerState["NotSet"] = "NOT_SET";
})(AiAnswerState || (AiAnswerState = {}));
export var AccessLevel;
(function (AccessLevel) {
    AccessLevel["Modify"] = "MODIFY";
    AccessLevel["ReadOnly"] = "READ_ONLY";
})(AccessLevel || (AccessLevel = {}));
export var AccessLevelEnum;
(function (AccessLevelEnum) {
    AccessLevelEnum["Full"] = "FULL";
    AccessLevelEnum["ReportBookView"] = "REPORT_BOOK_VIEW";
})(AccessLevelEnum || (AccessLevelEnum = {}));
export var AccessMode;
(function (AccessMode) {
    AccessMode["Modify"] = "MODIFY";
    AccessMode["ModifyMetadataReadContent"] = "MODIFY_METADATA_READ_CONTENT";
    AccessMode["NoAccess"] = "NO_ACCESS";
    AccessMode["ReadMetadataModifyContent"] = "READ_METADATA_MODIFY_CONTENT";
    AccessMode["ReadOnly"] = "READ_ONLY";
})(AccessMode || (AccessMode = {}));
export var AccessType;
(function (AccessType) {
    AccessType["User"] = "USER";
    AccessType["UserGroup"] = "USER_GROUP";
})(AccessType || (AccessType = {}));
export var ActionAvailability;
(function (ActionAvailability) {
    ActionAvailability["ContextMenuOnly"] = "CONTEXT_MENU_ONLY";
    ActionAvailability["Global"] = "GLOBAL";
    ActionAvailability["Worksheet"] = "WORKSHEET";
})(ActionAvailability || (ActionAvailability = {}));
export var ActionContext;
(function (ActionContext) {
    ActionContext["ContextMenu"] = "CONTEXT_MENU";
    ActionContext["Menu"] = "MENU";
    ActionContext["None"] = "NONE";
    ActionContext["Primary"] = "PRIMARY";
})(ActionContext || (ActionContext = {}));
export var ActionSelect;
(function (ActionSelect) {
    ActionSelect["Apikey"] = "APIKEY";
    ActionSelect["Basic"] = "BASIC";
    ActionSelect["Bearer"] = "BEARER";
    ActionSelect["None"] = "NONE";
})(ActionSelect || (ActionSelect = {}));
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["App"] = "APP";
    ActionTypes["Callback"] = "CALLBACK";
    ActionTypes["Url"] = "URL";
})(ActionTypes || (ActionTypes = {}));
export var Admin__FeatureManagementCategory;
(function (Admin__FeatureManagementCategory) {
    Admin__FeatureManagementCategory["EarlyAccess"] = "EARLY_ACCESS";
    Admin__FeatureManagementCategory["GeneralAccess"] = "GENERAL_ACCESS";
})(Admin__FeatureManagementCategory || (Admin__FeatureManagementCategory = {}));
export var Admin__FeatureManagementOperation;
(function (Admin__FeatureManagementOperation) {
    Admin__FeatureManagementOperation["Add"] = "ADD";
    Admin__FeatureManagementOperation["Remove"] = "REMOVE";
    Admin__FeatureManagementOperation["Replace"] = "REPLACE";
})(Admin__FeatureManagementOperation || (Admin__FeatureManagementOperation = {}));
export var Admin__FeatureManagementScope;
(function (Admin__FeatureManagementScope) {
    Admin__FeatureManagementScope["Cluster"] = "CLUSTER";
    Admin__FeatureManagementScope["Org"] = "ORG";
})(Admin__FeatureManagementScope || (Admin__FeatureManagementScope = {}));
export var AggregateFunctionTypeEnum;
(function (AggregateFunctionTypeEnum) {
    AggregateFunctionTypeEnum["Aggregate"] = "AGGREGATE";
    AggregateFunctionTypeEnum["AggrDistinct"] = "AGGR_DISTINCT";
    AggregateFunctionTypeEnum["ApproxAggrDistinct"] = "APPROX_AGGR_DISTINCT";
    AggregateFunctionTypeEnum["ApproxAggrDistinctMerge"] = "APPROX_AGGR_DISTINCT_MERGE";
    AggregateFunctionTypeEnum["ApproxCountDistinct"] = "APPROX_COUNT_DISTINCT";
    AggregateFunctionTypeEnum["Average"] = "AVERAGE";
    AggregateFunctionTypeEnum["Count"] = "COUNT";
    AggregateFunctionTypeEnum["CountDistinct"] = "COUNT_DISTINCT";
    AggregateFunctionTypeEnum["Growth"] = "GROWTH";
    AggregateFunctionTypeEnum["Max"] = "MAX";
    AggregateFunctionTypeEnum["Median"] = "MEDIAN";
    AggregateFunctionTypeEnum["Min"] = "MIN";
    AggregateFunctionTypeEnum["None"] = "NONE";
    AggregateFunctionTypeEnum["Percentile"] = "PERCENTILE";
    AggregateFunctionTypeEnum["Rank"] = "RANK";
    AggregateFunctionTypeEnum["RankPercentile"] = "RANK_PERCENTILE";
    AggregateFunctionTypeEnum["SqlBoolAggregateOp"] = "SQL_BOOL_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlDateAggregateOp"] = "SQL_DATE_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlDateTimeAggregateOp"] = "SQL_DATE_TIME_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlDoubleAggregateOp"] = "SQL_DOUBLE_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlIntAggregateOp"] = "SQL_INT_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlStringAggregateOp"] = "SQL_STRING_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlTimeAggregateOp"] = "SQL_TIME_AGGREGATE_OP";
    AggregateFunctionTypeEnum["StdDeviation"] = "STD_DEVIATION";
    AggregateFunctionTypeEnum["Sum"] = "SUM";
    AggregateFunctionTypeEnum["TableAggr"] = "TABLE_AGGR";
    AggregateFunctionTypeEnum["Variance"] = "VARIANCE";
})(AggregateFunctionTypeEnum || (AggregateFunctionTypeEnum = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["AggregateDistinct"] = "AGGREGATE_DISTINCT";
    AggregationType["Average"] = "AVERAGE";
    AggregationType["Count"] = "COUNT";
    AggregationType["Max"] = "MAX";
    AggregationType["Median"] = "MEDIAN";
    AggregationType["Min"] = "MIN";
    AggregationType["None"] = "NONE";
    AggregationType["Percentile"] = "PERCENTILE";
    AggregationType["Rank"] = "RANK";
    AggregationType["RankPercentile"] = "RANK_PERCENTILE";
    AggregationType["StdDeviation"] = "STD_DEVIATION";
    AggregationType["Sum"] = "SUM";
    AggregationType["UniqueCount"] = "UNIQUE_COUNT";
    AggregationType["Variance"] = "VARIANCE";
})(AggregationType || (AggregationType = {}));
export var AlertType;
(function (AlertType) {
    AlertType["Anomaly"] = "Anomaly";
    AlertType["Scheduled"] = "Scheduled";
    AlertType["ScheduledByAttribute"] = "ScheduledByAttribute";
    AlertType["Threshold"] = "Threshold";
    AlertType["ThresholdByAttribute"] = "ThresholdByAttribute";
})(AlertType || (AlertType = {}));
export var AnalysisActionResponseStatus;
(function (AnalysisActionResponseStatus) {
    AnalysisActionResponseStatus["Done"] = "DONE";
    AnalysisActionResponseStatus["Failed"] = "FAILED";
})(AnalysisActionResponseStatus || (AnalysisActionResponseStatus = {}));
export var AnalysisActionType;
(function (AnalysisActionType) {
    AnalysisActionType["Delete"] = "DELETE";
    AnalysisActionType["Save"] = "SAVE";
})(AnalysisActionType || (AnalysisActionType = {}));
export var AnalysisAlgorithmTypeEnum;
(function (AnalysisAlgorithmTypeEnum) {
    AnalysisAlgorithmTypeEnum["AbsDiffMajority"] = "ABS_DIFF_MAJORITY";
    AnalysisAlgorithmTypeEnum["AnomalyExplanation"] = "ANOMALY_EXPLANATION";
    AnalysisAlgorithmTypeEnum["CrossCorrelation"] = "CROSS_CORRELATION";
    AnalysisAlgorithmTypeEnum["Forecast"] = "FORECAST";
    AnalysisAlgorithmTypeEnum["KeyDrivers"] = "KEY_DRIVERS";
    AnalysisAlgorithmTypeEnum["LinearRegression"] = "LINEAR_REGRESSION";
    AnalysisAlgorithmTypeEnum["MadMedian"] = "MAD_MEDIAN";
    AnalysisAlgorithmTypeEnum["Shesd"] = "SHESD";
    AnalysisAlgorithmTypeEnum["StdevMean"] = "STDEV_MEAN";
    AnalysisAlgorithmTypeEnum["TrendAnalysis"] = "TREND_ANALYSIS";
    AnalysisAlgorithmTypeEnum["WhatIf"] = "WHAT_IF";
})(AnalysisAlgorithmTypeEnum || (AnalysisAlgorithmTypeEnum = {}));
export var AnalysisClassEnum;
(function (AnalysisClassEnum) {
    AnalysisClassEnum["AnomalyExplanation"] = "ANOMALY_EXPLANATION";
    AnalysisClassEnum["CrossCorrelation"] = "CROSS_CORRELATION";
    AnalysisClassEnum["CustomRAnalysis"] = "CUSTOM_R_ANALYSIS";
    AnalysisClassEnum["DiffExplanation"] = "DIFF_EXPLANATION";
    AnalysisClassEnum["Forecast"] = "FORECAST";
    AnalysisClassEnum["KeyDrivers"] = "KEY_DRIVERS";
    AnalysisClassEnum["OutlierDetection"] = "OUTLIER_DETECTION";
    AnalysisClassEnum["TrendAnalysis"] = "TREND_ANALYSIS";
    AnalysisClassEnum["WhatIf"] = "WHAT_IF";
})(AnalysisClassEnum || (AnalysisClassEnum = {}));
export var AnalysisSortBy;
(function (AnalysisSortBy) {
    AnalysisSortBy["ExpiresIn"] = "EXPIRES_IN";
    AnalysisSortBy["LastAnalyzed"] = "LAST_ANALYZED";
    AnalysisSortBy["Name"] = "NAME";
    AnalysisSortBy["Status"] = "STATUS";
    AnalysisSortBy["TriggeredBy"] = "TRIGGERED_BY";
})(AnalysisSortBy || (AnalysisSortBy = {}));
export var AnalysisState;
(function (AnalysisState) {
    AnalysisState["Completed"] = "COMPLETED";
    AnalysisState["Failed"] = "FAILED";
    AnalysisState["NoInsights"] = "NO_INSIGHTS";
    AnalysisState["Paused"] = "PAUSED";
    AnalysisState["Running"] = "RUNNING";
    AnalysisState["Scheduled"] = "SCHEDULED";
})(AnalysisState || (AnalysisState = {}));
export var AnalysisType;
(function (AnalysisType) {
    AnalysisType["Forecast"] = "FORECAST";
    AnalysisType["KeyDrivers"] = "KEY_DRIVERS";
    AnalysisType["KpiAnomalyDetection"] = "KPI_ANOMALY_DETECTION";
    AnalysisType["WhatIf"] = "WHAT_IF";
})(AnalysisType || (AnalysisType = {}));
export var AnnouncementPage;
(function (AnnouncementPage) {
    AnnouncementPage["Homepage"] = "HOMEPAGE";
})(AnnouncementPage || (AnnouncementPage = {}));
export var AnnouncementScope;
(function (AnnouncementScope) {
    AnnouncementScope["Cluster"] = "CLUSTER";
    AnnouncementScope["Org"] = "ORG";
})(AnnouncementScope || (AnnouncementScope = {}));
export var AnomalyDirectionEnum;
(function (AnomalyDirectionEnum) {
    AnomalyDirectionEnum["High"] = "HIGH";
    AnomalyDirectionEnum["Low"] = "LOW";
    AnomalyDirectionEnum["Unknown"] = "UNKNOWN";
})(AnomalyDirectionEnum || (AnomalyDirectionEnum = {}));
export var AnswerColumnCustomCalendarType;
(function (AnswerColumnCustomCalendarType) {
    AnswerColumnCustomCalendarType["EndOfDateBucket"] = "END_OF_DATE_BUCKET";
    AnswerColumnCustomCalendarType["FormattedDateBucketString"] = "FORMATTED_DATE_BUCKET_STRING";
})(AnswerColumnCustomCalendarType || (AnswerColumnCustomCalendarType = {}));
export var AnswerColumnEffectiveType;
(function (AnswerColumnEffectiveType) {
    AnswerColumnEffectiveType["Attribute"] = "ATTRIBUTE";
    AnswerColumnEffectiveType["Measure"] = "MEASURE";
    AnswerColumnEffectiveType["Unknown"] = "UNKNOWN";
})(AnswerColumnEffectiveType || (AnswerColumnEffectiveType = {}));
export var AnswerColumnFormatType;
(function (AnswerColumnFormatType) {
    AnswerColumnFormatType["Currency"] = "CURRENCY";
    AnswerColumnFormatType["None"] = "NONE";
    AnswerColumnFormatType["Percentage"] = "PERCENTAGE";
})(AnswerColumnFormatType || (AnswerColumnFormatType = {}));
export var AnswerColumnPropVersion;
(function (AnswerColumnPropVersion) {
    AnswerColumnPropVersion["PreV1"] = "PRE_V1";
    AnswerColumnPropVersion["V1"] = "V1";
})(AnswerColumnPropVersion || (AnswerColumnPropVersion = {}));
export var AnswerColumnSortType;
(function (AnswerColumnSortType) {
    AnswerColumnSortType["Ascending"] = "ASCENDING";
    AnswerColumnSortType["Descending"] = "DESCENDING";
    AnswerColumnSortType["Unknown"] = "UNKNOWN";
})(AnswerColumnSortType || (AnswerColumnSortType = {}));
export var AnswerColumnType;
(function (AnswerColumnType) {
    AnswerColumnType["FilterColumn"] = "FILTER_COLUMN";
    AnswerColumnType["GrowthColumn"] = "GROWTH_COLUMN";
    AnswerColumnType["SageColumn"] = "SAGE_COLUMN";
    AnswerColumnType["VizSpecificColumn"] = "VIZ_SPECIFIC_COLUMN";
})(AnswerColumnType || (AnswerColumnType = {}));
export var AnswerContextType;
(function (AnswerContextType) {
    AnswerContextType["ChangeAnalysis"] = "CHANGE_ANALYSIS";
    AnswerContextType["CohortAnswer"] = "COHORT_ANSWER";
    AnswerContextType["DownloadAnswer"] = "DOWNLOAD_ANSWER";
    AnswerContextType["EditPinboardViz"] = "EDIT_PINBOARD_VIZ";
    AnswerContextType["ExploreAnswer"] = "EXPLORE_ANSWER";
    AnswerContextType["KpiMonitor"] = "KPI_MONITOR";
    AnswerContextType["NewAnswer"] = "NEW_ANSWER";
    AnswerContextType["PinboardViz"] = "PINBOARD_VIZ";
    AnswerContextType["SavedAnswer"] = "SAVED_ANSWER";
    AnswerContextType["ScheduleAnswer"] = "SCHEDULE_ANSWER";
    AnswerContextType["SpotterNewAnswer"] = "SPOTTER_NEW_ANSWER";
    AnswerContextType["SpotIq"] = "SPOT_IQ";
    AnswerContextType["UnaggregatedAnswer"] = "UNAGGREGATED_ANSWER";
    AnswerContextType["View"] = "VIEW";
})(AnswerContextType || (AnswerContextType = {}));
export var AnswerJoinPathAmbiguityErrorType;
(function (AnswerJoinPathAmbiguityErrorType) {
    AnswerJoinPathAmbiguityErrorType["JoinPathResolutionRequired"] = "JOIN_PATH_RESOLUTION_REQUIRED";
    AnswerJoinPathAmbiguityErrorType["OtherBackendIssue"] = "OTHER_BACKEND_ISSUE";
})(AnswerJoinPathAmbiguityErrorType || (AnswerJoinPathAmbiguityErrorType = {}));
export var ApplicabilityLevel;
(function (ApplicabilityLevel) {
    ApplicabilityLevel["Group"] = "GROUP";
    ApplicabilityLevel["Liveboard"] = "LIVEBOARD";
    ApplicabilityLevel["Tab"] = "TAB";
})(ApplicabilityLevel || (ApplicabilityLevel = {}));
export var AssociatedActionContext;
(function (AssociatedActionContext) {
    AssociatedActionContext["ContextMenu"] = "CONTEXT_MENU";
    AssociatedActionContext["Menu"] = "MENU";
    AssociatedActionContext["None"] = "NONE";
    AssociatedActionContext["Primary"] = "PRIMARY";
})(AssociatedActionContext || (AssociatedActionContext = {}));
export var AtlasJoinType;
(function (AtlasJoinType) {
    AtlasJoinType["Cross"] = "CROSS";
    AtlasJoinType["Inner"] = "INNER";
    AtlasJoinType["Left"] = "LEFT";
    AtlasJoinType["Outer"] = "OUTER";
    AtlasJoinType["Right"] = "RIGHT";
})(AtlasJoinType || (AtlasJoinType = {}));
export var Augmentation_Column_Type;
(function (Augmentation_Column_Type) {
    Augmentation_Column_Type["AugmentData"] = "AUGMENT_DATA";
    Augmentation_Column_Type["TsObject"] = "TS_OBJECT";
})(Augmentation_Column_Type || (Augmentation_Column_Type = {}));
export var AuthenticationType;
(function (AuthenticationType) {
    AuthenticationType["Extoauth"] = "EXTOAUTH";
    AuthenticationType["Iam"] = "IAM";
    AuthenticationType["KeyPair"] = "KEY_PAIR";
    AuthenticationType["Oauth"] = "OAUTH";
    AuthenticationType["OauthClientCredentials"] = "OAUTH_CLIENT_CREDENTIALS";
    AuthenticationType["OauthWithPkce"] = "OAUTH_WITH_PKCE";
    AuthenticationType["OauthWithServicePrincipal"] = "OAUTH_WITH_SERVICE_PRINCIPAL";
    AuthenticationType["PersonalAccessToken"] = "PERSONAL_ACCESS_TOKEN";
    AuthenticationType["ServiceAccount"] = "SERVICE_ACCOUNT";
})(AuthenticationType || (AuthenticationType = {}));
export var AxisTypes;
(function (AxisTypes) {
    AxisTypes["Color"] = "COLOR";
    AxisTypes["X"] = "X";
    AxisTypes["Y"] = "Y";
})(AxisTypes || (AxisTypes = {}));
export var BackgroundFormatTypes;
(function (BackgroundFormatTypes) {
    BackgroundFormatTypes["Gradient"] = "GRADIENT";
    BackgroundFormatTypes["Solid"] = "SOLID";
})(BackgroundFormatTypes || (BackgroundFormatTypes = {}));
export var BannerLevel;
(function (BannerLevel) {
    BannerLevel["Cluster"] = "CLUSTER";
    BannerLevel["Org"] = "ORG";
})(BannerLevel || (BannerLevel = {}));
export var BulkEditColumAttributes;
(function (BulkEditColumAttributes) {
    BulkEditColumAttributes["Additive"] = "ADDITIVE";
    BulkEditColumAttributes["Aggregation"] = "AGGREGATION";
    BulkEditColumAttributes["AttributionDimension"] = "ATTRIBUTION_DIMENSION";
    BulkEditColumAttributes["CalendarType"] = "CALENDAR_TYPE";
    BulkEditColumAttributes["ColumnType"] = "COLUMN_TYPE";
    BulkEditColumAttributes["CurrencyInfo"] = "CURRENCY_INFO";
    BulkEditColumAttributes["FormatPattern"] = "FORMAT_PATTERN";
    BulkEditColumAttributes["GeoConfig"] = "GEO_CONFIG";
    BulkEditColumAttributes["Hidden"] = "HIDDEN";
    BulkEditColumAttributes["Index"] = "INDEX";
    BulkEditColumAttributes["Name"] = "NAME";
    BulkEditColumAttributes["Search"] = "SEARCH";
    BulkEditColumAttributes["SpotIqPreference"] = "SPOT_IQ_PREFERENCE";
    BulkEditColumAttributes["SyncWithSource"] = "SYNC_WITH_SOURCE";
})(BulkEditColumAttributes || (BulkEditColumAttributes = {}));
export var CcaColumnConfigAction;
(function (CcaColumnConfigAction) {
    CcaColumnConfigAction["Reset"] = "RESET";
    CcaColumnConfigAction["Save"] = "SAVE";
})(CcaColumnConfigAction || (CcaColumnConfigAction = {}));
export var CcaColumnConfigType;
(function (CcaColumnConfigType) {
    CcaColumnConfigType["Chart"] = "CHART";
    CcaColumnConfigType["Ubr"] = "UBR";
    CcaColumnConfigType["User"] = "USER";
})(CcaColumnConfigType || (CcaColumnConfigType = {}));
export var CategoryType;
(function (CategoryType) {
    CategoryType["Currency"] = "CURRENCY";
    CategoryType["Custom"] = "CUSTOM";
    CategoryType["Number"] = "NUMBER";
    CategoryType["Percentage"] = "PERCENTAGE";
})(CategoryType || (CategoryType = {}));
export var ChangeAnalysisInsightStatus;
(function (ChangeAnalysisInsightStatus) {
    ChangeAnalysisInsightStatus["ChangeAnalysisDataFetchForAihFailed"] = "CHANGE_ANALYSIS_DATA_FETCH_FOR_AIH_FAILED";
    ChangeAnalysisInsightStatus["ChangeAnalysisFailed"] = "CHANGE_ANALYSIS_FAILED";
    ChangeAnalysisInsightStatus["GroupAggregateNotSupported"] = "GROUP_AGGREGATE_NOT_SUPPORTED";
    ChangeAnalysisInsightStatus["StatusCodeOk"] = "STATUS_CODE_OK";
})(ChangeAnalysisInsightStatus || (ChangeAnalysisInsightStatus = {}));
export var ChangeInterpretation;
(function (ChangeInterpretation) {
    ChangeInterpretation["DownwardIsGood"] = "DOWNWARD_IS_GOOD";
    ChangeInterpretation["Neutral"] = "NEUTRAL";
    ChangeInterpretation["UpwardIsGood"] = "UPWARD_IS_GOOD";
})(ChangeInterpretation || (ChangeInterpretation = {}));
export var ChannelValidationResultCode;
(function (ChannelValidationResultCode) {
    ChannelValidationResultCode["Failed"] = "FAILED";
    ChannelValidationResultCode["PartialSuccess"] = "PARTIAL_SUCCESS";
    ChannelValidationResultCode["Success"] = "SUCCESS";
})(ChannelValidationResultCode || (ChannelValidationResultCode = {}));
export var ChannelValidationStepStatus;
(function (ChannelValidationStepStatus) {
    ChannelValidationStepStatus["Failed"] = "FAILED";
    ChannelValidationStepStatus["Success"] = "SUCCESS";
})(ChannelValidationStepStatus || (ChannelValidationStepStatus = {}));
export var ChartResponsiveLayout;
(function (ChartResponsiveLayout) {
    ChartResponsiveLayout["AutoOff"] = "AUTO_OFF";
    ChartResponsiveLayout["AutoOn"] = "AUTO_ON";
    ChartResponsiveLayout["UserPreferredOff"] = "USER_PREFERRED_OFF";
    ChartResponsiveLayout["UserPreferredOn"] = "USER_PREFERRED_ON";
})(ChartResponsiveLayout || (ChartResponsiveLayout = {}));
export var ChartSpecificColumnType;
(function (ChartSpecificColumnType) {
    ChartSpecificColumnType["MeasureNames"] = "MEASURE_NAMES";
    ChartSpecificColumnType["MeasureValues"] = "MEASURE_VALUES";
    ChartSpecificColumnType["Undefined"] = "UNDEFINED";
})(ChartSpecificColumnType || (ChartSpecificColumnType = {}));
export var ChartType;
(function (ChartType) {
    ChartType["AdvancedArea"] = "ADVANCED_AREA";
    ChartType["AdvancedBar"] = "ADVANCED_BAR";
    ChartType["AdvancedBubble"] = "ADVANCED_BUBBLE";
    ChartType["AdvancedColumn"] = "ADVANCED_COLUMN";
    ChartType["AdvancedDonut"] = "ADVANCED_DONUT";
    ChartType["AdvancedLine"] = "ADVANCED_LINE";
    ChartType["AdvancedLineColumn"] = "ADVANCED_LINE_COLUMN";
    ChartType["AdvancedLineStackedColumn"] = "ADVANCED_LINE_STACKED_COLUMN";
    ChartType["AdvancedPivotTable"] = "ADVANCED_PIVOT_TABLE";
    ChartType["AdvancedScatter"] = "ADVANCED_SCATTER";
    ChartType["AdvancedStackedArea"] = "ADVANCED_STACKED_AREA";
    ChartType["AdvancedStackedBar"] = "ADVANCED_STACKED_BAR";
    ChartType["AdvancedStackedColumn"] = "ADVANCED_STACKED_COLUMN";
    ChartType["AdvancedWaterfall"] = "ADVANCED_WATERFALL";
    ChartType["Area"] = "AREA";
    ChartType["Bar"] = "BAR";
    ChartType["Bubble"] = "BUBBLE";
    ChartType["Candlestick"] = "CANDLESTICK";
    ChartType["Column"] = "COLUMN";
    ChartType["CustomChart"] = "CUSTOM_CHART";
    ChartType["Funnel"] = "FUNNEL";
    ChartType["GeoArea"] = "GEO_AREA";
    ChartType["GeoBubble"] = "GEO_BUBBLE";
    ChartType["GeoEarthArea"] = "GEO_EARTH_AREA";
    ChartType["GeoEarthBar"] = "GEO_EARTH_BAR";
    ChartType["GeoEarthBubble"] = "GEO_EARTH_BUBBLE";
    ChartType["GeoEarthGraph"] = "GEO_EARTH_GRAPH";
    ChartType["GeoEarthHeatmap"] = "GEO_EARTH_HEATMAP";
    ChartType["GeoHeatmap"] = "GEO_HEATMAP";
    ChartType["GridTable"] = "GRID_TABLE";
    ChartType["Heatmap"] = "HEATMAP";
    ChartType["Kpi"] = "KPI";
    ChartType["Line"] = "LINE";
    ChartType["LineColumn"] = "LINE_COLUMN";
    ChartType["LineStackedColumn"] = "LINE_STACKED_COLUMN";
    ChartType["MuzeStudio"] = "MUZE_STUDIO";
    ChartType["None"] = "NONE";
    ChartType["Pareto"] = "PARETO";
    ChartType["Pie"] = "PIE";
    ChartType["PivotTable"] = "PIVOT_TABLE";
    ChartType["Sankey"] = "SANKEY";
    ChartType["Scatter"] = "SCATTER";
    ChartType["SpiderWeb"] = "SPIDER_WEB";
    ChartType["StackedArea"] = "STACKED_AREA";
    ChartType["StackedBar"] = "STACKED_BAR";
    ChartType["StackedColumn"] = "STACKED_COLUMN";
    ChartType["Treemap"] = "TREEMAP";
    ChartType["Waterfall"] = "WATERFALL";
    ChartType["WhiskerScatter"] = "WHISKER_SCATTER";
})(ChartType || (ChartType = {}));
export var ChartVizPropVersion;
(function (ChartVizPropVersion) {
    ChartVizPropVersion["V2"] = "V2";
    ChartVizPropVersion["V2Dot1"] = "V2DOT1";
    ChartVizPropVersion["V3"] = "V3";
    ChartVizPropVersion["V4"] = "V4";
    ChartVizPropVersion["V4Dot1"] = "V4DOT1";
    ChartVizPropVersion["V4Dot2"] = "V4DOT2";
})(ChartVizPropVersion || (ChartVizPropVersion = {}));
export var ChipType;
(function (ChipType) {
    ChipType["Filter"] = "FILTER";
    ChipType["Parameter"] = "PARAMETER";
})(ChipType || (ChipType = {}));
export var CohortConditionCombinationType;
(function (CohortConditionCombinationType) {
    CohortConditionCombinationType["All"] = "ALL";
    CohortConditionCombinationType["Any"] = "ANY";
})(CohortConditionCombinationType || (CohortConditionCombinationType = {}));
export var CohortGroupingType;
(function (CohortGroupingType) {
    CohortGroupingType["BinBased"] = "BIN_BASED";
    CohortGroupingType["ColumnBased"] = "COLUMN_BASED";
    CohortGroupingType["GroupBased"] = "GROUP_BASED";
})(CohortGroupingType || (CohortGroupingType = {}));
export var CohortLevel;
(function (CohortLevel) {
    CohortLevel["Answer"] = "ANSWER";
    CohortLevel["Reusable"] = "REUSABLE";
})(CohortLevel || (CohortLevel = {}));
export var CohortType;
(function (CohortType) {
    CohortType["Advanced"] = "ADVANCED";
    CohortType["BinBased"] = "BIN_BASED";
    CohortType["ColumnBased"] = "COLUMN_BASED";
    CohortType["GroupBased"] = "GROUP_BASED";
    CohortType["Simple"] = "SIMPLE";
})(CohortType || (CohortType = {}));
export var ColumnAggregationType;
(function (ColumnAggregationType) {
    ColumnAggregationType["Aggregate"] = "AGGREGATE";
    ColumnAggregationType["AggregateDistinct"] = "AGGREGATE_DISTINCT";
    ColumnAggregationType["ApproxAggrDistinct"] = "APPROX_AGGR_DISTINCT";
    ColumnAggregationType["ApproxAggrDistinctMerge"] = "APPROX_AGGR_DISTINCT_MERGE";
    ColumnAggregationType["ApproxCountDistinct"] = "APPROX_COUNT_DISTINCT";
    ColumnAggregationType["Average"] = "AVERAGE";
    ColumnAggregationType["Count"] = "COUNT";
    ColumnAggregationType["CountDistinct"] = "COUNT_DISTINCT";
    ColumnAggregationType["CumulativeAverage"] = "CUMULATIVE_AVERAGE";
    ColumnAggregationType["CumulativeCount"] = "CUMULATIVE_COUNT";
    ColumnAggregationType["CumulativeMax"] = "CUMULATIVE_MAX";
    ColumnAggregationType["CumulativeMin"] = "CUMULATIVE_MIN";
    ColumnAggregationType["CumulativeSum"] = "CUMULATIVE_SUM";
    ColumnAggregationType["Growth"] = "GROWTH";
    ColumnAggregationType["Max"] = "MAX";
    ColumnAggregationType["Median"] = "MEDIAN";
    ColumnAggregationType["Min"] = "MIN";
    ColumnAggregationType["MovingAverage"] = "MOVING_AVERAGE";
    ColumnAggregationType["MovingCount"] = "MOVING_COUNT";
    ColumnAggregationType["MovingMax"] = "MOVING_MAX";
    ColumnAggregationType["MovingMin"] = "MOVING_MIN";
    ColumnAggregationType["MovingSum"] = "MOVING_SUM";
    ColumnAggregationType["None"] = "NONE";
    ColumnAggregationType["Percentile"] = "PERCENTILE";
    ColumnAggregationType["Rank"] = "RANK";
    ColumnAggregationType["RankPercentile"] = "RANK_PERCENTILE";
    ColumnAggregationType["SqlBoolAggregateOp"] = "SQL_BOOL_AGGREGATE_OP";
    ColumnAggregationType["SqlDateAggregateOp"] = "SQL_DATE_AGGREGATE_OP";
    ColumnAggregationType["SqlDateTimeAggregateOp"] = "SQL_DATE_TIME_AGGREGATE_OP";
    ColumnAggregationType["SqlDoubleAggregateOp"] = "SQL_DOUBLE_AGGREGATE_OP";
    ColumnAggregationType["SqlIntAggregateOp"] = "SQL_INT_AGGREGATE_OP";
    ColumnAggregationType["SqlStringAggregateOp"] = "SQL_STRING_AGGREGATE_OP";
    ColumnAggregationType["SqlTimeAggregateOp"] = "SQL_TIME_AGGREGATE_OP";
    ColumnAggregationType["StdDeviation"] = "STD_DEVIATION";
    ColumnAggregationType["Sum"] = "SUM";
    ColumnAggregationType["TableAggr"] = "TABLE_AGGR";
    ColumnAggregationType["Variance"] = "VARIANCE";
})(ColumnAggregationType || (ColumnAggregationType = {}));
export var ColumnDataTypeEnum;
(function (ColumnDataTypeEnum) {
    ColumnDataTypeEnum["Bool"] = "BOOL";
    ColumnDataTypeEnum["Char"] = "CHAR";
    ColumnDataTypeEnum["Date"] = "DATE";
    ColumnDataTypeEnum["DateNum"] = "DATE_NUM";
    ColumnDataTypeEnum["DateNumAbsDay"] = "DATE_NUM_ABS_DAY";
    ColumnDataTypeEnum["DateNumAbsHour"] = "DATE_NUM_ABS_HOUR";
    ColumnDataTypeEnum["DateNumAbsMonth"] = "DATE_NUM_ABS_MONTH";
    ColumnDataTypeEnum["DateNumAbsQuarter"] = "DATE_NUM_ABS_QUARTER";
    ColumnDataTypeEnum["DateNumAbsWeek"] = "DATE_NUM_ABS_WEEK";
    ColumnDataTypeEnum["DateNumAbsYear"] = "DATE_NUM_ABS_YEAR";
    ColumnDataTypeEnum["DateNumDayInMonth"] = "DATE_NUM_DAY_IN_MONTH";
    ColumnDataTypeEnum["DateNumDayInQuarter"] = "DATE_NUM_DAY_IN_QUARTER";
    ColumnDataTypeEnum["DateNumDayInYear"] = "DATE_NUM_DAY_IN_YEAR";
    ColumnDataTypeEnum["DateNumDayOfWeek"] = "DATE_NUM_DAY_OF_WEEK";
    ColumnDataTypeEnum["DateNumDayOfWeekStr"] = "DATE_NUM_DAY_OF_WEEK_STR";
    ColumnDataTypeEnum["DateNumHourInDay"] = "DATE_NUM_HOUR_IN_DAY";
    ColumnDataTypeEnum["DateNumMonthInQuarter"] = "DATE_NUM_MONTH_IN_QUARTER";
    ColumnDataTypeEnum["DateNumMonthInYear"] = "DATE_NUM_MONTH_IN_YEAR";
    ColumnDataTypeEnum["DateNumQuarterInYear"] = "DATE_NUM_QUARTER_IN_YEAR";
    ColumnDataTypeEnum["DateNumSecInDay"] = "DATE_NUM_SEC_IN_DAY";
    ColumnDataTypeEnum["DateNumWeekInMonth"] = "DATE_NUM_WEEK_IN_MONTH";
    ColumnDataTypeEnum["DateNumWeekInQuarter"] = "DATE_NUM_WEEK_IN_QUARTER";
    ColumnDataTypeEnum["DateNumWeekInYear"] = "DATE_NUM_WEEK_IN_YEAR";
    ColumnDataTypeEnum["DateTime"] = "DATE_TIME";
    ColumnDataTypeEnum["Double"] = "DOUBLE";
    ColumnDataTypeEnum["Float"] = "FLOAT";
    ColumnDataTypeEnum["Int32"] = "INT32";
    ColumnDataTypeEnum["Int64"] = "INT64";
    ColumnDataTypeEnum["List"] = "LIST";
    ColumnDataTypeEnum["ListBool"] = "LIST_BOOL";
    ColumnDataTypeEnum["ListDate"] = "LIST_DATE";
    ColumnDataTypeEnum["ListDateTime"] = "LIST_DATE_TIME";
    ColumnDataTypeEnum["ListDouble"] = "LIST_DOUBLE";
    ColumnDataTypeEnum["ListInt"] = "LIST_INT";
    ColumnDataTypeEnum["ListString"] = "LIST_STRING";
    ColumnDataTypeEnum["ListTime"] = "LIST_TIME";
    ColumnDataTypeEnum["Time"] = "TIME";
    ColumnDataTypeEnum["Unknown"] = "UNKNOWN";
    ColumnDataTypeEnum["Varchar"] = "VARCHAR";
})(ColumnDataTypeEnum || (ColumnDataTypeEnum = {}));
export var ColumnProperty;
(function (ColumnProperty) {
    ColumnProperty["GrowthDimension"] = "GROWTH_DIMENSION";
    ColumnProperty["IsFormula"] = "IS_FORMULA";
    ColumnProperty["IsGrouping"] = "IS_GROUPING";
    ColumnProperty["IsOutput"] = "IS_OUTPUT";
    ColumnProperty["SortAscending"] = "SORT_ASCENDING";
    ColumnProperty["SortDescending"] = "SORT_DESCENDING";
})(ColumnProperty || (ColumnProperty = {}));
export var ColumnSortCategory;
(function (ColumnSortCategory) {
    ColumnSortCategory["Alpha"] = "ALPHA";
    ColumnSortCategory["Custom"] = "CUSTOM";
    ColumnSortCategory["Default"] = "DEFAULT";
    ColumnSortCategory["None"] = "NONE";
})(ColumnSortCategory || (ColumnSortCategory = {}));
export var ColumnSortConfigOptions;
(function (ColumnSortConfigOptions) {
    ColumnSortConfigOptions["Custom"] = "CUSTOM";
    ColumnSortConfigOptions["Default"] = "DEFAULT";
})(ColumnSortConfigOptions || (ColumnSortConfigOptions = {}));
export var ColumnTimeBucket;
(function (ColumnTimeBucket) {
    ColumnTimeBucket["Auto"] = "AUTO";
    ColumnTimeBucket["Daily"] = "DAILY";
    ColumnTimeBucket["DayOfMonth"] = "DAY_OF_MONTH";
    ColumnTimeBucket["DayOfQuarter"] = "DAY_OF_QUARTER";
    ColumnTimeBucket["DayOfWeek"] = "DAY_OF_WEEK";
    ColumnTimeBucket["DayOfYear"] = "DAY_OF_YEAR";
    ColumnTimeBucket["Hourly"] = "HOURLY";
    ColumnTimeBucket["HourOfDay"] = "HOUR_OF_DAY";
    ColumnTimeBucket["Monthly"] = "MONTHLY";
    ColumnTimeBucket["MonthOfQuarter"] = "MONTH_OF_QUARTER";
    ColumnTimeBucket["MonthOfYear"] = "MONTH_OF_YEAR";
    ColumnTimeBucket["NoBucket"] = "NO_BUCKET";
    ColumnTimeBucket["Quarterly"] = "QUARTERLY";
    ColumnTimeBucket["QuarterOfYear"] = "QUARTER_OF_YEAR";
    ColumnTimeBucket["Weekly"] = "WEEKLY";
    ColumnTimeBucket["WeekOfMonth"] = "WEEK_OF_MONTH";
    ColumnTimeBucket["WeekOfQuarter"] = "WEEK_OF_QUARTER";
    ColumnTimeBucket["WeekOfYear"] = "WEEK_OF_YEAR";
    ColumnTimeBucket["Yearly"] = "YEARLY";
})(ColumnTimeBucket || (ColumnTimeBucket = {}));
export var ColumnType;
(function (ColumnType) {
    ColumnType["Attribute"] = "ATTRIBUTE";
    ColumnType["Date"] = "DATE";
    ColumnType["Measure"] = "MEASURE";
})(ColumnType || (ColumnType = {}));
export var ColumnValueType;
(function (ColumnValueType) {
    ColumnValueType["Bool"] = "BOOL";
    ColumnValueType["Char"] = "CHAR";
    ColumnValueType["Date"] = "DATE";
    ColumnValueType["Double"] = "DOUBLE";
    ColumnValueType["Int"] = "INT";
    ColumnValueType["Unknown"] = "UNKNOWN";
})(ColumnValueType || (ColumnValueType = {}));
export var CommunicationChannelTypeToValidate;
(function (CommunicationChannelTypeToValidate) {
    CommunicationChannelTypeToValidate["Webhook"] = "WEBHOOK";
})(CommunicationChannelTypeToValidate || (CommunicationChannelTypeToValidate = {}));
export var CommunicationChannelValidationStep;
(function (CommunicationChannelValidationStep) {
    CommunicationChannelValidationStep["HttpConnectionCheck"] = "HTTP_CONNECTION_CHECK";
    CommunicationChannelValidationStep["StorageFileUploadCheck"] = "STORAGE_FILE_UPLOAD_CHECK";
})(CommunicationChannelValidationStep || (CommunicationChannelValidationStep = {}));
export var ComparisonOperatorType;
(function (ComparisonOperatorType) {
    ComparisonOperatorType["BeginsWith"] = "BEGINS_WITH";
    ComparisonOperatorType["Bw"] = "BW";
    ComparisonOperatorType["Contains"] = "CONTAINS";
    ComparisonOperatorType["EndsWith"] = "ENDS_WITH";
    ComparisonOperatorType["Eq"] = "EQ";
    ComparisonOperatorType["Ge"] = "GE";
    ComparisonOperatorType["Gt"] = "GT";
    ComparisonOperatorType["Le"] = "LE";
    ComparisonOperatorType["Lt"] = "LT";
    ComparisonOperatorType["Ne"] = "NE";
    ComparisonOperatorType["NotContains"] = "NOT_CONTAINS";
})(ComparisonOperatorType || (ComparisonOperatorType = {}));
export var ComparisonType;
(function (ComparisonType) {
    ComparisonType["Current"] = "CURRENT";
    ComparisonType["Previous"] = "PREVIOUS";
})(ComparisonType || (ComparisonType = {}));
export var ComponentType;
(function (ComponentType) {
    ComponentType["Group"] = "GROUP";
    ComponentType["Tile"] = "TILE";
})(ComponentType || (ComponentType = {}));
export var ConditionalFormattingComparisonTypes;
(function (ConditionalFormattingComparisonTypes) {
    ConditionalFormattingComparisonTypes["ColumnBased"] = "COLUMN_BASED";
    ConditionalFormattingComparisonTypes["ParameterBased"] = "PARAMETER_BASED";
    ConditionalFormattingComparisonTypes["ValueBased"] = "VALUE_BASED";
})(ConditionalFormattingComparisonTypes || (ConditionalFormattingComparisonTypes = {}));
export var ConnectionConfigType;
(function (ConnectionConfigType) {
    ConnectionConfigType["RdbmsAmazonAthena"] = "RDBMS_AMAZON_ATHENA";
    ConnectionConfigType["RdbmsAmazonAuroraMysql"] = "RDBMS_AMAZON_AURORA_MYSQL";
    ConnectionConfigType["RdbmsAmazonAuroraPostgresql"] = "RDBMS_AMAZON_AURORA_POSTGRESQL";
    ConnectionConfigType["RdbmsAmazonRdsMysql"] = "RDBMS_AMAZON_RDS_MYSQL";
    ConnectionConfigType["RdbmsAmazonRdsPostgresql"] = "RDBMS_AMAZON_RDS_POSTGRESQL";
    ConnectionConfigType["RdbmsAzureSqlDatawarehouse"] = "RDBMS_AZURE_SQL_DATAWAREHOUSE";
    ConnectionConfigType["RdbmsClickhouse"] = "RDBMS_CLICKHOUSE";
    ConnectionConfigType["RdbmsDatabricks"] = "RDBMS_DATABRICKS";
    ConnectionConfigType["RdbmsDenodo"] = "RDBMS_DENODO";
    ConnectionConfigType["RdbmsDremio"] = "RDBMS_DREMIO";
    ConnectionConfigType["RdbmsDrSum"] = "RDBMS_DR_SUM";
    ConnectionConfigType["RdbmsFalcon"] = "RDBMS_FALCON";
    ConnectionConfigType["RdbmsFalconOnprem"] = "RDBMS_FALCON_ONPREM";
    ConnectionConfigType["RdbmsGcpAlloydbPostgresql"] = "RDBMS_GCP_ALLOYDB_POSTGRESQL";
    ConnectionConfigType["RdbmsGcpBigquery"] = "RDBMS_GCP_BIGQUERY";
    ConnectionConfigType["RdbmsGcpMysql"] = "RDBMS_GCP_MYSQL";
    ConnectionConfigType["RdbmsGcpPostgresql"] = "RDBMS_GCP_POSTGRESQL";
    ConnectionConfigType["RdbmsGcpSqlserver"] = "RDBMS_GCP_SQLSERVER";
    ConnectionConfigType["RdbmsGenericJdbc"] = "RDBMS_GENERIC_JDBC";
    ConnectionConfigType["RdbmsGoogleSheets"] = "RDBMS_GOOGLE_SHEETS";
    ConnectionConfigType["RdbmsIomete"] = "RDBMS_IOMETE";
    ConnectionConfigType["RdbmsLooker"] = "RDBMS_LOOKER";
    ConnectionConfigType["RdbmsLookerMl"] = "RDBMS_LOOKER_ML";
    ConnectionConfigType["RdbmsMode"] = "RDBMS_MODE";
    ConnectionConfigType["RdbmsMysql"] = "RDBMS_MYSQL";
    ConnectionConfigType["RdbmsOracleAdw"] = "RDBMS_ORACLE_ADW";
    ConnectionConfigType["RdbmsPostgres"] = "RDBMS_POSTGRES";
    ConnectionConfigType["RdbmsPresto"] = "RDBMS_PRESTO";
    ConnectionConfigType["RdbmsPrestoJdbc"] = "RDBMS_PRESTO_JDBC";
    ConnectionConfigType["RdbmsRedshift"] = "RDBMS_REDSHIFT";
    ConnectionConfigType["RdbmsSapHana"] = "RDBMS_SAP_HANA";
    ConnectionConfigType["RdbmsSinglestore"] = "RDBMS_SINGLESTORE";
    ConnectionConfigType["RdbmsSnowflake"] = "RDBMS_SNOWFLAKE";
    ConnectionConfigType["RdbmsSqlserver"] = "RDBMS_SQLSERVER";
    ConnectionConfigType["RdbmsTeradata"] = "RDBMS_TERADATA";
    ConnectionConfigType["RdbmsTrino"] = "RDBMS_TRINO";
})(ConnectionConfigType || (ConnectionConfigType = {}));
export var ConnectionRelationType;
(function (ConnectionRelationType) {
    ConnectionRelationType["Administrator"] = "ADMINISTRATOR";
    ConnectionRelationType["ConnectionOwner"] = "CONNECTION_OWNER";
    ConnectionRelationType["None"] = "NONE";
    ConnectionRelationType["SharedWithCurrentUser"] = "SHARED_WITH_CURRENT_USER";
})(ConnectionRelationType || (ConnectionRelationType = {}));
export var ConnectionTypeEnum;
(function (ConnectionTypeEnum) {
    ConnectionTypeEnum["DataSource"] = "DATA_SOURCE";
    ConnectionTypeEnum["LogicalColumn"] = "LOGICAL_COLUMN";
    ConnectionTypeEnum["LogicalTable"] = "LOGICAL_TABLE";
})(ConnectionTypeEnum || (ConnectionTypeEnum = {}));
export var ConnectorType;
(function (ConnectorType) {
    ConnectorType["Airbyte"] = "AIRBYTE";
    ConnectorType["Fivetran"] = "FIVETRAN";
    ConnectorType["Matillion"] = "MATILLION";
})(ConnectorType || (ConnectorType = {}));
export var CortexInsightStatus;
(function (CortexInsightStatus) {
    CortexInsightStatus["CortexAnalysisFailed"] = "CORTEX_ANALYSIS_FAILED";
    CortexInsightStatus["StatusCodeOk"] = "STATUS_CODE_OK";
})(CortexInsightStatus || (CortexInsightStatus = {}));
export var CurrencyFormatType;
(function (CurrencyFormatType) {
    CurrencyFormatType["Column"] = "COLUMN";
    CurrencyFormatType["IsoCode"] = "ISO_CODE";
    CurrencyFormatType["UserLocale"] = "USER_LOCALE";
})(CurrencyFormatType || (CurrencyFormatType = {}));
export var CurrencySetting;
(function (CurrencySetting) {
    CurrencySetting["FromColumn"] = "FROM_COLUMN";
    CurrencySetting["FromIsoCode"] = "FROM_ISO_CODE";
    CurrencySetting["FromUserLocale"] = "FROM_USER_LOCALE";
    CurrencySetting["None"] = "NONE";
})(CurrencySetting || (CurrencySetting = {}));
export var CurrentDataOptionsEnum;
(function (CurrentDataOptionsEnum) {
    CurrentDataOptionsEnum["CurrentOnly"] = "CURRENT_ONLY";
    CurrentDataOptionsEnum["Exclude"] = "EXCLUDE";
    CurrentDataOptionsEnum["Include"] = "INCLUDE";
})(CurrentDataOptionsEnum || (CurrentDataOptionsEnum = {}));
export var CustomChartAxisConfigTypeEnum;
(function (CustomChartAxisConfigTypeEnum) {
    CustomChartAxisConfigTypeEnum["Dual"] = "DUAL";
    CustomChartAxisConfigTypeEnum["Flat"] = "FLAT";
    CustomChartAxisConfigTypeEnum["Merged"] = "MERGED";
})(CustomChartAxisConfigTypeEnum || (CustomChartAxisConfigTypeEnum = {}));
export var CustomChartDimensionModeEnum;
(function (CustomChartDimensionModeEnum) {
    CustomChartDimensionModeEnum["AxisDriven"] = "AXIS_DRIVEN";
    CustomChartDimensionModeEnum["ColumnDriven"] = "COLUMN_DRIVEN";
})(CustomChartDimensionModeEnum || (CustomChartDimensionModeEnum = {}));
export var DataConnection;
(function (DataConnection) {
    DataConnection["AmazonRedshift"] = "AMAZON_REDSHIFT";
    DataConnection["AzureSynapse"] = "AZURE_SYNAPSE";
    DataConnection["Databricks"] = "DATABRICKS";
    DataConnection["Denodo"] = "DENODO";
    DataConnection["Dremio"] = "DREMIO";
    DataConnection["GoogleBigquery"] = "GOOGLE_BIGQUERY";
    DataConnection["OracleAdw"] = "ORACLE_ADW";
    DataConnection["SapHana"] = "SAP_HANA";
    DataConnection["Snowflake"] = "SNOWFLAKE";
    DataConnection["Starburst"] = "STARBURST";
    DataConnection["Teradata"] = "TERADATA";
})(DataConnection || (DataConnection = {}));
export var DataLabelFilterOperator;
(function (DataLabelFilterOperator) {
    DataLabelFilterOperator["EqualTo"] = "EQUAL_TO";
    DataLabelFilterOperator["FilterOperatorUnspecified"] = "FILTER_OPERATOR_UNSPECIFIED";
    DataLabelFilterOperator["GreaterThan"] = "GREATER_THAN";
    DataLabelFilterOperator["GreaterThanOrEqualTo"] = "GREATER_THAN_OR_EQUAL_TO";
    DataLabelFilterOperator["LessThan"] = "LESS_THAN";
    DataLabelFilterOperator["LessThanOrEqualTo"] = "LESS_THAN_OR_EQUAL_TO";
    DataLabelFilterOperator["NotEqualTo"] = "NOT_EQUAL_TO";
})(DataLabelFilterOperator || (DataLabelFilterOperator = {}));
export var DataSourceOrigin;
(function (DataSourceOrigin) {
    DataSourceOrigin["Copilot"] = "COPILOT";
    DataSourceOrigin["Nls"] = "NLS";
    DataSourceOrigin["TrainSage"] = "TRAIN_SAGE";
    DataSourceOrigin["UnifiedSage"] = "UNIFIED_SAGE";
})(DataSourceOrigin || (DataSourceOrigin = {}));
export var DataSourceType;
(function (DataSourceType) {
    DataSourceType["Default"] = "DEFAULT";
    DataSourceType["FileCsv"] = "FILE_CSV";
    DataSourceType["Informatica"] = "INFORMATICA";
    DataSourceType["IpaasInformatica"] = "IPAAS_INFORMATICA";
    DataSourceType["RdbmsAmazonAthena"] = "RDBMS_AMAZON_ATHENA";
    DataSourceType["RdbmsAmazonAuroraMysql"] = "RDBMS_AMAZON_AURORA_MYSQL";
    DataSourceType["RdbmsAmazonAuroraPostgresql"] = "RDBMS_AMAZON_AURORA_POSTGRESQL";
    DataSourceType["RdbmsAmazonRdsMysql"] = "RDBMS_AMAZON_RDS_MYSQL";
    DataSourceType["RdbmsAmazonRdsPostgresql"] = "RDBMS_AMAZON_RDS_POSTGRESQL";
    DataSourceType["RdbmsAzureSqlDatawarehouse"] = "RDBMS_AZURE_SQL_DATAWAREHOUSE";
    DataSourceType["RdbmsClickhouse"] = "RDBMS_CLICKHOUSE";
    DataSourceType["RdbmsDatabricks"] = "RDBMS_DATABRICKS";
    DataSourceType["RdbmsDenodo"] = "RDBMS_DENODO";
    DataSourceType["RdbmsDremio"] = "RDBMS_DREMIO";
    DataSourceType["RdbmsDrSum"] = "RDBMS_DR_SUM";
    DataSourceType["RdbmsFalcon"] = "RDBMS_FALCON";
    DataSourceType["RdbmsFalconOnprem"] = "RDBMS_FALCON_ONPREM";
    DataSourceType["RdbmsGcpAlloydbPostgresql"] = "RDBMS_GCP_ALLOYDB_POSTGRESQL";
    DataSourceType["RdbmsGcpBigquery"] = "RDBMS_GCP_BIGQUERY";
    DataSourceType["RdbmsGcpMysql"] = "RDBMS_GCP_MYSQL";
    DataSourceType["RdbmsGcpPostgresql"] = "RDBMS_GCP_POSTGRESQL";
    DataSourceType["RdbmsGcpSqlserver"] = "RDBMS_GCP_SQLSERVER";
    DataSourceType["RdbmsGenericJdbc"] = "RDBMS_GENERIC_JDBC";
    DataSourceType["RdbmsGoogleSheets"] = "RDBMS_GOOGLE_SHEETS";
    DataSourceType["RdbmsIomete"] = "RDBMS_IOMETE";
    DataSourceType["RdbmsLooker"] = "RDBMS_LOOKER";
    DataSourceType["RdbmsLookerMl"] = "RDBMS_LOOKER_ML";
    DataSourceType["RdbmsMarketo"] = "RDBMS_MARKETO";
    DataSourceType["RdbmsMockDatabase"] = "RDBMS_MOCK_DATABASE";
    DataSourceType["RdbmsMode"] = "RDBMS_MODE";
    DataSourceType["RdbmsMysql"] = "RDBMS_MYSQL";
    DataSourceType["RdbmsOracle"] = "RDBMS_ORACLE";
    DataSourceType["RdbmsOracleAdw"] = "RDBMS_ORACLE_ADW";
    DataSourceType["RdbmsPostgres"] = "RDBMS_POSTGRES";
    DataSourceType["RdbmsPresto"] = "RDBMS_PRESTO";
    DataSourceType["RdbmsPrestoJdbc"] = "RDBMS_PRESTO_JDBC";
    DataSourceType["RdbmsRedshift"] = "RDBMS_REDSHIFT";
    DataSourceType["RdbmsSalesforce"] = "RDBMS_SALESFORCE";
    DataSourceType["RdbmsSapHana"] = "RDBMS_SAP_HANA";
    DataSourceType["RdbmsServiceNow"] = "RDBMS_SERVICE_NOW";
    DataSourceType["RdbmsSinglestore"] = "RDBMS_SINGLESTORE";
    DataSourceType["RdbmsSnowflake"] = "RDBMS_SNOWFLAKE";
    DataSourceType["RdbmsSqlserver"] = "RDBMS_SQLSERVER";
    DataSourceType["RdbmsTeradata"] = "RDBMS_TERADATA";
    DataSourceType["RdbmsTrino"] = "RDBMS_TRINO";
    DataSourceType["SaasSalesforce"] = "SAAS_SALESFORCE";
})(DataSourceType || (DataSourceType = {}));
export var DateFilterType;
(function (DateFilterType) {
    DateFilterType["ExactDate"] = "EXACT_DATE";
    DateFilterType["ExactDateRange"] = "EXACT_DATE_RANGE";
    DateFilterType["ExactDateTime"] = "EXACT_DATE_TIME";
    DateFilterType["ExactTime"] = "EXACT_TIME";
    DateFilterType["LastNPeriod"] = "LAST_N_PERIOD";
    DateFilterType["LastPeriod"] = "LAST_PERIOD";
    DateFilterType["MonthOnly"] = "MONTH_ONLY";
    DateFilterType["MonthYear"] = "MONTH_YEAR";
    DateFilterType["NextNPeriod"] = "NEXT_N_PERIOD";
    DateFilterType["NextPeriod"] = "NEXT_PERIOD";
    DateFilterType["Now"] = "NOW";
    DateFilterType["NumDateFilters"] = "NUM_DATE_FILTERS";
    DateFilterType["NPeriodAgo"] = "N_PERIOD_AGO";
    DateFilterType["PeriodOnly"] = "PERIOD_ONLY";
    DateFilterType["PeriodToDate"] = "PERIOD_TO_DATE";
    DateFilterType["QuarterOnly"] = "QUARTER_ONLY";
    DateFilterType["QuarterYear"] = "QUARTER_YEAR";
    DateFilterType["ThisPeriod"] = "THIS_PERIOD";
    DateFilterType["Today"] = "TODAY";
    DateFilterType["Tomorrow"] = "TOMORROW";
    DateFilterType["WeekdayOnly"] = "WEEKDAY_ONLY";
    DateFilterType["YearOnly"] = "YEAR_ONLY";
    DateFilterType["Yesterday"] = "YESTERDAY";
})(DateFilterType || (DateFilterType = {}));
export var DatePeriod;
(function (DatePeriod) {
    DatePeriod["Day"] = "DAY";
    DatePeriod["Hour"] = "HOUR";
    DatePeriod["Minute"] = "MINUTE";
    DatePeriod["Month"] = "MONTH";
    DatePeriod["NumDatePeriods"] = "NUM_DATE_PERIODS";
    DatePeriod["Quarter"] = "QUARTER";
    DatePeriod["Second"] = "SECOND";
    DatePeriod["Week"] = "WEEK";
    DatePeriod["Year"] = "YEAR";
})(DatePeriod || (DatePeriod = {}));
export var DependencyListObjectType;
(function (DependencyListObjectType) {
    DependencyListObjectType["CustomChartConfigManifest"] = "CUSTOM_CHART_CONFIG_MANIFEST";
    DependencyListObjectType["DataSource"] = "DATA_SOURCE";
    DependencyListObjectType["File"] = "FILE";
    DependencyListObjectType["LogicalColumn"] = "LOGICAL_COLUMN";
    DependencyListObjectType["LogicalRelationship"] = "LOGICAL_RELATIONSHIP";
    DependencyListObjectType["LogicalTable"] = "LOGICAL_TABLE";
    DependencyListObjectType["PinboardAnswerBook"] = "PINBOARD_ANSWER_BOOK";
    DependencyListObjectType["PinboardAnswerSheet"] = "PINBOARD_ANSWER_SHEET";
    DependencyListObjectType["QuestionAnswerBook"] = "QUESTION_ANSWER_BOOK";
    DependencyListObjectType["QuestionAnswerSheet"] = "QUESTION_ANSWER_SHEET";
    DependencyListObjectType["RTemplate"] = "R_TEMPLATE";
    DependencyListObjectType["Tag"] = "TAG";
    DependencyListObjectType["User"] = "USER";
    DependencyListObjectType["UserGroup"] = "USER_GROUP";
})(DependencyListObjectType || (DependencyListObjectType = {}));
export var DependentObjectVersion;
(function (DependentObjectVersion) {
    DependentObjectVersion["V1"] = "V1";
    DependentObjectVersion["V2"] = "V2";
})(DependentObjectVersion || (DependentObjectVersion = {}));
export var DestinationOperationTypes;
(function (DestinationOperationTypes) {
    DestinationOperationTypes["Archive"] = "ARCHIVE";
    DestinationOperationTypes["Create"] = "CREATE";
    DestinationOperationTypes["Delete"] = "DELETE";
    DestinationOperationTypes["Insert"] = "INSERT";
    DestinationOperationTypes["Update"] = "UPDATE";
    DestinationOperationTypes["Upsert"] = "UPSERT";
})(DestinationOperationTypes || (DestinationOperationTypes = {}));
export var DestinationTypes;
(function (DestinationTypes) {
    DestinationTypes["Bigquery"] = "BIGQUERY";
    DestinationTypes["Gainsight"] = "GAINSIGHT";
    DestinationTypes["Googlesheets"] = "GOOGLESHEETS";
    DestinationTypes["Hubspot"] = "HUBSPOT";
    DestinationTypes["Mailchimp"] = "MAILCHIMP";
    DestinationTypes["Msexcel"] = "MSEXCEL";
    DestinationTypes["Msteams"] = "MSTEAMS";
    DestinationTypes["Redshift"] = "REDSHIFT";
    DestinationTypes["Salesforce"] = "SALESFORCE";
    DestinationTypes["Servicenow"] = "SERVICENOW";
    DestinationTypes["Slack"] = "SLACK";
    DestinationTypes["Snowflake"] = "SNOWFLAKE";
    DestinationTypes["Webex"] = "WEBEX";
    DestinationTypes["Zendesk"] = "ZENDESK";
    DestinationTypes["Zoho"] = "ZOHO";
})(DestinationTypes || (DestinationTypes = {}));
export var DisallowedAlertTypeErrorCode;
(function (DisallowedAlertTypeErrorCode) {
    DisallowedAlertTypeErrorCode["AlertAcrossAttributesFlagDisabled"] = "ALERT_ACROSS_ATTRIBUTES_FLAG_DISABLED";
    DisallowedAlertTypeErrorCode["AnomalyDisabledAtChartLevel"] = "ANOMALY_DISABLED_AT_CHART_LEVEL";
    DisallowedAlertTypeErrorCode["AnomalyDisabledAtUserProfile"] = "ANOMALY_DISABLED_AT_USER_PROFILE";
    DisallowedAlertTypeErrorCode["AnomalyDisabledChartNonTimeSeries"] = "ANOMALY_DISABLED_CHART_NON_TIME_SERIES";
    DisallowedAlertTypeErrorCode["AnomalyDisabledFalconSource"] = "ANOMALY_DISABLED_FALCON_SOURCE";
    DisallowedAlertTypeErrorCode["AnomalyFlagDisabled"] = "ANOMALY_FLAG_DISABLED";
    DisallowedAlertTypeErrorCode["GrowthKeywordNotSupported"] = "GROWTH_KEYWORD_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["GrowthOfKeywordNotSupported"] = "GROWTH_OF_KEYWORD_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["HourlyKpiNotSupported"] = "HOURLY_KPI_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["OfKeywordNotSupported"] = "OF_KEYWORD_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["PercentageOfKeywordNotSupported"] = "PERCENTAGE_OF_KEYWORD_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["UnexpectedError"] = "UNEXPECTED_ERROR";
    DisallowedAlertTypeErrorCode["UnsupportedFormula"] = "UNSUPPORTED_FORMULA";
    DisallowedAlertTypeErrorCode["VersusKeywordNotSupported"] = "VERSUS_KEYWORD_NOT_SUPPORTED";
})(DisallowedAlertTypeErrorCode || (DisallowedAlertTypeErrorCode = {}));
export var DisplayMode;
(function (DisplayMode) {
    DisplayMode["ChartMode"] = "CHART_MODE";
    DisplayMode["HeadlineMode"] = "HEADLINE_MODE";
    DisplayMode["RAnalysisMode"] = "R_ANALYSIS_MODE";
    DisplayMode["TableMode"] = "TABLE_MODE";
    DisplayMode["Undefined"] = "UNDEFINED";
})(DisplayMode || (DisplayMode = {}));
export var DynamicDateParamType;
(function (DynamicDateParamType) {
    DynamicDateParamType["EndOfLastNPeriod"] = "END_OF_LAST_N_PERIOD";
    DynamicDateParamType["EndOfNextNPeriod"] = "END_OF_NEXT_N_PERIOD";
    DynamicDateParamType["EndOfThisPeriod"] = "END_OF_THIS_PERIOD";
    DynamicDateParamType["FromTodayStartOfLastNPeriod"] = "FROM_TODAY_START_OF_LAST_N_PERIOD";
    DynamicDateParamType["FromTodayStartOfNextNPeriod"] = "FROM_TODAY_START_OF_NEXT_N_PERIOD";
    DynamicDateParamType["StartOfLastNPeriod"] = "START_OF_LAST_N_PERIOD";
    DynamicDateParamType["StartOfNextNPeriod"] = "START_OF_NEXT_N_PERIOD";
    DynamicDateParamType["StartOfThisPeriod"] = "START_OF_THIS_PERIOD";
    DynamicDateParamType["Today"] = "TODAY";
    DynamicDateParamType["Tomorrow"] = "TOMORROW";
    DynamicDateParamType["Yesterday"] = "YESTERDAY";
})(DynamicDateParamType || (DynamicDateParamType = {}));
export var EDocFormatType;
(function (EDocFormatType) {
    EDocFormatType["Json"] = "JSON";
    EDocFormatType["Proto"] = "PROTO";
    EDocFormatType["Yaml"] = "YAML";
})(EDocFormatType || (EDocFormatType = {}));
export var EDocGenerationType;
(function (EDocGenerationType) {
    EDocGenerationType["Autogenerated"] = "AUTOGENERATED";
    EDocGenerationType["Default"] = "DEFAULT";
})(EDocGenerationType || (EDocGenerationType = {}));
export var EditType;
(function (EditType) {
    EditType["Editable"] = "EDITABLE";
    EditType["Hidden"] = "HIDDEN";
    EditType["MultiSelection"] = "MULTI_SELECTION";
    EditType["NonEditable"] = "NON_EDITABLE";
    EditType["Text"] = "TEXT";
})(EditType || (EditType = {}));
export var EmptyAnswerStateEnum;
(function (EmptyAnswerStateEnum) {
    EmptyAnswerStateEnum["AutogenAnswer"] = "AUTOGEN_ANSWER";
    EmptyAnswerStateEnum["Default"] = "DEFAULT";
    EmptyAnswerStateEnum["StartAaq"] = "START_AAQ";
    EmptyAnswerStateEnum["StartSearchAssist"] = "START_SEARCH_ASSIST";
})(EmptyAnswerStateEnum || (EmptyAnswerStateEnum = {}));
export var EventSchemaType;
(function (EventSchemaType) {
    EventSchemaType["Monitor"] = "MONITOR";
})(EventSchemaType || (EventSchemaType = {}));
export var EventTypeToValidate;
(function (EventTypeToValidate) {
    EventTypeToValidate["LiveboardSchedule"] = "LIVEBOARD_SCHEDULE";
})(EventTypeToValidate || (EventTypeToValidate = {}));
export var ExplorationType;
(function (ExplorationType) {
    ExplorationType["Add"] = "ADD";
    ExplorationType["Compare"] = "COMPARE";
    ExplorationType["Filter"] = "FILTER";
    ExplorationType["Replace"] = "REPLACE";
})(ExplorationType || (ExplorationType = {}));
export var ExportRequestVersion;
(function (ExportRequestVersion) {
    ExportRequestVersion["V1"] = "V1";
    ExportRequestVersion["V2"] = "V2";
})(ExportRequestVersion || (ExportRequestVersion = {}));
export var FalconDataType;
(function (FalconDataType) {
    FalconDataType["Bool"] = "BOOL";
    FalconDataType["ByteArray"] = "BYTE_ARRAY";
    FalconDataType["Char"] = "CHAR";
    FalconDataType["Date"] = "DATE";
    FalconDataType["DateTime"] = "DATE_TIME";
    FalconDataType["Double"] = "DOUBLE";
    FalconDataType["Float"] = "FLOAT";
    FalconDataType["Int32"] = "INT32";
    FalconDataType["Int64"] = "INT64";
    FalconDataType["List"] = "LIST";
    FalconDataType["ListBool"] = "LIST_BOOL";
    FalconDataType["ListDate"] = "LIST_DATE";
    FalconDataType["ListDateTime"] = "LIST_DATE_TIME";
    FalconDataType["ListDouble"] = "LIST_DOUBLE";
    FalconDataType["ListInt"] = "LIST_INT";
    FalconDataType["ListString"] = "LIST_STRING";
    FalconDataType["ListTime"] = "LIST_TIME";
    FalconDataType["MaxType"] = "MAX_TYPE";
    FalconDataType["Time"] = "TIME";
    FalconDataType["Unknown"] = "UNKNOWN";
})(FalconDataType || (FalconDataType = {}));
export var FalconValueTypeEnum;
(function (FalconValueTypeEnum) {
    FalconValueTypeEnum["TypeBool"] = "TYPE_BOOL";
    FalconValueTypeEnum["TypeDouble"] = "TYPE_DOUBLE";
    FalconValueTypeEnum["TypeInt64"] = "TYPE_INT64";
    FalconValueTypeEnum["TypeNull"] = "TYPE_NULL";
    FalconValueTypeEnum["TypeString"] = "TYPE_STRING";
    FalconValueTypeEnum["TypeStringCase"] = "TYPE_STRING_CASE";
})(FalconValueTypeEnum || (FalconValueTypeEnum = {}));
export var FeedbackReason;
(function (FeedbackReason) {
    FeedbackReason["NotInterested"] = "NOT_INTERESTED";
    FeedbackReason["QuestionAnswerMismatch"] = "QUESTION_ANSWER_MISMATCH";
})(FeedbackReason || (FeedbackReason = {}));
export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["AllAnomaliesObvious"] = "ALL_ANOMALIES_OBVIOUS";
    FeedbackType["AllChangesExpected"] = "ALL_CHANGES_EXPECTED";
    FeedbackType["AnomalousPointUninteresting"] = "ANOMALOUS_POINT_UNINTERESTING";
    FeedbackType["AttributeColumnUninteresting"] = "ATTRIBUTE_COLUMN_UNINTERESTING";
    FeedbackType["AttributeFilterCombinationUninteresting"] = "ATTRIBUTE_FILTER_COMBINATION_UNINTERESTING";
    FeedbackType["BetterDateBucket"] = "BETTER_DATE_BUCKET";
    FeedbackType["CorrelationObvious"] = "CORRELATION_OBVIOUS";
    FeedbackType["DataSourceUninteresting"] = "DATA_SOURCE_UNINTERESTING";
    FeedbackType["DiffExpected"] = "DIFF_EXPECTED";
    FeedbackType["DiffValueUninteresting"] = "DIFF_VALUE_UNINTERESTING";
    FeedbackType["FilterColumnUninteresting"] = "FILTER_COLUMN_UNINTERESTING";
    FeedbackType["MeasureColumnUninteresting"] = "MEASURE_COLUMN_UNINTERESTING";
    FeedbackType["MeasureFilterCombinationObvious"] = "MEASURE_FILTER_COMBINATION_OBVIOUS";
    FeedbackType["TrendBetterDateAttribute"] = "TREND_BETTER_DATE_ATTRIBUTE";
    FeedbackType["TrendObvious"] = "TREND_OBVIOUS";
})(FeedbackType || (FeedbackType = {}));
export var FilterProperty;
(function (FilterProperty) {
    FilterProperty["IncludeNull"] = "INCLUDE_NULL";
    FilterProperty["IsDateFilter"] = "IS_DATE_FILTER";
    FilterProperty["IsFormula"] = "IS_FORMULA";
    FilterProperty["IsInSubquery"] = "IS_IN_SUBQUERY";
})(FilterProperty || (FilterProperty = {}));
export var FilterTypes;
(function (FilterTypes) {
    FilterTypes["BeginsWith"] = "BEGINS_WITH";
    FilterTypes["Bw"] = "BW";
    FilterTypes["BwInc"] = "BW_INC";
    FilterTypes["BwIncMax"] = "BW_INC_MAX";
    FilterTypes["BwIncMin"] = "BW_INC_MIN";
    FilterTypes["Contains"] = "CONTAINS";
    FilterTypes["EndsWith"] = "ENDS_WITH";
    FilterTypes["Eq"] = "EQ";
    FilterTypes["Ge"] = "GE";
    FilterTypes["Gt"] = "GT";
    FilterTypes["In"] = "IN";
    FilterTypes["Le"] = "LE";
    FilterTypes["Like"] = "LIKE";
    FilterTypes["Lt"] = "LT";
    FilterTypes["Ne"] = "NE";
    FilterTypes["NotIn"] = "NOT_IN";
})(FilterTypes || (FilterTypes = {}));
export var FilterValueDataType;
(function (FilterValueDataType) {
    FilterValueDataType["Bool"] = "BOOL";
    FilterValueDataType["Char"] = "CHAR";
    FilterValueDataType["Date"] = "DATE";
    FilterValueDataType["Double"] = "DOUBLE";
    FilterValueDataType["Int"] = "INT";
    FilterValueDataType["Unknown"] = "UNKNOWN";
})(FilterValueDataType || (FilterValueDataType = {}));
export var FilterValueType;
(function (FilterValueType) {
    FilterValueType["DateFilter"] = "DATE_FILTER";
    FilterValueType["String"] = "STRING";
})(FilterValueType || (FilterValueType = {}));
export var FormatData;
(function (FormatData) {
    FormatData["Compact"] = "COMPACT";
    FormatData["Full"] = "FULL";
})(FormatData || (FormatData = {}));
export var FormatType;
(function (FormatType) {
    FormatType["Json"] = "JSON";
    FormatType["Yaml"] = "YAML";
})(FormatType || (FormatType = {}));
export var FormulaChangeInd;
(function (FormulaChangeInd) {
    FormulaChangeInd["Existing"] = "existing";
})(FormulaChangeInd || (FormulaChangeInd = {}));
export var FormulaStatus;
(function (FormulaStatus) {
    FormulaStatus["Failed"] = "FAILED";
    FormulaStatus["Success"] = "SUCCESS";
})(FormulaStatus || (FormulaStatus = {}));
export var FrequencyGranularity;
(function (FrequencyGranularity) {
    FrequencyGranularity["Daily"] = "DAILY";
    FrequencyGranularity["EveryMinute"] = "EVERY_MINUTE";
    FrequencyGranularity["Hourly"] = "HOURLY";
    FrequencyGranularity["Monthly"] = "MONTHLY";
    FrequencyGranularity["Weekly"] = "WEEKLY";
})(FrequencyGranularity || (FrequencyGranularity = {}));
export var GeoConfigGeometryTypes;
(function (GeoConfigGeometryTypes) {
    GeoConfigGeometryTypes["Circle"] = "CIRCLE";
    GeoConfigGeometryTypes["GeometryCollection"] = "GEOMETRY_COLLECTION";
    GeoConfigGeometryTypes["LinearRing"] = "LINEAR_RING";
    GeoConfigGeometryTypes["LineString"] = "LINE_STRING";
    GeoConfigGeometryTypes["MultiLineString"] = "MULTI_LINE_STRING";
    GeoConfigGeometryTypes["MultiPoint"] = "MULTI_POINT";
    GeoConfigGeometryTypes["MultiPolygon"] = "MULTI_POLYGON";
    GeoConfigGeometryTypes["Point"] = "POINT";
    GeoConfigGeometryTypes["Polygon"] = "POLYGON";
})(GeoConfigGeometryTypes || (GeoConfigGeometryTypes = {}));
export var GeoConfigType;
(function (GeoConfigType) {
    GeoConfigType["AdminDiv_0"] = "ADMIN_DIV_0";
    GeoConfigType["AdminDiv_1"] = "ADMIN_DIV_1";
    GeoConfigType["AdminDiv_2"] = "ADMIN_DIV_2";
    GeoConfigType["CustomRegion"] = "CUSTOM_REGION";
    GeoConfigType["Latitude"] = "LATITUDE";
    GeoConfigType["Longitude"] = "LONGITUDE";
    GeoConfigType["ZipCode"] = "ZIP_CODE";
})(GeoConfigType || (GeoConfigType = {}));
export var GeoConfigTypes;
(function (GeoConfigTypes) {
    GeoConfigTypes["AdminDiv_0"] = "ADMIN_DIV_0";
    GeoConfigTypes["AdminDiv_1"] = "ADMIN_DIV_1";
    GeoConfigTypes["AdminDiv_2"] = "ADMIN_DIV_2";
    GeoConfigTypes["CustomRegion"] = "CUSTOM_REGION";
    GeoConfigTypes["Latitude"] = "LATITUDE";
    GeoConfigTypes["Longitude"] = "LONGITUDE";
    GeoConfigTypes["None"] = "NONE";
    GeoConfigTypes["ZipCode"] = "ZIP_CODE";
})(GeoConfigTypes || (GeoConfigTypes = {}));
export var GeometryType;
(function (GeometryType) {
    GeometryType["Circle"] = "CIRCLE";
    GeometryType["GeometryCollection"] = "GEOMETRY_COLLECTION";
    GeometryType["LinearRing"] = "LINEAR_RING";
    GeometryType["LineString"] = "LINE_STRING";
    GeometryType["MultiLineString"] = "MULTI_LINE_STRING";
    GeometryType["MultiPoint"] = "MULTI_POINT";
    GeometryType["MultiPolygon"] = "MULTI_POLYGON";
    GeometryType["Point"] = "POINT";
    GeometryType["Polygon"] = "POLYGON";
})(GeometryType || (GeometryType = {}));
export var GitConfigsMappingStatus;
(function (GitConfigsMappingStatus) {
    GitConfigsMappingStatus["Mapped"] = "MAPPED";
    GitConfigsMappingStatus["Unmapped"] = "UNMAPPED";
})(GitConfigsMappingStatus || (GitConfigsMappingStatus = {}));
export var GitConfigsSortFieldName;
(function (GitConfigsSortFieldName) {
    GitConfigsSortFieldName["Name"] = "NAME";
    GitConfigsSortFieldName["Status"] = "STATUS";
})(GitConfigsSortFieldName || (GitConfigsSortFieldName = {}));
export var GitConfigsSortOrder;
(function (GitConfigsSortOrder) {
    GitConfigsSortOrder["Asc"] = "ASC";
    GitConfigsSortOrder["Desc"] = "DESC";
})(GitConfigsSortOrder || (GitConfigsSortOrder = {}));
export var GroupBrandColor;
(function (GroupBrandColor) {
    GroupBrandColor["GbcA"] = "GBC_A";
    GroupBrandColor["GbcB"] = "GBC_B";
    GroupBrandColor["GbcC"] = "GBC_C";
    GroupBrandColor["GbcD"] = "GBC_D";
    GroupBrandColor["GbcE"] = "GBC_E";
    GroupBrandColor["GbcF"] = "GBC_F";
    GroupBrandColor["GbcG"] = "GBC_G";
    GroupBrandColor["GbcH"] = "GBC_H";
    GroupBrandColor["GbcUnknown"] = "GBC_UNKNOWN";
})(GroupBrandColor || (GroupBrandColor = {}));
export var GroupColorShade;
(function (GroupColorShade) {
    GroupColorShade["GcsA"] = "GCS_A";
    GroupColorShade["GcsUnknown"] = "GCS_UNKNOWN";
})(GroupColorShade || (GroupColorShade = {}));
export var GroupOperationType;
(function (GroupOperationType) {
    GroupOperationType["Add"] = "ADD";
    GroupOperationType["Overwrite"] = "OVERWRITE";
    GroupOperationType["Remove"] = "REMOVE";
})(GroupOperationType || (GroupOperationType = {}));
export var Groups__GroupType;
(function (Groups__GroupType) {
    Groups__GroupType["LdapGroup"] = "LDAP_GROUP";
    Groups__GroupType["LocalGroup"] = "LOCAL_GROUP";
    Groups__GroupType["TeamGroup"] = "TEAM_GROUP";
    Groups__GroupType["TenantGroup"] = "TENANT_GROUP";
})(Groups__GroupType || (Groups__GroupType = {}));
export var Groups__ParentType;
(function (Groups__ParentType) {
    Groups__ParentType["Group"] = "GROUP";
    Groups__ParentType["User"] = "USER";
})(Groups__ParentType || (Groups__ParentType = {}));
export var HandleMissingValues;
(function (HandleMissingValues) {
    HandleMissingValues["DontShow"] = "DONT_SHOW";
    HandleMissingValues["ShowAsZero"] = "SHOW_AS_ZERO";
    HandleMissingValues["ShowGap"] = "SHOW_GAP";
})(HandleMissingValues || (HandleMissingValues = {}));
export var HandleNullData;
(function (HandleNullData) {
    HandleNullData["NoDataFound"] = "NO_DATA_FOUND";
    HandleNullData["Zero"] = "ZERO";
})(HandleNullData || (HandleNullData = {}));
export var HeadlineVizPropVersion;
(function (HeadlineVizPropVersion) {
    HeadlineVizPropVersion["PreV1"] = "PRE_V1";
    HeadlineVizPropVersion["V1"] = "V1";
})(HeadlineVizPropVersion || (HeadlineVizPropVersion = {}));
export var HomepageModule;
(function (HomepageModule) {
    HomepageModule["Announcement"] = "ANNOUNCEMENT";
    HomepageModule["Favorite"] = "FAVORITE";
    HomepageModule["Learning"] = "LEARNING";
    HomepageModule["MyLibrary"] = "MY_LIBRARY";
    HomepageModule["Search"] = "SEARCH";
    HomepageModule["Trending"] = "TRENDING";
    HomepageModule["Watchlist"] = "WATCHLIST";
})(HomepageModule || (HomepageModule = {}));
export var HomepageModuleConfigLevel;
(function (HomepageModuleConfigLevel) {
    HomepageModuleConfigLevel["Cluster"] = "CLUSTER";
    HomepageModuleConfigLevel["Org"] = "ORG";
    HomepageModuleConfigLevel["User"] = "USER";
})(HomepageModuleConfigLevel || (HomepageModuleConfigLevel = {}));
export var ImportEPackAction;
(function (ImportEPackAction) {
    ImportEPackAction["Create"] = "CREATE";
    ImportEPackAction["Update"] = "UPDATE";
    ImportEPackAction["UpdateOrCreate"] = "UPDATE_OR_CREATE";
})(ImportEPackAction || (ImportEPackAction = {}));
export var ImportEPackPolicy;
(function (ImportEPackPolicy) {
    ImportEPackPolicy["AllOrNone"] = "ALL_OR_NONE";
    ImportEPackPolicy["Partial"] = "PARTIAL";
    ImportEPackPolicy["PartialObject"] = "PARTIAL_OBJECT";
    ImportEPackPolicy["ValidateOnly"] = "VALIDATE_ONLY";
})(ImportEPackPolicy || (ImportEPackPolicy = {}));
export var ImportPolicy;
(function (ImportPolicy) {
    ImportPolicy["AllOrNone"] = "ALL_OR_NONE";
    ImportPolicy["Partial"] = "PARTIAL";
    ImportPolicy["PartialObject"] = "PARTIAL_OBJECT";
    ImportPolicy["ValidateOnly"] = "VALIDATE_ONLY";
})(ImportPolicy || (ImportPolicy = {}));
export var IndexStatusType;
(function (IndexStatusType) {
    IndexStatusType["Indexed"] = "INDEXED";
    IndexStatusType["IndexingInProgress"] = "INDEXING_IN_PROGRESS";
    IndexStatusType["NotIndexed"] = "NOT_INDEXED";
})(IndexStatusType || (IndexStatusType = {}));
export var InferenceStatusEnum;
(function (InferenceStatusEnum) {
    InferenceStatusEnum["Done"] = "DONE";
    InferenceStatusEnum["Error"] = "ERROR";
    InferenceStatusEnum["Pending"] = "PENDING";
})(InferenceStatusEnum || (InferenceStatusEnum = {}));
export var IntegrationActionEnum;
(function (IntegrationActionEnum) {
    IntegrationActionEnum["Create"] = "CREATE";
    IntegrationActionEnum["Delete"] = "DELETE";
    IntegrationActionEnum["Edit"] = "EDIT";
})(IntegrationActionEnum || (IntegrationActionEnum = {}));
export var JobChannelStatus;
(function (JobChannelStatus) {
    JobChannelStatus["Failed"] = "FAILED";
    JobChannelStatus["Pending"] = "PENDING";
    JobChannelStatus["Retry"] = "RETRY";
    JobChannelStatus["Success"] = "SUCCESS";
})(JobChannelStatus || (JobChannelStatus = {}));
export var JobChannelType;
(function (JobChannelType) {
    JobChannelType["Webhook"] = "WEBHOOK";
})(JobChannelType || (JobChannelType = {}));
export var JobEventType;
(function (JobEventType) {
    JobEventType["LiveboardSchedule"] = "LIVEBOARD_SCHEDULE";
})(JobEventType || (JobEventType = {}));
export var JobRecipientType;
(function (JobRecipientType) {
    JobRecipientType["External"] = "EXTERNAL";
    JobRecipientType["User"] = "USER";
})(JobRecipientType || (JobRecipientType = {}));
export var JobStatusEnum;
(function (JobStatusEnum) {
    JobStatusEnum["Cleanup"] = "CLEANUP";
    JobStatusEnum["Default"] = "DEFAULT";
    JobStatusEnum["Expired"] = "EXPIRED";
    JobStatusEnum["Paused"] = "PAUSED";
    JobStatusEnum["Scheduled"] = "SCHEDULED";
    JobStatusEnum["Stopped"] = "STOPPED";
})(JobStatusEnum || (JobStatusEnum = {}));
export var JoinType;
(function (JoinType) {
    JoinType["Cross"] = "CROSS";
    JoinType["FullOuter"] = "FULL_OUTER";
    JoinType["Inner"] = "INNER";
    JoinType["LeftOuter"] = "LEFT_OUTER";
    JoinType["RightOuter"] = "RIGHT_OUTER";
})(JoinType || (JoinType = {}));
export var KpiHeroFontSizeType;
(function (KpiHeroFontSizeType) {
    KpiHeroFontSizeType["L"] = "L";
    KpiHeroFontSizeType["M"] = "M";
    KpiHeroFontSizeType["S"] = "S";
    KpiHeroFontSizeType["Xl"] = "XL";
    KpiHeroFontSizeType["Xs"] = "XS";
})(KpiHeroFontSizeType || (KpiHeroFontSizeType = {}));
export var LayoutType;
(function (LayoutType) {
    LayoutType["Pinboard"] = "PINBOARD";
    LayoutType["TablesOnly"] = "TABLES_ONLY";
    LayoutType["Visualization"] = "VISUALIZATION";
})(LayoutType || (LayoutType = {}));
export var LegendPositionOptions;
(function (LegendPositionOptions) {
    LegendPositionOptions["BottomLegend"] = "BOTTOM_LEGEND";
    LegendPositionOptions["LeftLegend"] = "LEFT_LEGEND";
    LegendPositionOptions["RightLegend"] = "RIGHT_LEGEND";
    LegendPositionOptions["TopLegend"] = "TOP_LEGEND";
})(LegendPositionOptions || (LegendPositionOptions = {}));
export var ListCategory;
(function (ListCategory) {
    ListCategory["All"] = "ALL";
    ListCategory["Favorite"] = "FAVORITE";
    ListCategory["My"] = "MY";
    ListCategory["NonFavorite"] = "NON_FAVORITE";
    ListCategory["Requested"] = "REQUESTED";
})(ListCategory || (ListCategory = {}));
export var ListType;
(function (ListType) {
    ListType["DataSource"] = "DATA_SOURCE";
    ListType["DbtConnection"] = "DBT_CONNECTION";
    ListType["File"] = "FILE";
    ListType["Folder"] = "FOLDER";
    ListType["LogicalColumn"] = "LOGICAL_COLUMN";
    ListType["LogicalRelationship"] = "LOGICAL_RELATIONSHIP";
    ListType["LogicalTable"] = "LOGICAL_TABLE";
    ListType["PinboardAnswerBook"] = "PINBOARD_ANSWER_BOOK";
    ListType["PinboardAnswerSheet"] = "PINBOARD_ANSWER_SHEET";
    ListType["QuestionAnswerBook"] = "QUESTION_ANSWER_BOOK";
    ListType["QuestionAnswerSheet"] = "QUESTION_ANSWER_SHEET";
    ListType["RTemplate"] = "R_TEMPLATE";
    ListType["SemanticIntegration"] = "SEMANTIC_INTEGRATION";
    ListType["Tag"] = "TAG";
    ListType["User"] = "USER";
    ListType["UserGroup"] = "USER_GROUP";
})(ListType || (ListType = {}));
export var LiveboardBorderType;
(function (LiveboardBorderType) {
    LiveboardBorderType["Curved"] = "CURVED";
    LiveboardBorderType["LiveboardBorderUnknown"] = "LIVEBOARD_BORDER_UNKNOWN";
    LiveboardBorderType["Sharp"] = "SHARP";
})(LiveboardBorderType || (LiveboardBorderType = {}));
export var LiveboardBrandColor;
(function (LiveboardBrandColor) {
    LiveboardBrandColor["LbcA"] = "LBC_A";
    LiveboardBrandColor["LbcB"] = "LBC_B";
    LiveboardBrandColor["LbcC"] = "LBC_C";
    LiveboardBrandColor["LbcD"] = "LBC_D";
    LiveboardBrandColor["LbcE"] = "LBC_E";
    LiveboardBrandColor["LbcF"] = "LBC_F";
    LiveboardBrandColor["LbcG"] = "LBC_G";
    LiveboardBrandColor["LbcH"] = "LBC_H";
    LiveboardBrandColor["LbcUnknown"] = "LBC_UNKNOWN";
})(LiveboardBrandColor || (LiveboardBrandColor = {}));
export var LiveboardDensityType;
(function (LiveboardDensityType) {
    LiveboardDensityType["LiveboardDensityUnknown"] = "LIVEBOARD_DENSITY_UNKNOWN";
    LiveboardDensityType["Loose"] = "LOOSE";
    LiveboardDensityType["Regular"] = "REGULAR";
    LiveboardDensityType["Tight"] = "TIGHT";
})(LiveboardDensityType || (LiveboardDensityType = {}));
export var LiveboardGutterType;
(function (LiveboardGutterType) {
    LiveboardGutterType["Guttered"] = "GUTTERED";
    LiveboardGutterType["Gutterless"] = "GUTTERLESS";
    LiveboardGutterType["LiveboardGutterUnknown"] = "LIVEBOARD_GUTTER_UNKNOWN";
})(LiveboardGutterType || (LiveboardGutterType = {}));
export var LogicalTableTypeEnum;
(function (LogicalTableTypeEnum) {
    LogicalTableTypeEnum["AggrWorksheet"] = "AGGR_WORKSHEET";
    LogicalTableTypeEnum["CalendarTable"] = "CALENDAR_TABLE";
    LogicalTableTypeEnum["DbView"] = "DB_VIEW";
    LogicalTableTypeEnum["InputTable"] = "INPUT_TABLE";
    LogicalTableTypeEnum["MaterializedView"] = "MATERIALIZED_VIEW";
    LogicalTableTypeEnum["OneToOneLogical"] = "ONE_TO_ONE_LOGICAL";
    LogicalTableTypeEnum["PrivateWorksheet"] = "PRIVATE_WORKSHEET";
    LogicalTableTypeEnum["SqlView"] = "SQL_VIEW";
    LogicalTableTypeEnum["UserDefined"] = "USER_DEFINED";
    LogicalTableTypeEnum["Worksheet"] = "WORKSHEET";
})(LogicalTableTypeEnum || (LogicalTableTypeEnum = {}));
export var LogsValues;
(function (LogsValues) {
    LogsValues["SecurityLogs"] = "security_logs";
})(LogsValues || (LogsValues = {}));
export var LumosChoiceOptionType;
(function (LumosChoiceOptionType) {
    LumosChoiceOptionType["ColumnSelect"] = "COLUMN_SELECT";
    LumosChoiceOptionType["FormulaSelect"] = "FORMULA_SELECT";
    LumosChoiceOptionType["JoinSelect"] = "JOIN_SELECT";
    LumosChoiceOptionType["TableSelect"] = "TABLE_SELECT";
})(LumosChoiceOptionType || (LumosChoiceOptionType = {}));
export var LumosChoiceType;
(function (LumosChoiceType) {
    LumosChoiceType["MultiSelect"] = "MULTI_SELECT";
    LumosChoiceType["SingleSelect"] = "SINGLE_SELECT";
})(LumosChoiceType || (LumosChoiceType = {}));
export var MessageCodeType;
(function (MessageCodeType) {
    MessageCodeType["ConfirmationOnInheritTableSetting"] = "CONFIRMATION_ON_INHERIT_TABLE_SETTING";
    MessageCodeType["ConfirmationOnSecureSuggestionSetting"] = "CONFIRMATION_ON_SECURE_SUGGESTION_SETTING";
})(MessageCodeType || (MessageCodeType = {}));
export var MetadataSortFieldName;
(function (MetadataSortFieldName) {
    MetadataSortFieldName["Author"] = "AUTHOR";
    MetadataSortFieldName["Created"] = "CREATED";
    MetadataSortFieldName["DisplayName"] = "DISPLAY_NAME";
    MetadataSortFieldName["Modified"] = "MODIFIED";
    MetadataSortFieldName["Name"] = "NAME";
})(MetadataSortFieldName || (MetadataSortFieldName = {}));
export var MetadataSortOrder;
(function (MetadataSortOrder) {
    MetadataSortOrder["Asc"] = "ASC";
    MetadataSortOrder["Desc"] = "DESC";
})(MetadataSortOrder || (MetadataSortOrder = {}));
export var MetadataType;
(function (MetadataType) {
    MetadataType["AggrWorksheet"] = "AGGR_WORKSHEET";
    MetadataType["Answer"] = "ANSWER";
    MetadataType["Connection"] = "CONNECTION";
    MetadataType["DataSource"] = "DATA_SOURCE";
    MetadataType["DbView"] = "DB_VIEW";
    MetadataType["Filter"] = "FILTER";
    MetadataType["Liveboard"] = "LIVEBOARD";
    MetadataType["LogicalColumn"] = "LOGICAL_COLUMN";
    MetadataType["LogicalRelationship"] = "LOGICAL_RELATIONSHIP";
    MetadataType["LogicalTable"] = "LOGICAL_TABLE";
    MetadataType["OneToOneLogical"] = "ONE_TO_ONE_LOGICAL";
    MetadataType["PersonalisedView"] = "PERSONALISED_VIEW";
    MetadataType["PinboardAnswerBook"] = "PINBOARD_ANSWER_BOOK";
    MetadataType["PrivateWorksheet"] = "PRIVATE_WORKSHEET";
    MetadataType["QuestionAnswerBook"] = "QUESTION_ANSWER_BOOK";
    MetadataType["RelatedLink"] = "RELATED_LINK";
    MetadataType["ReportBook"] = "REPORT_BOOK";
    MetadataType["RowSecurity"] = "ROW_SECURITY";
    MetadataType["RTemplate"] = "R_TEMPLATE";
    MetadataType["TableFilter"] = "TABLE_FILTER";
    MetadataType["Tag"] = "TAG";
    MetadataType["User"] = "USER";
    MetadataType["UserData"] = "USER_DATA";
    MetadataType["UserDefined"] = "USER_DEFINED";
    MetadataType["UserGroup"] = "USER_GROUP";
    MetadataType["UserQuestion"] = "USER_QUESTION";
    MetadataType["UserRole"] = "USER_ROLE";
    MetadataType["Visualization"] = "VISUALIZATION";
    MetadataType["Worksheet"] = "WORKSHEET";
})(MetadataType || (MetadataType = {}));
export var Method;
(function (Method) {
    Method["Get"] = "GET";
    Method["Post"] = "POST";
})(Method || (Method = {}));
export var MonitorAlertType;
(function (MonitorAlertType) {
    MonitorAlertType["AnomalyBasedAlerts"] = "ANOMALY_BASED_ALERTS";
    MonitorAlertType["ScheduleBasedAlerts"] = "SCHEDULE_BASED_ALERTS";
    MonitorAlertType["ScheduleByAttributeBasedAlerts"] = "SCHEDULE_BY_ATTRIBUTE_BASED_ALERTS";
    MonitorAlertType["ThresholdBasedAlerts"] = "THRESHOLD_BASED_ALERTS";
    MonitorAlertType["ThresholdByAttributeBasedAlerts"] = "THRESHOLD_BY_ATTRIBUTE_BASED_ALERTS";
    MonitorAlertType["Unspecified"] = "UNSPECIFIED";
})(MonitorAlertType || (MonitorAlertType = {}));
export var MonitorRuleApiCode;
(function (MonitorRuleApiCode) {
    MonitorRuleApiCode["StatusCodeAlertAcrossAttributesDisabled"] = "STATUS_CODE_ALERT_ACROSS_ATTRIBUTES_DISABLED";
    MonitorRuleApiCode["StatusCodeAnomalyAlertDisabled"] = "STATUS_CODE_ANOMALY_ALERT_DISABLED";
    MonitorRuleApiCode["StatusCodeAutoCompleteFailure"] = "STATUS_CODE_AUTO_COMPLETE_FAILURE";
    MonitorRuleApiCode["StatusCodeCreatorNotSubscriber"] = "STATUS_CODE_CREATOR_NOT_SUBSCRIBER";
    MonitorRuleApiCode["StatusCodeDataFetchError"] = "STATUS_CODE_DATA_FETCH_ERROR";
    MonitorRuleApiCode["StatusCodeError"] = "STATUS_CODE_ERROR";
    MonitorRuleApiCode["StatusCodeHourlyKpiNotSupported"] = "STATUS_CODE_HOURLY_KPI_NOT_SUPPORTED";
    MonitorRuleApiCode["StatusCodeHtmlInAlertName"] = "STATUS_CODE_HTML_IN_ALERT_NAME";
    MonitorRuleApiCode["StatusCodeInsufficientDataError"] = "STATUS_CODE_INSUFFICIENT_DATA_ERROR";
    MonitorRuleApiCode["StatusCodeInvalidAttributeValueConfiguration"] = "STATUS_CODE_INVALID_ATTRIBUTE_VALUE_CONFIGURATION";
    MonitorRuleApiCode["StatusCodeInvalidRequest"] = "STATUS_CODE_INVALID_REQUEST";
    MonitorRuleApiCode["StatusCodeKeywordNotSupported"] = "STATUS_CODE_KEYWORD_NOT_SUPPORTED";
    MonitorRuleApiCode["StatusCodeMetricNotMonitorable"] = "STATUS_CODE_METRIC_NOT_MONITORABLE";
    MonitorRuleApiCode["StatusCodeMonitorableNotFound"] = "STATUS_CODE_MONITORABLE_NOT_FOUND";
    MonitorRuleApiCode["StatusCodeOk"] = "STATUS_CODE_OK";
    MonitorRuleApiCode["StatusCodePercentageChangeOnNonTimeseriesKpi"] = "STATUS_CODE_PERCENTAGE_CHANGE_ON_NON_TIMESERIES_KPI";
    MonitorRuleApiCode["StatusCodePermissionsNotFound"] = "STATUS_CODE_PERMISSIONS_NOT_FOUND";
    MonitorRuleApiCode["StatusCodeRuleNotFound"] = "STATUS_CODE_RULE_NOT_FOUND";
    MonitorRuleApiCode["StatusCodeTableIndependentAttributesNotSupported"] = "STATUS_CODE_TABLE_INDEPENDENT_ATTRIBUTES_NOT_SUPPORTED";
    MonitorRuleApiCode["StatusCodeTitleNotPlaintext"] = "STATUS_CODE_TITLE_NOT_PLAINTEXT";
    MonitorRuleApiCode["StatusCodeUnauthorized"] = "STATUS_CODE_UNAUTHORIZED";
    MonitorRuleApiCode["StatusCodeUnspecified"] = "STATUS_CODE_UNSPECIFIED";
    MonitorRuleApiCode["StatusCodeUnsupportedFormula"] = "STATUS_CODE_UNSUPPORTED_FORMULA";
    MonitorRuleApiCode["StatusCodeUnsupportedTimeBucket"] = "STATUS_CODE_UNSUPPORTED_TIME_BUCKET";
    MonitorRuleApiCode["StatusCodeUserAlreadySubscribed"] = "STATUS_CODE_USER_ALREADY_SUBSCRIBED";
    MonitorRuleApiCode["StatusCodeUserNotFound"] = "STATUS_CODE_USER_NOT_FOUND";
    MonitorRuleApiCode["StatusCodeUserNotSubscribed"] = "STATUS_CODE_USER_NOT_SUBSCRIBED";
})(MonitorRuleApiCode || (MonitorRuleApiCode = {}));
export var Month;
(function (Month) {
    Month["April"] = "APRIL";
    Month["August"] = "AUGUST";
    Month["December"] = "DECEMBER";
    Month["February"] = "FEBRUARY";
    Month["January"] = "JANUARY";
    Month["July"] = "JULY";
    Month["June"] = "JUNE";
    Month["March"] = "MARCH";
    Month["May"] = "MAY";
    Month["November"] = "NOVEMBER";
    Month["NumMonths"] = "NUM_MONTHS";
    Month["October"] = "OCTOBER";
    Month["September"] = "SEPTEMBER";
})(Month || (Month = {}));
export var NasStatus;
(function (NasStatus) {
    NasStatus["Configured"] = "CONFIGURED";
    NasStatus["Empty"] = "EMPTY";
    NasStatus["NotConfigured"] = "NOT_CONFIGURED";
})(NasStatus || (NasStatus = {}));
export var NegativeValueFormat;
(function (NegativeValueFormat) {
    NegativeValueFormat["BracesNodash"] = "BRACES_NODASH";
    NegativeValueFormat["PrefixDash"] = "PREFIX_DASH";
    NegativeValueFormat["SuffixDash"] = "SUFFIX_DASH";
})(NegativeValueFormat || (NegativeValueFormat = {}));
export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["Email"] = "EMAIL";
    NotificationChannel["Webhook"] = "WEBHOOK";
})(NotificationChannel || (NotificationChannel = {}));
export var ObjectDependency;
(function (ObjectDependency) {
    ObjectDependency["Column"] = "COLUMN";
    ObjectDependency["Dataobject"] = "DATAOBJECT";
    ObjectDependency["Join"] = "JOIN";
    ObjectDependency["Liveboard"] = "LIVEBOARD";
})(ObjectDependency || (ObjectDependency = {}));
export var ObjectType;
(function (ObjectType) {
    ObjectType["Answer"] = "ANSWER";
    ObjectType["Column"] = "COLUMN";
    ObjectType["Connection"] = "CONNECTION";
    ObjectType["Filter"] = "FILTER";
    ObjectType["Formula"] = "FORMULA";
    ObjectType["Insight"] = "INSIGHT";
    ObjectType["Pinboard"] = "PINBOARD";
    ObjectType["Relationship"] = "RELATIONSHIP";
    ObjectType["Table"] = "TABLE";
})(ObjectType || (ObjectType = {}));
export var Operators;
(function (Operators) {
    Operators["Contains"] = "CONTAINS";
    Operators["DoesNotContain"] = "DOES_NOT_CONTAIN";
    Operators["EndsWith"] = "ENDS_WITH";
    Operators["EqualTo"] = "EQUAL_TO";
    Operators["GreaterThan"] = "GREATER_THAN";
    Operators["GreaterThanEqualTo"] = "GREATER_THAN_EQUAL_TO";
    Operators["Is"] = "IS";
    Operators["IsBetween"] = "IS_BETWEEN";
    Operators["IsEmpty"] = "IS_EMPTY";
    Operators["IsNot"] = "IS_NOT";
    Operators["IsNotEmpty"] = "IS_NOT_EMPTY";
    Operators["IsNotNull"] = "IS_NOT_NULL";
    Operators["IsNull"] = "IS_NULL";
    Operators["LessThan"] = "LESS_THAN";
    Operators["LessThanEqualTo"] = "LESS_THAN_EQUAL_TO";
    Operators["NotEqualTo"] = "NOT_EQUAL_TO";
    Operators["StartsWith"] = "STARTS_WITH";
})(Operators || (Operators = {}));
export var OrgDetailType;
(function (OrgDetailType) {
    OrgDetailType["All"] = "ALL";
    OrgDetailType["FeatureFlag"] = "FEATURE_FLAG";
    OrgDetailType["User"] = "USER";
    OrgDetailType["UserGroup"] = "USER_GROUP";
})(OrgDetailType || (OrgDetailType = {}));
export var Orientation;
(function (Orientation) {
    Orientation["Landscape"] = "LANDSCAPE";
    Orientation["Portrait"] = "PORTRAIT";
})(Orientation || (Orientation = {}));
export var OutputType;
(function (OutputType) {
    OutputType["Csv"] = "CSV";
    OutputType["None"] = "NONE";
    OutputType["Pdf"] = "PDF";
    OutputType["Png"] = "PNG";
    OutputType["Xls"] = "XLS";
    OutputType["Xlsx"] = "XLSX";
})(OutputType || (OutputType = {}));
export var PageSize;
(function (PageSize) {
    PageSize["A4"] = "A4";
    PageSize["TabBased"] = "TAB_BASED";
})(PageSize || (PageSize = {}));
export var ParameterDatePeriod;
(function (ParameterDatePeriod) {
    ParameterDatePeriod["Day"] = "DAY";
    ParameterDatePeriod["Month"] = "MONTH";
    ParameterDatePeriod["Quarter"] = "QUARTER";
    ParameterDatePeriod["Week"] = "WEEK";
    ParameterDatePeriod["Year"] = "YEAR";
})(ParameterDatePeriod || (ParameterDatePeriod = {}));
export var ParameterOwnerType;
(function (ParameterOwnerType) {
    ParameterOwnerType["Answer"] = "ANSWER";
    ParameterOwnerType["Worksheet"] = "WORKSHEET";
})(ParameterOwnerType || (ParameterOwnerType = {}));
export var ParameterValueType;
(function (ParameterValueType) {
    ParameterValueType["Any"] = "ANY";
    ParameterValueType["List"] = "LIST";
    ParameterValueType["Range"] = "RANGE";
})(ParameterValueType || (ParameterValueType = {}));
export var Partner;
(function (Partner) {
    Partner["Redshift"] = "REDSHIFT";
})(Partner || (Partner = {}));
export var PeriodicScheduleType;
(function (PeriodicScheduleType) {
    PeriodicScheduleType["Cron"] = "CRON";
    PeriodicScheduleType["Default"] = "DEFAULT";
})(PeriodicScheduleType || (PeriodicScheduleType = {}));
export var Periodicity;
(function (Periodicity) {
    Periodicity["Default"] = "DEFAULT";
    Periodicity["OneTime"] = "ONE_TIME";
    Periodicity["Periodic"] = "PERIODIC";
})(Periodicity || (Periodicity = {}));
export var PermissionLevel;
(function (PermissionLevel) {
    PermissionLevel["PermissionLevelCannotSubscribe"] = "PERMISSION_LEVEL_CANNOT_SUBSCRIBE";
    PermissionLevel["PermissionLevelCanSubscribe"] = "PERMISSION_LEVEL_CAN_SUBSCRIBE";
    PermissionLevel["PermissionLevelPermissionsNeeded"] = "PERMISSION_LEVEL_PERMISSIONS_NEEDED";
    PermissionLevel["PermissionLevelUnspecified"] = "PERMISSION_LEVEL_UNSPECIFIED";
})(PermissionLevel || (PermissionLevel = {}));
export var PhraseType;
(function (PhraseType) {
    PhraseType["AggregatedAttributeValuePhrase"] = "AGGREGATED_ATTRIBUTE_VALUE_PHRASE";
    PhraseType["AggregatedColumnPhrase"] = "AGGREGATED_COLUMN_PHRASE";
    PhraseType["Begin"] = "BEGIN";
    PhraseType["CalendarPhrase"] = "CALENDAR_PHRASE";
    PhraseType["DelimiterPhrase"] = "DELIMITER_PHRASE";
    PhraseType["End"] = "END";
    PhraseType["FilteredCountPhrase"] = "FILTERED_COUNT_PHRASE";
    PhraseType["FilterPhrase"] = "FILTER_PHRASE";
    PhraseType["FormulaPhrase"] = "FORMULA_PHRASE";
    PhraseType["ForEachPhrase"] = "FOR_EACH_PHRASE";
    PhraseType["GeofilterPhrase"] = "GEOFILTER_PHRASE";
    PhraseType["GroupByColumnPhrase"] = "GROUP_BY_COLUMN_PHRASE";
    PhraseType["GrowthPhrase"] = "GROWTH_PHRASE";
    PhraseType["HavingPhrase"] = "HAVING_PHRASE";
    PhraseType["InFilterPhrase"] = "IN_FILTER_PHRASE";
    PhraseType["InFilterSubqueryPhrase"] = "IN_FILTER_SUBQUERY_PHRASE";
    PhraseType["OfFilterPhrase"] = "OF_FILTER_PHRASE";
    PhraseType["OfPhrase"] = "OF_PHRASE";
    PhraseType["OfSortByPhrase"] = "OF_SORT_BY_PHRASE";
    PhraseType["PercentageOfFilterPhrase"] = "PERCENTAGE_OF_FILTER_PHRASE";
    PhraseType["PercentageOfPhrase"] = "PERCENTAGE_OF_PHRASE";
    PhraseType["PercentageOfSortByPhrase"] = "PERCENTAGE_OF_SORT_BY_PHRASE";
    PhraseType["PivotPhrase"] = "PIVOT_PHRASE";
    PhraseType["ShowColumnPhrase"] = "SHOW_COLUMN_PHRASE";
    PhraseType["SkipTokenPhrase"] = "SKIP_TOKEN_PHRASE";
    PhraseType["SortByPhrase"] = "SORT_BY_PHRASE";
    PhraseType["StopWordPhrase"] = "STOP_WORD_PHRASE";
    PhraseType["TopBottomFilterPhrase"] = "TOP_BOTTOM_FILTER_PHRASE";
    PhraseType["TopBottomPhrase"] = "TOP_BOTTOM_PHRASE";
    PhraseType["UndefinedPhrase"] = "UNDEFINED_PHRASE";
    PhraseType["VersusPhrase"] = "VERSUS_PHRASE";
    PhraseType["VersusSubqueryPhrase"] = "VERSUS_SUBQUERY_PHRASE";
})(PhraseType || (PhraseType = {}));
export var PinboardContainerType;
(function (PinboardContainerType) {
    PinboardContainerType["AiTile"] = "AI_TILE";
    PinboardContainerType["ClusterViz"] = "CLUSTER_VIZ";
    PinboardContainerType["GenericViz"] = "GENERIC_VIZ";
    PinboardContainerType["Group"] = "GROUP";
    PinboardContainerType["NoteTile"] = "NOTE_TILE";
    PinboardContainerType["PinnedAnswer"] = "PINNED_ANSWER";
    PinboardContainerType["PinnedInsight"] = "PINNED_INSIGHT";
})(PinboardContainerType || (PinboardContainerType = {}));
export var PinboardContextType;
(function (PinboardContextType) {
    PinboardContextType["AdminPinboard"] = "ADMIN_PINBOARD";
    PinboardContextType["DownloadPinboard"] = "DOWNLOAD_PINBOARD";
    PinboardContextType["EditPinboard"] = "EDIT_PINBOARD";
    PinboardContextType["EmbedPinboard"] = "EMBED_PINBOARD";
    PinboardContextType["HomePinboard"] = "HOME_PINBOARD";
    PinboardContextType["InsightPinboard"] = "INSIGHT_PINBOARD";
    PinboardContextType["KpiMonitor"] = "KPI_MONITOR";
    PinboardContextType["LearnPinboard"] = "LEARN_PINBOARD";
    PinboardContextType["SavedPinboard"] = "SAVED_PINBOARD";
    PinboardContextType["SchedulePinboard"] = "SCHEDULE_PINBOARD";
})(PinboardContextType || (PinboardContextType = {}));
export var PinboardModelVersion;
(function (PinboardModelVersion) {
    PinboardModelVersion["V1"] = "V1";
    PinboardModelVersion["V2"] = "V2";
})(PinboardModelVersion || (PinboardModelVersion = {}));
export var PolicyType;
(function (PolicyType) {
    PolicyType["NoPolicy"] = "NO_POLICY";
    PolicyType["Process"] = "PROCESS";
    PolicyType["Usergroups"] = "USERGROUPS";
})(PolicyType || (PolicyType = {}));
export var PrincipalGroupType;
(function (PrincipalGroupType) {
    PrincipalGroupType["LocalGroup"] = "LOCAL_GROUP";
    PrincipalGroupType["TenantGroup"] = "TENANT_GROUP";
})(PrincipalGroupType || (PrincipalGroupType = {}));
export var PrincipalType;
(function (PrincipalType) {
    PrincipalType["LdapUser"] = "LDAP_USER";
    PrincipalType["LocalUser"] = "LOCAL_USER";
    PrincipalType["OidcUser"] = "OIDC_USER";
    PrincipalType["SamlUser"] = "SAML_USER";
    PrincipalType["Unknown"] = "UNKNOWN";
    PrincipalType["User"] = "USER";
    PrincipalType["UserGroup"] = "USER_GROUP";
})(PrincipalType || (PrincipalType = {}));
export var PrincipalVisibilityType;
(function (PrincipalVisibilityType) {
    PrincipalVisibilityType["Default"] = "DEFAULT";
    PrincipalVisibilityType["NonSharable"] = "NON_SHARABLE";
    PrincipalVisibilityType["Sharable"] = "SHARABLE";
})(PrincipalVisibilityType || (PrincipalVisibilityType = {}));
export var Privilages;
(function (Privilages) {
    Privilages["A3Analysis"] = "A3ANALYSIS";
    Privilages["Administration"] = "ADMINISTRATION";
    Privilages["ApplicationAdministration"] = "APPLICATION_ADMINISTRATION";
    Privilages["Authoring"] = "AUTHORING";
    Privilages["BackupAdministration"] = "BACKUP_ADMINISTRATION";
    Privilages["Bypassrls"] = "BYPASSRLS";
    Privilages["CanConfigureConnections"] = "CAN_CONFIGURE_CONNECTIONS";
    Privilages["CanCreateOrEditConnections"] = "CAN_CREATE_OR_EDIT_CONNECTIONS";
    Privilages["CanManageWorksheetViewsTables"] = "CAN_MANAGE_WORKSHEET_VIEWS_TABLES";
    Privilages["Datadownloading"] = "DATADOWNLOADING";
    Privilages["Datamanagement"] = "DATAMANAGEMENT";
    Privilages["Developer"] = "DEVELOPER";
    Privilages["DisablePinboardCreation"] = "DISABLE_PINBOARD_CREATION";
    Privilages["Experimentalfeatureprivilege"] = "EXPERIMENTALFEATUREPRIVILEGE";
    Privilages["GroupAdministration"] = "GROUP_ADMINISTRATION";
    Privilages["Jobscheduling"] = "JOBSCHEDULING";
    Privilages["Ranalysis"] = "RANALYSIS";
    Privilages["Sharewithall"] = "SHAREWITHALL";
    Privilages["Systemmanagement"] = "SYSTEMMANAGEMENT";
    Privilages["SystemInfoAdministration"] = "SYSTEM_INFO_ADMINISTRATION";
    Privilages["Userdatauploading"] = "USERDATAUPLOADING";
    Privilages["UserAdministration"] = "USER_ADMINISTRATION";
})(Privilages || (Privilages = {}));
export var Privileges;
(function (Privileges) {
    Privileges["A3Analysis"] = "A3ANALYSIS";
    Privileges["Administration"] = "ADMINISTRATION";
    Privileges["AllowNonEmbedFullAppAccess"] = "ALLOW_NON_EMBED_FULL_APP_ACCESS";
    Privileges["Authoring"] = "AUTHORING";
    Privileges["Bypassrls"] = "BYPASSRLS";
    Privileges["CanCreateOrEditConnections"] = "CAN_CREATE_OR_EDIT_CONNECTIONS";
    Privileges["CanManageWorksheetViewsTables"] = "CAN_MANAGE_WORKSHEET_VIEWS_TABLES";
    Privileges["Datadownloading"] = "DATADOWNLOADING";
    Privileges["Datamanagement"] = "DATAMANAGEMENT";
    Privileges["Developer"] = "DEVELOPER";
    Privileges["Experimentalfeatureprivilege"] = "EXPERIMENTALFEATUREPRIVILEGE";
    Privileges["GroupAdministration"] = "GROUP_ADMINISTRATION";
    Privileges["Jobscheduling"] = "JOBSCHEDULING";
    Privileges["Ranalysis"] = "RANALYSIS";
    Privileges["Sharewithall"] = "SHAREWITHALL";
    Privileges["Syncmanagement"] = "SYNCMANAGEMENT";
    Privileges["Userdatauploading"] = "USERDATAUPLOADING";
    Privileges["Usermanagement"] = "USERMANAGEMENT";
    Privileges["UserAdministration"] = "USER_ADMINISTRATION";
})(Privileges || (Privileges = {}));
export var Processes;
(function (Processes) {
    Processes["RowCountStats"] = "ROW_COUNT_STATS";
    Processes["SageIndexing"] = "SAGE_INDEXING";
    Processes["SageSampling"] = "SAGE_SAMPLING";
})(Processes || (Processes = {}));
export var ProgressStatusCode;
(function (ProgressStatusCode) {
    ProgressStatusCode["Completed"] = "COMPLETED";
    ProgressStatusCode["Failed"] = "FAILED";
    ProgressStatusCode["InProgress"] = "IN_PROGRESS";
    ProgressStatusCode["InQueue"] = "IN_QUEUE";
})(ProgressStatusCode || (ProgressStatusCode = {}));
export var Quarter;
(function (Quarter) {
    Quarter["NumQuarters"] = "NUM_QUARTERS";
    Quarter["Q1"] = "Q1";
    Quarter["Q2"] = "Q2";
    Quarter["Q3"] = "Q3";
    Quarter["Q4"] = "Q4";
})(Quarter || (Quarter = {}));
export var QuerableDataSourceType;
(function (QuerableDataSourceType) {
    QuerableDataSourceType["Default"] = "DEFAULT";
    QuerableDataSourceType["FileCsv"] = "FILE_CSV";
    QuerableDataSourceType["Informatica"] = "INFORMATICA";
    QuerableDataSourceType["IpaasInformatica"] = "IPAAS_INFORMATICA";
    QuerableDataSourceType["RdbmsAmazonAthena"] = "RDBMS_AMAZON_ATHENA";
    QuerableDataSourceType["RdbmsAmazonAuroraMysql"] = "RDBMS_AMAZON_AURORA_MYSQL";
    QuerableDataSourceType["RdbmsAmazonAuroraPostgresql"] = "RDBMS_AMAZON_AURORA_POSTGRESQL";
    QuerableDataSourceType["RdbmsAmazonRdsMysql"] = "RDBMS_AMAZON_RDS_MYSQL";
    QuerableDataSourceType["RdbmsAmazonRdsPostgresql"] = "RDBMS_AMAZON_RDS_POSTGRESQL";
    QuerableDataSourceType["RdbmsAzureSqlDatawarehouse"] = "RDBMS_AZURE_SQL_DATAWAREHOUSE";
    QuerableDataSourceType["RdbmsClickhouse"] = "RDBMS_CLICKHOUSE";
    QuerableDataSourceType["RdbmsDatabricks"] = "RDBMS_DATABRICKS";
    QuerableDataSourceType["RdbmsDenodo"] = "RDBMS_DENODO";
    QuerableDataSourceType["RdbmsDremio"] = "RDBMS_DREMIO";
    QuerableDataSourceType["RdbmsDrSum"] = "RDBMS_DR_SUM";
    QuerableDataSourceType["RdbmsFalcon"] = "RDBMS_FALCON";
    QuerableDataSourceType["RdbmsFalconOnprem"] = "RDBMS_FALCON_ONPREM";
    QuerableDataSourceType["RdbmsGcpAlloydbPostgresql"] = "RDBMS_GCP_ALLOYDB_POSTGRESQL";
    QuerableDataSourceType["RdbmsGcpBigquery"] = "RDBMS_GCP_BIGQUERY";
    QuerableDataSourceType["RdbmsGcpMysql"] = "RDBMS_GCP_MYSQL";
    QuerableDataSourceType["RdbmsGcpPostgresql"] = "RDBMS_GCP_POSTGRESQL";
    QuerableDataSourceType["RdbmsGcpSqlserver"] = "RDBMS_GCP_SQLSERVER";
    QuerableDataSourceType["RdbmsGenericJdbc"] = "RDBMS_GENERIC_JDBC";
    QuerableDataSourceType["RdbmsGoogleSheets"] = "RDBMS_GOOGLE_SHEETS";
    QuerableDataSourceType["RdbmsIomete"] = "RDBMS_IOMETE";
    QuerableDataSourceType["RdbmsLooker"] = "RDBMS_LOOKER";
    QuerableDataSourceType["RdbmsLookerMl"] = "RDBMS_LOOKER_ML";
    QuerableDataSourceType["RdbmsMarketo"] = "RDBMS_MARKETO";
    QuerableDataSourceType["RdbmsMockDatabase"] = "RDBMS_MOCK_DATABASE";
    QuerableDataSourceType["RdbmsMode"] = "RDBMS_MODE";
    QuerableDataSourceType["RdbmsMysql"] = "RDBMS_MYSQL";
    QuerableDataSourceType["RdbmsOracle"] = "RDBMS_ORACLE";
    QuerableDataSourceType["RdbmsOracleAdw"] = "RDBMS_ORACLE_ADW";
    QuerableDataSourceType["RdbmsPostgres"] = "RDBMS_POSTGRES";
    QuerableDataSourceType["RdbmsPresto"] = "RDBMS_PRESTO";
    QuerableDataSourceType["RdbmsPrestoJdbc"] = "RDBMS_PRESTO_JDBC";
    QuerableDataSourceType["RdbmsRedshift"] = "RDBMS_REDSHIFT";
    QuerableDataSourceType["RdbmsSalesforce"] = "RDBMS_SALESFORCE";
    QuerableDataSourceType["RdbmsSapHana"] = "RDBMS_SAP_HANA";
    QuerableDataSourceType["RdbmsServiceNow"] = "RDBMS_SERVICE_NOW";
    QuerableDataSourceType["RdbmsSinglestore"] = "RDBMS_SINGLESTORE";
    QuerableDataSourceType["RdbmsSnowflake"] = "RDBMS_SNOWFLAKE";
    QuerableDataSourceType["RdbmsSqlserver"] = "RDBMS_SQLSERVER";
    QuerableDataSourceType["RdbmsTeradata"] = "RDBMS_TERADATA";
    QuerableDataSourceType["RdbmsTrino"] = "RDBMS_TRINO";
    QuerableDataSourceType["SaasSalesforce"] = "SAAS_SALESFORCE";
})(QuerableDataSourceType || (QuerableDataSourceType = {}));
export var QueryCompletionType;
(function (QueryCompletionType) {
    QueryCompletionType["NlCompletion"] = "NL_COMPLETION";
    QueryCompletionType["NlPrimingCompletion"] = "NL_PRIMING_COMPLETION";
    QueryCompletionType["PhraseHistoryOthers"] = "PHRASE_HISTORY_OTHERS";
    QueryCompletionType["PhraseHistorySelf"] = "PHRASE_HISTORY_SELF";
    QueryCompletionType["Rewrite"] = "REWRITE";
    QueryCompletionType["SearchHistoryOthers"] = "SEARCH_HISTORY_OTHERS";
    QueryCompletionType["SearchHistorySelf"] = "SEARCH_HISTORY_SELF";
    QueryCompletionType["Synonym"] = "SYNONYM";
    QueryCompletionType["Undefined"] = "UNDEFINED";
})(QueryCompletionType || (QueryCompletionType = {}));
export var QueryTemplateBoundStateType;
(function (QueryTemplateBoundStateType) {
    QueryTemplateBoundStateType["FilterColumn"] = "FILTER_COLUMN";
    QueryTemplateBoundStateType["FilterValue"] = "FILTER_VALUE";
})(QueryTemplateBoundStateType || (QueryTemplateBoundStateType = {}));
export var QueryTemplateType;
(function (QueryTemplateType) {
    QueryTemplateType["Attribute"] = "ATTRIBUTE";
    QueryTemplateType["AttributeColumn"] = "ATTRIBUTE_COLUMN";
    QueryTemplateType["ColumnOpFilter"] = "COLUMN_OP_FILTER";
    QueryTemplateType["CustomCalendar"] = "CUSTOM_CALENDAR";
    QueryTemplateType["ForEach"] = "FOR_EACH";
    QueryTemplateType["Geofilter"] = "GEOFILTER";
    QueryTemplateType["GrowthOf"] = "GROWTH_OF";
    QueryTemplateType["Having"] = "HAVING";
    QueryTemplateType["InFilter"] = "IN_FILTER";
    QueryTemplateType["Measure"] = "MEASURE";
    QueryTemplateType["MeasureColumn"] = "MEASURE_COLUMN";
    QueryTemplateType["NoSkill"] = "NO_SKILL";
    QueryTemplateType["SimpleOpAttributeFilter"] = "SIMPLE_OP_ATTRIBUTE_FILTER";
    QueryTemplateType["SimpleOpMeasureFilter"] = "SIMPLE_OP_MEASURE_FILTER";
    QueryTemplateType["SingleColumnVersus"] = "SINGLE_COLUMN_VERSUS";
    QueryTemplateType["SortBy"] = "SORT_BY";
    QueryTemplateType["TimeBucket"] = "TIME_BUCKET";
    QueryTemplateType["TimeFilters"] = "TIME_FILTERS";
    QueryTemplateType["TopBottom"] = "TOP_BOTTOM";
    QueryTemplateType["Undefined"] = "UNDEFINED";
    QueryTemplateType["Value1VsValue2"] = "VALUE1_VS_VALUE2";
})(QueryTemplateType || (QueryTemplateType = {}));
export var QueryTransformType;
(function (QueryTransformType) {
    QueryTransformType["AddAttribute"] = "ADD_ATTRIBUTE";
    QueryTransformType["AddAutoResolvedDateBucketsToTokens"] = "ADD_AUTO_RESOLVED_DATE_BUCKETS_TO_TOKENS";
    QueryTransformType["AddColumn"] = "ADD_COLUMN";
    QueryTransformType["AddEmptyGroupBy"] = "ADD_EMPTY_GROUP_BY";
    QueryTransformType["AddFilter"] = "ADD_FILTER";
    QueryTransformType["AddHavingFilter"] = "ADD_HAVING_FILTER";
    QueryTransformType["AddInFilter"] = "ADD_IN_FILTER";
    QueryTransformType["AddMeasure"] = "ADD_MEASURE";
    QueryTransformType["AddPredicateFilter"] = "ADD_PREDICATE_FILTER";
    QueryTransformType["AddSortColumn"] = "ADD_SORT_COLUMN";
    QueryTransformType["AddTimeBucketQualifier"] = "ADD_TIME_BUCKET_QUALIFIER";
    QueryTransformType["AddVersus"] = "ADD_VERSUS";
    QueryTransformType["ChangeAggregation"] = "CHANGE_AGGREGATION";
    QueryTransformType["ChangeTimeBucket"] = "CHANGE_TIME_BUCKET";
    QueryTransformType["DeprecatedAddFormula"] = "DEPRECATED_ADD_FORMULA";
    QueryTransformType["DeprecatedAddTimeBucket"] = "DEPRECATED_ADD_TIME_BUCKET";
    QueryTransformType["DeprecatedRemoveFormula"] = "DEPRECATED_REMOVE_FORMULA";
    QueryTransformType["DeprecatedRemoveTimeBucket"] = "DEPRECATED_REMOVE_TIME_BUCKET";
    QueryTransformType["DrillDown"] = "DRILL_DOWN";
    QueryTransformType["EditFilter"] = "EDIT_FILTER";
    QueryTransformType["NumTransforms"] = "NUM_TRANSFORMS";
    QueryTransformType["PopulatePeriodToDateFiltersInTokens"] = "POPULATE_PERIOD_TO_DATE_FILTERS_IN_TOKENS";
    QueryTransformType["RemoveAllDateRangeFiltersForColumn"] = "REMOVE_ALL_DATE_RANGE_FILTERS_FOR_COLUMN";
    QueryTransformType["RemoveAllFiltersForColumn"] = "REMOVE_ALL_FILTERS_FOR_COLUMN";
    QueryTransformType["RemoveAllHavingFilters"] = "REMOVE_ALL_HAVING_FILTERS";
    QueryTransformType["RemoveAllHavingFiltersByAggregate"] = "REMOVE_ALL_HAVING_FILTERS_BY_AGGREGATE";
    QueryTransformType["RemoveAllHavingFiltersByColumn"] = "REMOVE_ALL_HAVING_FILTERS_BY_COLUMN";
    QueryTransformType["RemoveAllPhrasesByColumn"] = "REMOVE_ALL_PHRASES_BY_COLUMN";
    QueryTransformType["RemoveAllSortPhrases"] = "REMOVE_ALL_SORT_PHRASES";
    QueryTransformType["RemoveColumn"] = "REMOVE_COLUMN";
    QueryTransformType["RemoveFilter"] = "REMOVE_FILTER";
    QueryTransformType["RemoveHavingFilter"] = "REMOVE_HAVING_FILTER";
    QueryTransformType["RemoveInFilter"] = "REMOVE_IN_FILTER";
    QueryTransformType["RemoveNonFilterPhrases"] = "REMOVE_NON_FILTER_PHRASES";
    QueryTransformType["RemovePredicateFilter"] = "REMOVE_PREDICATE_FILTER";
    QueryTransformType["RemoveTimeBucketQualifier"] = "REMOVE_TIME_BUCKET_QUALIFIER";
    QueryTransformType["RemoveVersus"] = "REMOVE_VERSUS";
})(QueryTransformType || (QueryTransformType = {}));
export var ROutputTypeEnum;
(function (ROutputTypeEnum) {
    ROutputTypeEnum["Csv"] = "CSV";
    ROutputTypeEnum["Png"] = "PNG";
})(ROutputTypeEnum || (ROutputTypeEnum = {}));
export var ReceiverType;
(function (ReceiverType) {
    ReceiverType["Email"] = "EMAIL";
    ReceiverType["Group"] = "GROUP";
    ReceiverType["User"] = "USER";
})(ReceiverType || (ReceiverType = {}));
export var RecognizedTokenType;
(function (RecognizedTokenType) {
    RecognizedTokenType["Any"] = "ANY";
    RecognizedTokenType["Attribute"] = "ATTRIBUTE";
    RecognizedTokenType["Bool"] = "BOOL";
    RecognizedTokenType["Calendar"] = "CALENDAR";
    RecognizedTokenType["Constant"] = "CONSTANT";
    RecognizedTokenType["Date"] = "DATE";
    RecognizedTokenType["DateBucket"] = "DATE_BUCKET";
    RecognizedTokenType["Delimiter"] = "DELIMITER";
    RecognizedTokenType["Double"] = "DOUBLE";
    RecognizedTokenType["EndFsm"] = "END_FSM";
    RecognizedTokenType["Formula"] = "FORMULA";
    RecognizedTokenType["FunctionName"] = "FUNCTION_NAME";
    RecognizedTokenType["IncludeFsm"] = "INCLUDE_FSM";
    RecognizedTokenType["Integer"] = "INTEGER";
    RecognizedTokenType["Keyword"] = "KEYWORD";
    RecognizedTokenType["MaxType"] = "MAX_TYPE";
    RecognizedTokenType["Measure"] = "MEASURE";
    RecognizedTokenType["NamedPhrase"] = "NAMED_PHRASE";
    RecognizedTokenType["Operator"] = "OPERATOR";
    RecognizedTokenType["Parameter"] = "PARAMETER";
    RecognizedTokenType["PositiveInt"] = "POSITIVE_INT";
    RecognizedTokenType["PrefixValue"] = "PREFIX_VALUE";
    RecognizedTokenType["SkipToken"] = "SKIP_TOKEN";
    RecognizedTokenType["StopWord"] = "STOP_WORD";
    RecognizedTokenType["String"] = "STRING";
    RecognizedTokenType["SubstringValue"] = "SUBSTRING_VALUE";
    RecognizedTokenType["SuffixValue"] = "SUFFIX_VALUE";
    RecognizedTokenType["TemplateArg"] = "TEMPLATE_ARG";
    RecognizedTokenType["Time"] = "TIME";
    RecognizedTokenType["Unrecognized"] = "UNRECOGNIZED";
    RecognizedTokenType["Value"] = "VALUE";
    RecognizedTokenType["Year"] = "YEAR";
})(RecognizedTokenType || (RecognizedTokenType = {}));
export var RedshiftConnectionStatus;
(function (RedshiftConnectionStatus) {
    RedshiftConnectionStatus["Active"] = "Active";
    RedshiftConnectionStatus["ConnectionFailure"] = "ConnectionFailure";
    RedshiftConnectionStatus["Inactive"] = "Inactive";
    RedshiftConnectionStatus["RuntimeFailure"] = "RuntimeFailure";
})(RedshiftConnectionStatus || (RedshiftConnectionStatus = {}));
export var ReplaceableColumnType;
(function (ReplaceableColumnType) {
    ReplaceableColumnType["Attribute"] = "ATTRIBUTE";
    ReplaceableColumnType["DateBucket"] = "DATE_BUCKET";
    ReplaceableColumnType["DateColumn"] = "DATE_COLUMN";
    ReplaceableColumnType["Measure"] = "MEASURE";
})(ReplaceableColumnType || (ReplaceableColumnType = {}));
export var ReportFormat;
(function (ReportFormat) {
    ReportFormat["Csv"] = "CSV";
    ReportFormat["Pdf"] = "PDF";
    ReportFormat["Png"] = "PNG";
    ReportFormat["Xlsx"] = "XLSX";
})(ReportFormat || (ReportFormat = {}));
export var RevertPolicy;
(function (RevertPolicy) {
    RevertPolicy["AllOrNone"] = "ALL_OR_NONE";
    RevertPolicy["Partial"] = "PARTIAL";
    RevertPolicy["PartialObject"] = "PARTIAL_OBJECT";
})(RevertPolicy || (RevertPolicy = {}));
export var SfdcOperationTypes;
(function (SfdcOperationTypes) {
    SfdcOperationTypes["Insert"] = "INSERT";
    SfdcOperationTypes["Upsert"] = "UPSERT";
})(SfdcOperationTypes || (SfdcOperationTypes = {}));
export var SageBooleanType;
(function (SageBooleanType) {
    SageBooleanType["And"] = "AND";
    SageBooleanType["Default"] = "DEFAULT";
    SageBooleanType["Or"] = "OR";
})(SageBooleanType || (SageBooleanType = {}));
export var SageColumnAggTypes;
(function (SageColumnAggTypes) {
    SageColumnAggTypes["AggregateDistinct"] = "AGGREGATE_DISTINCT";
    SageColumnAggTypes["Average"] = "AVERAGE";
    SageColumnAggTypes["Count"] = "COUNT";
    SageColumnAggTypes["Max"] = "MAX";
    SageColumnAggTypes["Median"] = "MEDIAN";
    SageColumnAggTypes["Min"] = "MIN";
    SageColumnAggTypes["None"] = "NONE";
    SageColumnAggTypes["Percentile"] = "PERCENTILE";
    SageColumnAggTypes["Rank"] = "RANK";
    SageColumnAggTypes["RankPercentile"] = "RANK_PERCENTILE";
    SageColumnAggTypes["StdDeviation"] = "STD_DEVIATION";
    SageColumnAggTypes["Sum"] = "SUM";
    SageColumnAggTypes["UniqueCount"] = "UNIQUE_COUNT";
    SageColumnAggTypes["Variance"] = "VARIANCE";
})(SageColumnAggTypes || (SageColumnAggTypes = {}));
export var SageColumnType;
(function (SageColumnType) {
    SageColumnType["Attribute"] = "ATTRIBUTE";
    SageColumnType["Measure"] = "MEASURE";
    SageColumnType["Unknown"] = "UNKNOWN";
})(SageColumnType || (SageColumnType = {}));
export var SageCompareType;
(function (SageCompareType) {
    SageCompareType["BeginsWith"] = "BEGINS_WITH";
    SageCompareType["Bw"] = "BW";
    SageCompareType["BwInc"] = "BW_INC";
    SageCompareType["BwIncMax"] = "BW_INC_MAX";
    SageCompareType["BwIncMin"] = "BW_INC_MIN";
    SageCompareType["Contains"] = "CONTAINS";
    SageCompareType["EndsWith"] = "ENDS_WITH";
    SageCompareType["Eq"] = "EQ";
    SageCompareType["Ge"] = "GE";
    SageCompareType["Gt"] = "GT";
    SageCompareType["In"] = "IN";
    SageCompareType["Le"] = "LE";
    SageCompareType["Like"] = "LIKE";
    SageCompareType["Lt"] = "LT";
    SageCompareType["Ne"] = "NE";
    SageCompareType["NotIn"] = "NOT_IN";
})(SageCompareType || (SageCompareType = {}));
export var SageErrorCodeType;
(function (SageErrorCodeType) {
    SageErrorCodeType["AmbiguousToken"] = "AMBIGUOUS_TOKEN";
    SageErrorCodeType["BadRecognizedTokens"] = "BAD_RECOGNIZED_TOKENS";
    SageErrorCodeType["BadTokenSequence"] = "BAD_TOKEN_SEQUENCE";
    SageErrorCodeType["Cancelled"] = "CANCELLED";
    SageErrorCodeType["Failure"] = "FAILURE";
    SageErrorCodeType["ForbiddenWord"] = "FORBIDDEN_WORD";
    SageErrorCodeType["InconsistentJoinPath"] = "INCONSISTENT_JOIN_PATH";
    SageErrorCodeType["IncrementalRequestNotApplicable"] = "INCREMENTAL_REQUEST_NOT_APPLICABLE";
    SageErrorCodeType["InvalidColumn"] = "INVALID_COLUMN";
    SageErrorCodeType["InvalidJoinPath"] = "INVALID_JOIN_PATH";
    SageErrorCodeType["InvalidRequest"] = "INVALID_REQUEST";
    SageErrorCodeType["InvalidTable"] = "INVALID_TABLE";
    SageErrorCodeType["InvalidTransform"] = "INVALID_TRANSFORM";
    SageErrorCodeType["JoinPathAmbiguity"] = "JOIN_PATH_AMBIGUITY";
    SageErrorCodeType["LessonPlanUpgraded"] = "LESSON_PLAN_UPGRADED";
    SageErrorCodeType["LessonPlanUpgradeFailed"] = "LESSON_PLAN_UPGRADE_FAILED";
    SageErrorCodeType["LlmDisabled"] = "LLM_DISABLED";
    SageErrorCodeType["LlmFormat"] = "LLM_FORMAT";
    SageErrorCodeType["LlmNotEnoughQuestions"] = "LLM_NOT_ENOUGH_QUESTIONS";
    SageErrorCodeType["LlmNotFoundInPensieve"] = "LLM_NOT_FOUND_IN_PENSIEVE";
    SageErrorCodeType["LlmPensieveWriteError"] = "LLM_PENSIEVE_WRITE_ERROR";
    SageErrorCodeType["LlmUnavailable"] = "LLM_UNAVAILABLE";
    SageErrorCodeType["NestedAggrWarning"] = "NESTED_AGGR_WARNING";
    SageErrorCodeType["NestingGroupAggrNotAllowed"] = "NESTING_GROUP_AGGR_NOT_ALLOWED";
    SageErrorCodeType["NotFound"] = "NOT_FOUND";
    SageErrorCodeType["NotReady"] = "NOT_READY";
    SageErrorCodeType["NoJoinPath"] = "NO_JOIN_PATH";
    SageErrorCodeType["NoMatch"] = "NO_MATCH";
    SageErrorCodeType["PermissionDenied"] = "PERMISSION_DENIED";
    SageErrorCodeType["QueryTemplateToTemplateEntryMismatch"] = "QUERY_TEMPLATE_TO_TEMPLATE_ENTRY_MISMATCH";
    SageErrorCodeType["RelationshipGraphHasCycles"] = "RELATIONSHIP_GRAPH_HAS_CYCLES";
    SageErrorCodeType["RemoveFormulaDependencyFailure"] = "REMOVE_FORMULA_DEPENDENCY_FAILURE";
    SageErrorCodeType["Success"] = "SUCCESS";
    SageErrorCodeType["TimeOutError"] = "TIME_OUT_ERROR";
    SageErrorCodeType["UnknownUser"] = "UNKNOWN_USER";
    SageErrorCodeType["UnsupportedLanguage"] = "UNSUPPORTED_LANGUAGE";
    SageErrorCodeType["UserGroupMaskNotSet"] = "USER_GROUP_MASK_NOT_SET";
})(SageErrorCodeType || (SageErrorCodeType = {}));
export var SageFeatureFlag;
(function (SageFeatureFlag) {
    SageFeatureFlag["AutoResolveJoinAmbiguity"] = "AUTO_RESOLVE_JOIN_AMBIGUITY";
    SageFeatureFlag["DisableApproximateMatches"] = "DISABLE_APPROXIMATE_MATCHES";
    SageFeatureFlag["DisableDataBasedAutoBucketing"] = "DISABLE_DATA_BASED_AUTO_BUCKETING";
    SageFeatureFlag["DisableFollowUpSuggestions"] = "DISABLE_FOLLOW_UP_SUGGESTIONS";
    SageFeatureFlag["DisableObjectSearch"] = "DISABLE_OBJECT_SEARCH";
    SageFeatureFlag["DisableSearchHistoryLookup"] = "DISABLE_SEARCH_HISTORY_LOOKUP";
    SageFeatureFlag["DisableTokenization"] = "DISABLE_TOKENIZATION";
    SageFeatureFlag["DisableUbr"] = "DISABLE_UBR";
    SageFeatureFlag["DisableUbrFeedbackLookup"] = "DISABLE_UBR_FEEDBACK_LOOKUP";
    SageFeatureFlag["EnableDataBasedAutoBucketing"] = "ENABLE_DATA_BASED_AUTO_BUCKETING";
    SageFeatureFlag["EnableNlpTokenizer"] = "ENABLE_NLP_TOKENIZER";
    SageFeatureFlag["EnableOutOfScopeMatches"] = "ENABLE_OUT_OF_SCOPE_MATCHES";
    SageFeatureFlag["EnableRequestProfiling"] = "ENABLE_REQUEST_PROFILING";
    SageFeatureFlag["EnableSearchHistory"] = "ENABLE_SEARCH_HISTORY";
    SageFeatureFlag["LookupEnlitePreferredColumns"] = "LOOKUP_ENLITE_PREFERRED_COLUMNS";
    SageFeatureFlag["LookupOnlyColumns"] = "LOOKUP_ONLY_COLUMNS";
    SageFeatureFlag["NumFeatureFlags"] = "NUM_FEATURE_FLAGS";
    SageFeatureFlag["ShowDebugInfo"] = "SHOW_DEBUG_INFO";
    SageFeatureFlag["SingleTokenCompletionsOnly"] = "SINGLE_TOKEN_COMPLETIONS_ONLY";
    SageFeatureFlag["UseWhiteSpaceInfo"] = "USE_WHITE_SPACE_INFO";
    SageFeatureFlag["WriteRequestSnapshot"] = "WRITE_REQUEST_SNAPSHOT";
})(SageFeatureFlag || (SageFeatureFlag = {}));
export var SageJoinType;
(function (SageJoinType) {
    SageJoinType["Cross"] = "CROSS";
    SageJoinType["FullOuter"] = "FULL_OUTER";
    SageJoinType["Inner"] = "INNER";
    SageJoinType["LeftOuter"] = "LEFT_OUTER";
    SageJoinType["RightOuter"] = "RIGHT_OUTER";
})(SageJoinType || (SageJoinType = {}));
export var SageQueryIssueSeverity;
(function (SageQueryIssueSeverity) {
    SageQueryIssueSeverity["Error"] = "ERROR";
    SageQueryIssueSeverity["Warning"] = "WARNING";
})(SageQueryIssueSeverity || (SageQueryIssueSeverity = {}));
export var SageQueryIssueType;
(function (SageQueryIssueType) {
    SageQueryIssueType["AutoDisambiguation"] = "AUTO_DISAMBIGUATION";
    SageQueryIssueType["JoinPathResolutionRequired"] = "JOIN_PATH_RESOLUTION_REQUIRED";
    SageQueryIssueType["OtherBackendIssue"] = "OTHER_BACKEND_ISSUE";
})(SageQueryIssueType || (SageQueryIssueType = {}));
export var SageRequestFlag;
(function (SageRequestFlag) {
    SageRequestFlag["DoBestEffortTokenization"] = "DoBestEffortTokenization";
    SageRequestFlag["ExactMatchCompletionsOnly"] = "ExactMatchCompletionsOnly";
})(SageRequestFlag || (SageRequestFlag = {}));
export var ScheduleOps;
(function (ScheduleOps) {
    ScheduleOps["Create"] = "CREATE";
    ScheduleOps["Delete"] = "DELETE";
    ScheduleOps["Update"] = "UPDATE";
})(ScheduleOps || (ScheduleOps = {}));
export var ScheduleRunState;
(function (ScheduleRunState) {
    ScheduleRunState["Deadline"] = "DEADLINE";
    ScheduleRunState["Default"] = "DEFAULT";
    ScheduleRunState["DoesNotExist"] = "DOES_NOT_EXIST";
    ScheduleRunState["Failed"] = "FAILED";
    ScheduleRunState["Running"] = "RUNNING";
    ScheduleRunState["Success"] = "SUCCESS";
})(ScheduleRunState || (ScheduleRunState = {}));
export var ScheduleTargetType;
(function (ScheduleTargetType) {
    ScheduleTargetType["Http"] = "HTTP";
    ScheduleTargetType["Queue"] = "QUEUE";
})(ScheduleTargetType || (ScheduleTargetType = {}));
export var ScheduleType;
(function (ScheduleType) {
    ScheduleType["OnetimeSchedule"] = "ONETIME_SCHEDULE";
    ScheduleType["RecurringSchedule"] = "RECURRING_SCHEDULE";
})(ScheduleType || (ScheduleType = {}));
export var SchemaVersion;
(function (SchemaVersion) {
    SchemaVersion["V1"] = "v1";
})(SchemaVersion || (SchemaVersion = {}));
export var SearchCacheSchedulerRunType;
(function (SearchCacheSchedulerRunType) {
    SearchCacheSchedulerRunType["AdHoc"] = "AD_HOC";
    SearchCacheSchedulerRunType["Scheduled"] = "SCHEDULED";
})(SearchCacheSchedulerRunType || (SearchCacheSchedulerRunType = {}));
export var SearchCacheStatus;
(function (SearchCacheStatus) {
    SearchCacheStatus["Empty"] = "EMPTY";
    SearchCacheStatus["Error"] = "ERROR";
    SearchCacheStatus["Inprogress"] = "INPROGRESS";
    SearchCacheStatus["Queued"] = "QUEUED";
    SearchCacheStatus["Ready"] = "READY";
    SearchCacheStatus["Stale"] = "STALE";
    SearchCacheStatus["Unknown"] = "UNKNOWN";
})(SearchCacheStatus || (SearchCacheStatus = {}));
export var SearchMetadataType;
(function (SearchMetadataType) {
    SearchMetadataType["Answer"] = "ANSWER";
    SearchMetadataType["Connection"] = "CONNECTION";
    SearchMetadataType["InsightSpec"] = "INSIGHT_SPEC";
    SearchMetadataType["Liveboard"] = "LIVEBOARD";
    SearchMetadataType["LogicalColumn"] = "LOGICAL_COLUMN";
    SearchMetadataType["LogicalRelationship"] = "LOGICAL_RELATIONSHIP";
    SearchMetadataType["LogicalTable"] = "LOGICAL_TABLE";
    SearchMetadataType["Tag"] = "TAG";
    SearchMetadataType["User"] = "USER";
    SearchMetadataType["UserGroup"] = "USER_GROUP";
})(SearchMetadataType || (SearchMetadataType = {}));
export var SecuritySettingsScope;
(function (SecuritySettingsScope) {
    SecuritySettingsScope["Cluster"] = "CLUSTER";
    SecuritySettingsScope["Org"] = "ORG";
})(SecuritySettingsScope || (SecuritySettingsScope = {}));
export var SecurityType;
(function (SecurityType) {
    SecurityType["Answer"] = "ANSWER";
    SecurityType["Column"] = "COLUMN";
    SecurityType["Dataobject"] = "DATAOBJECT";
    SecurityType["Liveboard"] = "LIVEBOARD";
})(SecurityType || (SecurityType = {}));
export var SemanticModelImportType;
(function (SemanticModelImportType) {
    SemanticModelImportType["Cdw"] = "CDW";
    SemanticModelImportType["Upload"] = "UPLOAD";
})(SemanticModelImportType || (SemanticModelImportType = {}));
export var ShareMode;
(function (ShareMode) {
    ShareMode["Modify"] = "MODIFY";
    ShareMode["NoAccess"] = "NO_ACCESS";
    ShareMode["ReadOnly"] = "READ_ONLY";
})(ShareMode || (ShareMode = {}));
export var ShareType;
(function (ShareType) {
    ShareType["ReadOnly"] = "READ_ONLY";
})(ShareType || (ShareType = {}));
export var ShowChangeAs;
(function (ShowChangeAs) {
    ShowChangeAs["Absolute"] = "ABSOLUTE";
    ShowChangeAs["Percent"] = "PERCENT";
})(ShowChangeAs || (ShowChangeAs = {}));
export var ShowPivotSummaryPrior;
(function (ShowPivotSummaryPrior) {
    ShowPivotSummaryPrior["Both"] = "BOTH";
    ShowPivotSummaryPrior["Columns"] = "COLUMNS";
    ShowPivotSummaryPrior["None"] = "NONE";
    ShowPivotSummaryPrior["Rows"] = "ROWS";
})(ShowPivotSummaryPrior || (ShowPivotSummaryPrior = {}));
export var SinglePointKpiStatus;
(function (SinglePointKpiStatus) {
    SinglePointKpiStatus["Complete"] = "COMPLETE";
    SinglePointKpiStatus["Done"] = "DONE";
    SinglePointKpiStatus["InProgress"] = "IN_PROGRESS";
})(SinglePointKpiStatus || (SinglePointKpiStatus = {}));
export var SnapshotStatus;
(function (SnapshotStatus) {
    SnapshotStatus["SnapshotCreateFailed"] = "SNAPSHOT_CREATE_FAILED";
    SnapshotStatus["SnapshotCreateFinished"] = "SNAPSHOT_CREATE_FINISHED";
    SnapshotStatus["SnapshotCreateStarted"] = "SNAPSHOT_CREATE_STARTED";
    SnapshotStatus["SnapshotDeleteFailed"] = "SNAPSHOT_DELETE_FAILED";
    SnapshotStatus["SnapshotDeleteScheduled"] = "SNAPSHOT_DELETE_SCHEDULED";
    SnapshotStatus["SnapshotNotFound"] = "SNAPSHOT_NOT_FOUND";
})(SnapshotStatus || (SnapshotStatus = {}));
export var SnapshotType;
(function (SnapshotType) {
    SnapshotType["Html"] = "HTML";
    SnapshotType["Jpeg"] = "JPEG";
    SnapshotType["Svg"] = "SVG";
})(SnapshotType || (SnapshotType = {}));
export var SortBy;
(function (SortBy) {
    SortBy["Author"] = "AUTHOR";
    SortBy["Created"] = "CREATED";
    SortBy["Default"] = "DEFAULT";
    SortBy["DisplayName"] = "DISPLAY_NAME";
    SortBy["LastAccessed"] = "LAST_ACCESSED";
    SortBy["Modified"] = "MODIFIED";
    SortBy["Name"] = "NAME";
    SortBy["None"] = "NONE";
    SortBy["RowCount"] = "ROW_COUNT";
    SortBy["Synced"] = "SYNCED";
    SortBy["UserState"] = "USER_STATE";
    SortBy["Views"] = "VIEWS";
})(SortBy || (SortBy = {}));
export var SortByType;
(function (SortByType) {
    SortByType["Count"] = "COUNT";
    SortByType["Value"] = "VALUE";
})(SortByType || (SortByType = {}));
export var SortOptionFieldName;
(function (SortOptionFieldName) {
    SortOptionFieldName["Author"] = "AUTHOR";
    SortOptionFieldName["Created"] = "CREATED";
    SortOptionFieldName["DisplayName"] = "DISPLAY_NAME";
    SortOptionFieldName["Modified"] = "MODIFIED";
    SortOptionFieldName["Name"] = "NAME";
})(SortOptionFieldName || (SortOptionFieldName = {}));
export var SortOptionOrder;
(function (SortOptionOrder) {
    SortOptionOrder["Asc"] = "ASC";
    SortOptionOrder["Desc"] = "DESC";
})(SortOptionOrder || (SortOptionOrder = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["Asc"] = "ASC";
    SortOrder["Default"] = "DEFAULT";
    SortOrder["Desc"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SourceTypes;
(function (SourceTypes) {
    SourceTypes["Answer"] = "ANSWER";
    SourceTypes["Viz"] = "VIZ";
})(SourceTypes || (SourceTypes = {}));
export var SpotAppReviewStatus;
(function (SpotAppReviewStatus) {
    SpotAppReviewStatus["Published"] = "PUBLISHED";
    SpotAppReviewStatus["Rejected"] = "REJECTED";
    SpotAppReviewStatus["UnderReview"] = "UNDER_REVIEW";
})(SpotAppReviewStatus || (SpotAppReviewStatus = {}));
export var StateType;
(function (StateType) {
    StateType["Active"] = "ACTIVE";
    StateType["Expired"] = "EXPIRED";
    StateType["Inactive"] = "INACTIVE";
    StateType["Locked"] = "LOCKED";
    StateType["Pending"] = "PENDING";
})(StateType || (StateType = {}));
export var StorageType;
(function (StorageType) {
    StorageType["AwsS3"] = "AWS_S3";
    StorageType["GcpGcs"] = "GCP_GCS";
})(StorageType || (StorageType = {}));
export var StyleConfigType;
(function (StyleConfigType) {
    StyleConfigType["All"] = "ALL";
    StyleConfigType["Group"] = "GROUP";
    StyleConfigType["Liveboard"] = "LIVEBOARD";
    StyleConfigType["Tile"] = "TILE";
})(StyleConfigType || (StyleConfigType = {}));
export var StyleV2AdvancedChartVisualizationArea;
(function (StyleV2AdvancedChartVisualizationArea) {
    StyleV2AdvancedChartVisualizationArea["AdvancedChartLabels"] = "ADVANCED_CHART_LABELS";
})(StyleV2AdvancedChartVisualizationArea || (StyleV2AdvancedChartVisualizationArea = {}));
export var StyleV2ChartVisualizationArea;
(function (StyleV2ChartVisualizationArea) {
    StyleV2ChartVisualizationArea["ChartAreaDataLabels"] = "CHART_AREA_DATA_LABELS";
    StyleV2ChartVisualizationArea["ChartBarDataLabels"] = "CHART_BAR_DATA_LABELS";
    StyleV2ChartVisualizationArea["ChartColumnDataLabels"] = "CHART_COLUMN_DATA_LABELS";
    StyleV2ChartVisualizationArea["ChartDonutDataLabels"] = "CHART_DONUT_DATA_LABELS";
    StyleV2ChartVisualizationArea["ChartLineDataLabels"] = "CHART_LINE_DATA_LABELS";
    StyleV2ChartVisualizationArea["ChartScatterDataLabels"] = "CHART_SCATTER_DATA_LABELS";
    StyleV2ChartVisualizationArea["ChartTooltip"] = "CHART_TOOLTIP";
    StyleV2ChartVisualizationArea["ChartXAxisLabels"] = "CHART_X_AXIS_LABELS";
    StyleV2ChartVisualizationArea["ChartXAxisTitle"] = "CHART_X_AXIS_TITLE";
    StyleV2ChartVisualizationArea["ChartYAxisLabels"] = "CHART_Y_AXIS_LABELS";
    StyleV2ChartVisualizationArea["ChartYAxisTitle"] = "CHART_Y_AXIS_TITLE";
})(StyleV2ChartVisualizationArea || (StyleV2ChartVisualizationArea = {}));
export var StyleV2FontStyle;
(function (StyleV2FontStyle) {
    StyleV2FontStyle["Italic"] = "ITALIC";
    StyleV2FontStyle["Normal"] = "NORMAL";
    StyleV2FontStyle["Oblique"] = "OBLIQUE";
})(StyleV2FontStyle || (StyleV2FontStyle = {}));
export var StyleV2FontVisualizationArea;
(function (StyleV2FontVisualizationArea) {
    StyleV2FontVisualizationArea["AdvancedChartLabels"] = "ADVANCED_CHART_LABELS";
    StyleV2FontVisualizationArea["ChartAreaDataLabels"] = "CHART_AREA_DATA_LABELS";
    StyleV2FontVisualizationArea["ChartBarDataLabels"] = "CHART_BAR_DATA_LABELS";
    StyleV2FontVisualizationArea["ChartColumnDataLabels"] = "CHART_COLUMN_DATA_LABELS";
    StyleV2FontVisualizationArea["ChartDonutDataLabels"] = "CHART_DONUT_DATA_LABELS";
    StyleV2FontVisualizationArea["ChartLineDataLabels"] = "CHART_LINE_DATA_LABELS";
    StyleV2FontVisualizationArea["ChartScatterDataLabels"] = "CHART_SCATTER_DATA_LABELS";
    StyleV2FontVisualizationArea["ChartTooltip"] = "CHART_TOOLTIP";
    StyleV2FontVisualizationArea["ChartXAxisLabels"] = "CHART_X_AXIS_LABELS";
    StyleV2FontVisualizationArea["ChartXAxisTitle"] = "CHART_X_AXIS_TITLE";
    StyleV2FontVisualizationArea["ChartYAxisLabels"] = "CHART_Y_AXIS_LABELS";
    StyleV2FontVisualizationArea["ChartYAxisTitle"] = "CHART_Y_AXIS_TITLE";
    StyleV2FontVisualizationArea["TableValueCells"] = "TABLE_VALUE_CELLS";
})(StyleV2FontVisualizationArea || (StyleV2FontVisualizationArea = {}));
export var StyleV2FontWeight;
(function (StyleV2FontWeight) {
    StyleV2FontWeight["Bold"] = "BOLD";
    StyleV2FontWeight["Light"] = "LIGHT";
    StyleV2FontWeight["Normal"] = "NORMAL";
})(StyleV2FontWeight || (StyleV2FontWeight = {}));
export var StyleV2NavPanelColorMode;
(function (StyleV2NavPanelColorMode) {
    StyleV2NavPanelColorMode["Custom"] = "CUSTOM";
    StyleV2NavPanelColorMode["Dark"] = "DARK";
    StyleV2NavPanelColorMode["TwoTone"] = "TWO_TONE";
})(StyleV2NavPanelColorMode || (StyleV2NavPanelColorMode = {}));
export var StyleV2ScopeType;
(function (StyleV2ScopeType) {
    StyleV2ScopeType["Cluster"] = "CLUSTER";
    StyleV2ScopeType["Org"] = "ORG";
})(StyleV2ScopeType || (StyleV2ScopeType = {}));
export var StyleV2TableVisualizationArea;
(function (StyleV2TableVisualizationArea) {
    StyleV2TableVisualizationArea["TableValueCells"] = "TABLE_VALUE_CELLS";
})(StyleV2TableVisualizationArea || (StyleV2TableVisualizationArea = {}));
export var SubTypes;
(function (SubTypes) {
    SubTypes["AggrWorksheet"] = "AGGR_WORKSHEET";
    SubTypes["Dataset"] = "DATASET";
    SubTypes["OneToOneLogical"] = "ONE_TO_ONE_LOGICAL";
    SubTypes["SqlView"] = "SQL_VIEW";
    SubTypes["UserDefined"] = "USER_DEFINED";
    SubTypes["Worksheet"] = "WORKSHEET";
})(SubTypes || (SubTypes = {}));
export var SyncSourceTypes;
(function (SyncSourceTypes) {
    SyncSourceTypes["Answers"] = "Answers";
    SyncSourceTypes["Pinboard"] = "Pinboard";
    SyncSourceTypes["SqlView"] = "SqlView";
    SyncSourceTypes["View"] = "View";
})(SyncSourceTypes || (SyncSourceTypes = {}));
export var TableContentDensity;
(function (TableContentDensity) {
    TableContentDensity["Compact"] = "COMPACT";
    TableContentDensity["Regular"] = "REGULAR";
})(TableContentDensity || (TableContentDensity = {}));
export var TableTheme;
(function (TableTheme) {
    TableTheme["Outline"] = "OUTLINE";
    TableTheme["Row"] = "ROW";
    TableTheme["Zebra"] = "ZEBRA";
})(TableTheme || (TableTheme = {}));
export var TableType;
(function (TableType) {
    TableType["AggWorksheet"] = "AGG_WORKSHEET";
    TableType["BaseTable"] = "BASE_TABLE";
    TableType["QueryTable"] = "QUERY_TABLE";
    TableType["Unknown"] = "UNKNOWN";
    TableType["Worksheet"] = "WORKSHEET";
})(TableType || (TableType = {}));
export var TableVizPropVersion;
(function (TableVizPropVersion) {
    TableVizPropVersion["PreV1"] = "PRE_V1";
    TableVizPropVersion["V1"] = "V1";
})(TableVizPropVersion || (TableVizPropVersion = {}));
export var TemplateEntryType;
(function (TemplateEntryType) {
    TemplateEntryType["Text"] = "TEXT";
    TemplateEntryType["Token"] = "TOKEN";
})(TemplateEntryType || (TemplateEntryType = {}));
export var ThresholdComparator;
(function (ThresholdComparator) {
    ThresholdComparator["ComparatorEq"] = "COMPARATOR_EQ";
    ThresholdComparator["ComparatorGeq"] = "COMPARATOR_GEQ";
    ThresholdComparator["ComparatorGt"] = "COMPARATOR_GT";
    ThresholdComparator["ComparatorLeq"] = "COMPARATOR_LEQ";
    ThresholdComparator["ComparatorLt"] = "COMPARATOR_LT";
    ThresholdComparator["ComparatorNeq"] = "COMPARATOR_NEQ";
    ThresholdComparator["ComparatorUnspecified"] = "COMPARATOR_UNSPECIFIED";
})(ThresholdComparator || (ThresholdComparator = {}));
export var ThresholdPercentageChangeComparator;
(function (ThresholdPercentageChangeComparator) {
    ThresholdPercentageChangeComparator["PercentageChangeComparatorChangesBy"] = "PERCENTAGE_CHANGE_COMPARATOR_CHANGES_BY";
    ThresholdPercentageChangeComparator["PercentageChangeComparatorDecreasesBy"] = "PERCENTAGE_CHANGE_COMPARATOR_DECREASES_BY";
    ThresholdPercentageChangeComparator["PercentageChangeComparatorIncreasesBy"] = "PERCENTAGE_CHANGE_COMPARATOR_INCREASES_BY";
    ThresholdPercentageChangeComparator["PercentageChangeComparatorUnspecified"] = "PERCENTAGE_CHANGE_COMPARATOR_UNSPECIFIED";
})(ThresholdPercentageChangeComparator || (ThresholdPercentageChangeComparator = {}));
export var TileBrandColor;
(function (TileBrandColor) {
    TileBrandColor["TbcA"] = "TBC_A";
    TileBrandColor["TbcB"] = "TBC_B";
    TileBrandColor["TbcC"] = "TBC_C";
    TileBrandColor["TbcD"] = "TBC_D";
    TileBrandColor["TbcE"] = "TBC_E";
    TileBrandColor["TbcF"] = "TBC_F";
    TileBrandColor["TbcG"] = "TBC_G";
    TileBrandColor["TbcH"] = "TBC_H";
    TileBrandColor["TbcI"] = "TBC_I";
    TileBrandColor["TbcJ"] = "TBC_J";
    TileBrandColor["TbcK"] = "TBC_K";
    TileBrandColor["TbcL"] = "TBC_L";
    TileBrandColor["TbcM"] = "TBC_M";
    TileBrandColor["TbcN"] = "TBC_N";
    TileBrandColor["TbcO"] = "TBC_O";
    TileBrandColor["TbcP"] = "TBC_P";
    TileBrandColor["TbcQ"] = "TBC_Q";
    TileBrandColor["TbcUnknown"] = "TBC_UNKNOWN";
})(TileBrandColor || (TileBrandColor = {}));
export var TileColorShade;
(function (TileColorShade) {
    TileColorShade["TcsA"] = "TCS_A";
    TileColorShade["TcsB"] = "TCS_B";
    TileColorShade["TcsUnknown"] = "TCS_UNKNOWN";
})(TileColorShade || (TileColorShade = {}));
export var TileKpiColor;
(function (TileKpiColor) {
    TileKpiColor["TksA"] = "TKS_A";
    TileKpiColor["TksB"] = "TKS_B";
    TileKpiColor["TksC"] = "TKS_C";
    TileKpiColor["TksD"] = "TKS_D";
    TileKpiColor["TksE"] = "TKS_E";
    TileKpiColor["TksF"] = "TKS_F";
    TileKpiColor["TksG"] = "TKS_G";
    TileKpiColor["TksH"] = "TKS_H";
    TileKpiColor["TksI"] = "TKS_I";
    TileKpiColor["TksJ"] = "TKS_J";
    TileKpiColor["TksK"] = "TKS_K";
    TileKpiColor["TksL"] = "TKS_L";
    TileKpiColor["TksM"] = "TKS_M";
    TileKpiColor["TksN"] = "TKS_N";
    TileKpiColor["TksO"] = "TKS_O";
    TileKpiColor["TksP"] = "TKS_P";
    TileKpiColor["TksUnknown"] = "TKS_UNKNOWN";
})(TileKpiColor || (TileKpiColor = {}));
export var TimeFrequency;
(function (TimeFrequency) {
    TimeFrequency["Daily"] = "DAILY";
    TimeFrequency["Hourly"] = "HOURLY";
    TimeFrequency["Monthly"] = "MONTHLY";
    TimeFrequency["None"] = "NONE";
    TimeFrequency["Quarterly"] = "QUARTERLY";
    TimeFrequency["Weekly"] = "WEEKLY";
    TimeFrequency["Yearly"] = "YEARLY";
})(TimeFrequency || (TimeFrequency = {}));
export var TsObject;
(function (TsObject) {
    TsObject["Answer"] = "ANSWER";
    TsObject["Connection"] = "CONNECTION";
    TsObject["Dataobject"] = "DATAOBJECT";
    TsObject["Liveboard"] = "LIVEBOARD";
})(TsObject || (TsObject = {}));
export var TsObjectDetailGet;
(function (TsObjectDetailGet) {
    TsObjectDetailGet["Answer"] = "ANSWER";
    TsObjectDetailGet["Column"] = "COLUMN";
    TsObjectDetailGet["Connection"] = "CONNECTION";
    TsObjectDetailGet["Dataobject"] = "DATAOBJECT";
    TsObjectDetailGet["Join"] = "JOIN";
    TsObjectDetailGet["Liveboard"] = "LIVEBOARD";
    TsObjectDetailGet["LogicalTable"] = "LOGICAL_TABLE";
    TsObjectDetailGet["Tag"] = "TAG";
    TsObjectDetailGet["User"] = "USER";
    TsObjectDetailGet["UserGroup"] = "USER_GROUP";
})(TsObjectDetailGet || (TsObjectDetailGet = {}));
export var TsObjectGet;
(function (TsObjectGet) {
    TsObjectGet["Answer"] = "ANSWER";
    TsObjectGet["ColumnAll"] = "COLUMN_ALL";
    TsObjectGet["ColumnCalendarTable"] = "COLUMN_CALENDAR_TABLE";
    TsObjectGet["ColumnTable"] = "COLUMN_TABLE";
    TsObjectGet["ColumnUserDefined"] = "COLUMN_USER_DEFINED";
    TsObjectGet["ColumnView"] = "COLUMN_VIEW";
    TsObjectGet["ColumnWorksheet"] = "COLUMN_WORKSHEET";
    TsObjectGet["Connection"] = "CONNECTION";
    TsObjectGet["DataobjectAll"] = "DATAOBJECT_ALL";
    TsObjectGet["DataobjectCalendarTable"] = "DATAOBJECT_CALENDAR_TABLE";
    TsObjectGet["DataobjectTable"] = "DATAOBJECT_TABLE";
    TsObjectGet["DataobjectUserDefined"] = "DATAOBJECT_USER_DEFINED";
    TsObjectGet["DataobjectView"] = "DATAOBJECT_VIEW";
    TsObjectGet["DataobjectWorksheet"] = "DATAOBJECT_WORKSHEET";
    TsObjectGet["Join"] = "JOIN";
    TsObjectGet["Liveboard"] = "LIVEBOARD";
    TsObjectGet["Tag"] = "TAG";
    TsObjectGet["User"] = "USER";
    TsObjectGet["UserGroup"] = "USER_GROUP";
})(TsObjectGet || (TsObjectGet = {}));
export var TupleType;
(function (TupleType) {
    TupleType["ChartAggregatedVal"] = "CHART_AGGREGATED_VAL";
    TupleType["Current"] = "CURRENT";
    TupleType["Custom"] = "CUSTOM";
    TupleType["LastAvailable"] = "LAST_AVAILABLE";
    TupleType["PreviousChartAggregatedVal"] = "PREVIOUS_CHART_AGGREGATED_VAL";
    TupleType["PrevAvailable"] = "PREV_AVAILABLE";
    TupleType["PrevDay"] = "PREV_DAY";
    TupleType["PrevHour"] = "PREV_HOUR";
    TupleType["PrevMonth"] = "PREV_MONTH";
    TupleType["PrevQuarter"] = "PREV_QUARTER";
    TupleType["PrevWeek"] = "PREV_WEEK";
    TupleType["PrevYear"] = "PREV_YEAR";
    TupleType["SinglePointKpiCurrent"] = "SINGLE_POINT_KPI_CURRENT";
    TupleType["SinglePointKpiPrevious"] = "SINGLE_POINT_KPI_PREVIOUS";
})(TupleType || (TupleType = {}));
export var Unit;
(function (Unit) {
    Unit["Auto"] = "AUTO";
    Unit["Billion"] = "BILLION";
    Unit["Million"] = "MILLION";
    Unit["None"] = "NONE";
    Unit["Thousands"] = "THOUSANDS";
    Unit["Trillion"] = "TRILLION";
})(Unit || (Unit = {}));
export var Users__AccountStatus;
(function (Users__AccountStatus) {
    Users__AccountStatus["Active"] = "ACTIVE";
    Users__AccountStatus["Expired"] = "EXPIRED";
    Users__AccountStatus["Inactive"] = "INACTIVE";
    Users__AccountStatus["Locked"] = "LOCKED";
    Users__AccountStatus["Pending"] = "PENDING";
    Users__AccountStatus["Suspended"] = "SUSPENDED";
})(Users__AccountStatus || (Users__AccountStatus = {}));
export var Users__AccountType;
(function (Users__AccountType) {
    Users__AccountType["LdapUser"] = "LDAP_USER";
    Users__AccountType["LocalUser"] = "LOCAL_USER";
    Users__AccountType["OidcUser"] = "OIDC_USER";
    Users__AccountType["RemoteUser"] = "REMOTE_USER";
    Users__AccountType["SamlUser"] = "SAML_USER";
})(Users__AccountType || (Users__AccountType = {}));
export var Users__FavoriteMetadata;
(function (Users__FavoriteMetadata) {
    Users__FavoriteMetadata["Answer"] = "ANSWER";
    Users__FavoriteMetadata["Connection"] = "CONNECTION";
    Users__FavoriteMetadata["Liveboard"] = "LIVEBOARD";
    Users__FavoriteMetadata["LogicalTable"] = "LOGICAL_TABLE";
})(Users__FavoriteMetadata || (Users__FavoriteMetadata = {}));
export var VcsCommitMetadataType;
(function (VcsCommitMetadataType) {
    VcsCommitMetadataType["Answer"] = "ANSWER";
    VcsCommitMetadataType["Liveboard"] = "LIVEBOARD";
    VcsCommitMetadataType["LogicalTable"] = "LOGICAL_TABLE";
})(VcsCommitMetadataType || (VcsCommitMetadataType = {}));
export var ValidEdocMetadataType;
(function (ValidEdocMetadataType) {
    ValidEdocMetadataType["ActionObject"] = "ACTION_OBJECT";
    ValidEdocMetadataType["Answer"] = "ANSWER";
    ValidEdocMetadataType["Cohort"] = "COHORT";
    ValidEdocMetadataType["Collection"] = "COLLECTION";
    ValidEdocMetadataType["ColumnAliasUdf"] = "COLUMN_ALIAS_UDF";
    ValidEdocMetadataType["ColumnSecurityRules"] = "COLUMN_SECURITY_RULES";
    ValidEdocMetadataType["Connection"] = "CONNECTION";
    ValidEdocMetadataType["Feedback"] = "FEEDBACK";
    ValidEdocMetadataType["Group"] = "GROUP";
    ValidEdocMetadataType["LogicalTable"] = "LOGICAL_TABLE";
    ValidEdocMetadataType["Model"] = "MODEL";
    ValidEdocMetadataType["MonitorAlerts"] = "MONITOR_ALERTS";
    ValidEdocMetadataType["NlInstruction"] = "NL_INSTRUCTION";
    ValidEdocMetadataType["Pinboard"] = "PINBOARD";
    ValidEdocMetadataType["PinboardAnswerBook"] = "PINBOARD_ANSWER_BOOK";
    ValidEdocMetadataType["QuestionAnswerBook"] = "QUESTION_ANSWER_BOOK";
    ValidEdocMetadataType["Role"] = "ROLE";
    ValidEdocMetadataType["SqlView"] = "SQL_VIEW";
    ValidEdocMetadataType["Table"] = "TABLE";
    ValidEdocMetadataType["User"] = "USER";
    ValidEdocMetadataType["UserGroup"] = "USER_GROUP";
    ValidEdocMetadataType["View"] = "VIEW";
    ValidEdocMetadataType["Worksheet"] = "WORKSHEET";
})(ValidEdocMetadataType || (ValidEdocMetadataType = {}));
export var VariableAssignmentOperation;
(function (VariableAssignmentOperation) {
    VariableAssignmentOperation["Add"] = "ADD";
    VariableAssignmentOperation["Remove"] = "REMOVE";
    VariableAssignmentOperation["Replace"] = "REPLACE";
    VariableAssignmentOperation["Reset"] = "RESET";
})(VariableAssignmentOperation || (VariableAssignmentOperation = {}));
export var VariableResponseContent;
(function (VariableResponseContent) {
    VariableResponseContent["Metadata"] = "METADATA";
    VariableResponseContent["MetadataAndValues"] = "METADATA_AND_VALUES";
})(VariableResponseContent || (VariableResponseContent = {}));
export var VariableType;
(function (VariableType) {
    VariableType["ConnectionProperty"] = "CONNECTION_PROPERTY";
    VariableType["ConnectionPropertyPerPrincipal"] = "CONNECTION_PROPERTY_PER_PRINCIPAL";
    VariableType["FormulaTemplateVariable"] = "FORMULA_TEMPLATE_VARIABLE";
    VariableType["FormulaVariable"] = "FORMULA_VARIABLE";
    VariableType["SystemVariable"] = "SYSTEM_VARIABLE";
    VariableType["TableMapping"] = "TABLE_MAPPING";
    VariableType["Unknown"] = "UNKNOWN";
    VariableType["UserProperty"] = "USER_PROPERTY";
})(VariableType || (VariableType = {}));
export var Vendor;
(function (Vendor) {
    Vendor["Datarobot"] = "DATAROBOT";
    Vendor["Thoughtspot"] = "THOUGHTSPOT";
})(Vendor || (Vendor = {}));
export var ViewType;
(function (ViewType) {
    ViewType["Default"] = "DEFAULT";
    ViewType["MonitorAlert"] = "MONITOR_ALERT";
})(ViewType || (ViewType = {}));
export var Visibility;
(function (Visibility) {
    Visibility["NonSharable"] = "NON_SHARABLE";
    Visibility["Sharable"] = "SHARABLE";
})(Visibility || (Visibility = {}));
export var VisualizationQueryStatus;
(function (VisualizationQueryStatus) {
    VisualizationQueryStatus["Completed"] = "COMPLETED";
    VisualizationQueryStatus["ExecutingQuery"] = "EXECUTING_QUERY";
    VisualizationQueryStatus["InPriorityQueue"] = "IN_PRIORITY_QUEUE";
    VisualizationQueryStatus["ProcessingResults"] = "PROCESSING_RESULTS";
    VisualizationQueryStatus["Unknown"] = "UNKNOWN";
    VisualizationQueryStatus["WaitingForConnection"] = "WAITING_FOR_CONNECTION";
})(VisualizationQueryStatus || (VisualizationQueryStatus = {}));
export var WebhookAuthType;
(function (WebhookAuthType) {
    WebhookAuthType["ApiKeyType"] = "API_KEY_TYPE";
    WebhookAuthType["NoAuthType"] = "NO_AUTH_TYPE";
    WebhookAuthType["OAuth2Type"] = "O_AUTH2_TYPE";
})(WebhookAuthType || (WebhookAuthType = {}));
export var WebhookEventType;
(function (WebhookEventType) {
    WebhookEventType["LiveboardSchedule"] = "LIVEBOARD_SCHEDULE";
})(WebhookEventType || (WebhookEventType = {}));
export var WebhookSignatureVerificationAlgorithm;
(function (WebhookSignatureVerificationAlgorithm) {
    WebhookSignatureVerificationAlgorithm["Sha256"] = "SHA256";
})(WebhookSignatureVerificationAlgorithm || (WebhookSignatureVerificationAlgorithm = {}));
export var WebhookSignatureVerificationType;
(function (WebhookSignatureVerificationType) {
    WebhookSignatureVerificationType["HmacSha256"] = "HMAC_SHA256";
})(WebhookSignatureVerificationType || (WebhookSignatureVerificationType = {}));
export var WebhookSortField;
(function (WebhookSortField) {
    WebhookSortField["Created"] = "CREATED";
    WebhookSortField["Modified"] = "MODIFIED";
    WebhookSortField["Name"] = "NAME";
})(WebhookSortField || (WebhookSortField = {}));
export var WebhookSortOrder;
(function (WebhookSortOrder) {
    WebhookSortOrder["Asc"] = "ASC";
    WebhookSortOrder["Desc"] = "DESC";
})(WebhookSortOrder || (WebhookSortOrder = {}));
export var WebhookStatus;
(function (WebhookStatus) {
    WebhookStatus["Disabled"] = "DISABLED";
    WebhookStatus["Enabled"] = "ENABLED";
})(WebhookStatus || (WebhookStatus = {}));
export var WeekDay;
(function (WeekDay) {
    WeekDay["Friday"] = "FRIDAY";
    WeekDay["Monday"] = "MONDAY";
    WeekDay["NumWeekDays"] = "NUM_WEEK_DAYS";
    WeekDay["Saturday"] = "SATURDAY";
    WeekDay["Sunday"] = "SUNDAY";
    WeekDay["Thursday"] = "THURSDAY";
    WeekDay["Tuesday"] = "TUESDAY";
    WeekDay["Wednesday"] = "WEDNESDAY";
})(WeekDay || (WeekDay = {}));
export var WorksheetRequestType;
(function (WorksheetRequestType) {
    WorksheetRequestType["AcceptJoinRecommendationsTransform"] = "ACCEPT_JOIN_RECOMMENDATIONS_TRANSFORM";
    WorksheetRequestType["AddColumnsFromDiffTablesTransformRequest"] = "ADD_COLUMNS_FROM_DIFF_TABLES_TRANSFORM_REQUEST";
    WorksheetRequestType["AddColumnsTransformRequest"] = "ADD_COLUMNS_TRANSFORM_REQUEST";
    WorksheetRequestType["AddFilterTransformRequest"] = "ADD_FILTER_TRANSFORM_REQUEST";
    WorksheetRequestType["AddSchemaTableTransformRequest"] = "ADD_SCHEMA_TABLE_TRANSFORM_REQUEST";
    WorksheetRequestType["ChatRequest"] = "CHAT_REQUEST";
    WorksheetRequestType["ClearJoinRecommendationsTransform"] = "CLEAR_JOIN_RECOMMENDATIONS_TRANSFORM";
    WorksheetRequestType["ColumnBulkEditTransform"] = "COLUMN_BULK_EDIT_TRANSFORM";
    WorksheetRequestType["ColumnCsvExportTransform"] = "COLUMN_CSV_EXPORT_TRANSFORM";
    WorksheetRequestType["ColumnCsvImportTransform"] = "COLUMN_CSV_IMPORT_TRANSFORM";
    WorksheetRequestType["ConvertGlobalToLocalJoinTransform"] = "CONVERT_GLOBAL_TO_LOCAL_JOIN_TRANSFORM";
    WorksheetRequestType["CreateSchemaJoinRequest"] = "CREATE_SCHEMA_JOIN_REQUEST";
    WorksheetRequestType["CreateWorksheetRequest"] = "CREATE_WORKSHEET_REQUEST";
    WorksheetRequestType["DeleteColumnsTransformRequest"] = "DELETE_COLUMNS_TRANSFORM_REQUEST";
    WorksheetRequestType["DeleteParameterTransformRequest"] = "DELETE_PARAMETER_TRANSFORM_REQUEST";
    WorksheetRequestType["EditFilterTransformRequest"] = "EDIT_FILTER_TRANSFORM_REQUEST";
    WorksheetRequestType["EditSchemaGraphLayoutTransform"] = "EDIT_SCHEMA_GRAPH_LAYOUT_TRANSFORM";
    WorksheetRequestType["EditSchemaJoinRequest"] = "EDIT_SCHEMA_JOIN_REQUEST";
    WorksheetRequestType["FetchWorksheetModelRequest"] = "FETCH_WORKSHEET_MODEL_REQUEST";
    WorksheetRequestType["GetFormulaMetadataRequest"] = "GET_FORMULA_METADATA_REQUEST";
    WorksheetRequestType["GetJoinRecommendationsTransform"] = "GET_JOIN_RECOMMENDATIONS_TRANSFORM";
    WorksheetRequestType["GetSchemaJoinDetailsRequest"] = "GET_SCHEMA_JOIN_DETAILS_REQUEST";
    WorksheetRequestType["InitAcSessionTransformRequest"] = "INIT_AC_SESSION_TRANSFORM_REQUEST";
    WorksheetRequestType["InitAiAssistedModelingRequest"] = "INIT_AI_ASSISTED_MODELING_REQUEST";
    WorksheetRequestType["LoadWorksheetRequest"] = "LOAD_WORKSHEET_REQUEST";
    WorksheetRequestType["ParameterDependenciesRequest"] = "PARAMETER_DEPENDENCIES_REQUEST";
    WorksheetRequestType["RemoveFilterTransformRequest"] = "REMOVE_FILTER_TRANSFORM_REQUEST";
    WorksheetRequestType["RemoveFormulaTransformRequest"] = "REMOVE_FORMULA_TRANSFORM_REQUEST";
    WorksheetRequestType["RemoveSchemaJoinTransform"] = "REMOVE_SCHEMA_JOIN_TRANSFORM";
    WorksheetRequestType["RemoveSchemaTableTransform"] = "REMOVE_SCHEMA_TABLE_TRANSFORM";
    WorksheetRequestType["RenameSchemaTableTransform"] = "RENAME_SCHEMA_TABLE_TRANSFORM";
    WorksheetRequestType["SaveAsRequest"] = "SAVE_AS_REQUEST";
    WorksheetRequestType["SaveFormulaTransformRequest"] = "SAVE_FORMULA_TRANSFORM_REQUEST";
    WorksheetRequestType["SaveParameterTransformRequest"] = "SAVE_PARAMETER_TRANSFORM_REQUEST";
    WorksheetRequestType["SaveWorksheetRequest"] = "SAVE_WORKSHEET_REQUEST";
    WorksheetRequestType["SelectSchemaJoinTransform"] = "SELECT_SCHEMA_JOIN_TRANSFORM";
    WorksheetRequestType["SetScopeTransformRequest"] = "SET_SCOPE_TRANSFORM_REQUEST";
    WorksheetRequestType["UpdateColumnPropertiesTransform"] = "UPDATE_COLUMN_PROPERTIES_TRANSFORM";
    WorksheetRequestType["UpdateWorksheetNameDescriptionRequest"] = "UPDATE_WORKSHEET_NAME_DESCRIPTION_REQUEST";
    WorksheetRequestType["UpdateWorksheetPropertiesRequest"] = "UPDATE_WORKSHEET_PROPERTIES_REQUEST";
    WorksheetRequestType["ValidateSchemaJoinDetailsRequest"] = "VALIDATE_SCHEMA_JOIN_DETAILS_REQUEST";
})(WorksheetRequestType || (WorksheetRequestType = {}));
export var WorksheetVersion;
(function (WorksheetVersion) {
    WorksheetVersion["V1"] = "V1";
    WorksheetVersion["V2"] = "V2";
})(WorksheetVersion || (WorksheetVersion = {}));
export var Common_FormatingType_E;
(function (Common_FormatingType_E) {
    Common_FormatingType_E["DateFormatPattern"] = "DATE_FORMAT_PATTERN";
    Common_FormatingType_E["DateTimeFormatPattern"] = "DATE_TIME_FORMAT_PATTERN";
    Common_FormatingType_E["DayInMonthFormatPattern"] = "DAY_IN_MONTH_FORMAT_PATTERN";
    Common_FormatingType_E["DayInQtrFormatPattern"] = "DAY_IN_QTR_FORMAT_PATTERN";
    Common_FormatingType_E["DayInYearFormatPattern"] = "DAY_IN_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["DayOfWeekFormatPattern"] = "DAY_OF_WEEK_FORMAT_PATTERN";
    Common_FormatingType_E["HourDateFormatPattern"] = "HOUR_DATE_FORMAT_PATTERN";
    Common_FormatingType_E["HourTimeFormatPattern"] = "HOUR_TIME_FORMAT_PATTERN";
    Common_FormatingType_E["MonthInQtrFormatPattern"] = "MONTH_IN_QTR_FORMAT_PATTERN";
    Common_FormatingType_E["MonthInYearFormatPattern"] = "MONTH_IN_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["MonthYearFormatPattern"] = "MONTH_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["NoFormating"] = "NO_FORMATING";
    Common_FormatingType_E["NumberFormatPattern"] = "NUMBER_FORMAT_PATTERN";
    Common_FormatingType_E["QtrInYearFormatPattern"] = "QTR_IN_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["QtrYearFormatPattern"] = "QTR_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["TimeFormatPattern"] = "TIME_FORMAT_PATTERN";
    Common_FormatingType_E["WeekYearFormatPattern"] = "WEEK_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["YearFormatPattern"] = "YEAR_FORMAT_PATTERN";
})(Common_FormatingType_E || (Common_FormatingType_E = {}));
export var OrientationValues;
(function (OrientationValues) {
    OrientationValues["Landscape"] = "LANDSCAPE";
    OrientationValues["Portrait"] = "PORTRAIT";
})(OrientationValues || (OrientationValues = {}));
export var Sage_MatchType_E;
(function (Sage_MatchType_E) {
    Sage_MatchType_E["Approximate"] = "APPROXIMATE";
    Sage_MatchType_E["ApproximatePrefix"] = "APPROXIMATE_PREFIX";
    Sage_MatchType_E["ApproximateWordPrefix"] = "APPROXIMATE_WORD_PREFIX";
    Sage_MatchType_E["Exact"] = "EXACT";
    Sage_MatchType_E["ExactStemmed"] = "EXACT_STEMMED";
    Sage_MatchType_E["PartialSubstring"] = "PARTIAL_SUBSTRING";
    Sage_MatchType_E["Prefix"] = "PREFIX";
    Sage_MatchType_E["Substring"] = "SUBSTRING";
    Sage_MatchType_E["Suffix"] = "SUFFIX";
    Sage_MatchType_E["Undefined"] = "UNDEFINED";
    Sage_MatchType_E["WordPrefix"] = "WORD_PREFIX";
})(Sage_MatchType_E || (Sage_MatchType_E = {}));
export var Sage_SageExpression_ExpressionClass;
(function (Sage_SageExpression_ExpressionClass) {
    Sage_SageExpression_ExpressionClass["ExprColumn"] = "EXPR_COLUMN";
    Sage_SageExpression_ExpressionClass["ExprConstant"] = "EXPR_CONSTANT";
    Sage_SageExpression_ExpressionClass["ExprFunction"] = "EXPR_FUNCTION";
    Sage_SageExpression_ExpressionClass["ExprVariable"] = "EXPR_VARIABLE";
})(Sage_SageExpression_ExpressionClass || (Sage_SageExpression_ExpressionClass = {}));
export var Sage_Auto_Complete_V2_WhiteSpaceElement_Type;
(function (Sage_Auto_Complete_V2_WhiteSpaceElement_Type) {
    Sage_Auto_Complete_V2_WhiteSpaceElement_Type["NewLine"] = "NEW_LINE";
    Sage_Auto_Complete_V2_WhiteSpaceElement_Type["Space"] = "SPACE";
})(Sage_Auto_Complete_V2_WhiteSpaceElement_Type || (Sage_Auto_Complete_V2_WhiteSpaceElement_Type = {}));
export var Sage_Auto_Complete_V2_WhiteSpaceInfo_Type;
(function (Sage_Auto_Complete_V2_WhiteSpaceInfo_Type) {
    Sage_Auto_Complete_V2_WhiteSpaceInfo_Type["Complex"] = "COMPLEX";
    Sage_Auto_Complete_V2_WhiteSpaceInfo_Type["NoWhiteSpace"] = "NO_WHITE_SPACE";
    Sage_Auto_Complete_V2_WhiteSpaceInfo_Type["SingleSpace"] = "SINGLE_SPACE";
})(Sage_Auto_Complete_V2_WhiteSpaceInfo_Type || (Sage_Auto_Complete_V2_WhiteSpaceInfo_Type = {}));
export const FileHeaderFragmentDoc = lazyGql(() => gql `
    fragment fileHeader on FileHeader {
  id
  name
  author
  belongToAllOrgs
  created
  modified
  modifiedBy
  modifiedByName
  orgIds
}
    `);
export const ChartManifestFragmentDoc = lazyGql(() => gql `
    fragment chartManifest on CustomChartManifest {
  id
  name
  description
  sourceUrl
  chartAppAccessToken
  iconUrl
  author {
    name
    email
    organisation
  }
  created
  modified
  modifiedBy
  modifiedByName
  belongToAllOrgs
  orgIds
  __typename
}
    `);
export const CustomRegionUploadDocument = lazyGql(() => gql `
    mutation customRegionUpload($file: String!, $mimeType: String!, $displayName: String!, $geometryType: String!, $orgId: Int) {
  CustomRegion_upload(
    file: $file
    mimeType: $mimeType
    displayName: $displayName
    geometryType: $geometryType
    orgId: $orgId
  ) {
    ...fileHeader
  }
}
    ${FileHeaderFragmentDoc}`);
export function useCustomRegionUploadMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CustomRegionUploadDocument, options);
}
export const CustomRegionUpdateDocument = lazyGql(() => gql `
    mutation customRegionUpdate($id: String!, $file: String!, $mimeType: String!, $displayName: String!, $geometryType: String!, $orgId: Int) {
  CustomRegion_update(
    id: $id
    file: $file
    mimeType: $mimeType
    displayName: $displayName
    geometryType: $geometryType
    orgId: $orgId
  ) {
    ...fileHeader
  }
}
    ${FileHeaderFragmentDoc}`);
export function useCustomRegionUpdateMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CustomRegionUpdateDocument, options);
}
export const CustomRegionDeleteDocument = lazyGql(() => gql `
    mutation customRegionDelete($id: String!, $orgId: Int) {
  CustomRegion_delete(id: $id, orgId: $orgId)
}
    `);
export function useCustomRegionDeleteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CustomRegionDeleteDocument, options);
}
export const GetCustomRegionListDocument = lazyGql(() => gql `
    query GetCustomRegionList($orgId: Int) {
  getCustomRegionList(orgId: $orgId) {
    ...fileHeader
  }
}
    ${FileHeaderFragmentDoc}`);
export function useGetCustomRegionListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCustomRegionListDocument, options);
}
export function useGetCustomRegionListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCustomRegionListDocument, options);
}
export const AddChartDocument = lazyGql(() => gql `
    mutation addChart($name: String!, $description: String, $sourceUrl: String!, $iconUrl: String, $author: ChartAuthorInput, $orgId: Int, $chartAppAccessToken: String) {
  CustomChart_add(
    name: $name
    description: $description
    sourceUrl: $sourceUrl
    iconUrl: $iconUrl
    author: $author
    orgId: $orgId
    chartAppAccessToken: $chartAppAccessToken
  )
}
    `);
export function useAddChartMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AddChartDocument, options);
}
export const UpdateChartDocument = lazyGql(() => gql `
    mutation updateChart($guid: GUID!, $name: String!, $description: String, $sourceUrl: String!, $iconUrl: String, $author: ChartAuthorInput, $orgId: Int, $chartAppAccessToken: String) {
  CustomChart_update(
    guid: $guid
    name: $name
    description: $description
    sourceUrl: $sourceUrl
    iconUrl: $iconUrl
    author: $author
    orgId: $orgId
    chartAppAccessToken: $chartAppAccessToken
  )
}
    `);
export function useUpdateChartMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateChartDocument, options);
}
export const DeleteChartDocument = lazyGql(() => gql `
    mutation deleteChart($guid: GUID!, $orgId: Int) {
  CustomChart_delete(guid: $guid, orgId: $orgId)
}
    `);
export function useDeleteChartMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteChartDocument, options);
}
export const GetChartDocument = lazyGql(() => gql `
    query getChart($guid: GUID!, $orgId: Int) {
  CustomChart_get(guid: $guid, orgId: $orgId) {
    ...chartManifest
  }
}
    ${ChartManifestFragmentDoc}`);
export function useGetChartQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetChartDocument, options);
}
export function useGetChartLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetChartDocument, options);
}
export const GetAllChartsDocument = lazyGql(() => gql `
    query getAllCharts($orgId: Int) {
  CustomChart_getAll(orgId: $orgId) {
    ...chartManifest
  }
}
    ${ChartManifestFragmentDoc}`);
export function useGetAllChartsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAllChartsDocument, options);
}
export function useGetAllChartsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAllChartsDocument, options);
}
export const WorksheetUpgradeValidationDocument = lazyGql(() => gql `
    query worksheetUpgradeValidation($applyChanges: Boolean!) {
  Worksheet__bulkUpgraderValidation(applyChanges: $applyChanges)
}
    `);
export function useWorksheetUpgradeValidationQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(WorksheetUpgradeValidationDocument, options);
}
export function useWorksheetUpgradeValidationLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(WorksheetUpgradeValidationDocument, options);
}
export const CreateEmailCustomizationDocument = lazyGql(() => gql `
    mutation createEmailCustomization($template_properties: Template_Properties_Input_Create!, $org_identifier: String) {
  createEmailCustomization(
    template_properties: $template_properties
    org_identifier: $org_identifier
  ) {
    data {
      tenant_id
      org {
        id
        name
      }
      name
      template_properties
    }
  }
}
    `);
export function useCreateEmailCustomizationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateEmailCustomizationDocument, options);
}
export const UpdateEmailCustomizationDocument = lazyGql(() => gql `
    mutation updateEmailCustomization($template_properties: Template_Properties_Input_Create!, $org_identifier: String) {
  updateEmailCustomization(
    template_properties: $template_properties
    org_identifier: $org_identifier
  )
}
    `);
export function useUpdateEmailCustomizationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateEmailCustomizationDocument, options);
}
export const SearchEmailCustomizationDocument = lazyGql(() => gql `
    mutation searchEmailCustomization($org_identifiers: [String]) {
  searchEmailCustomization(org_identifiers: $org_identifiers) {
    data {
      tenant_id
      org {
        id
        name
      }
      name
      template_properties
    }
  }
}
    `);
export function useSearchEmailCustomizationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SearchEmailCustomizationDocument, options);
}
export const DeleteOrgEmailCustomizationDocument = lazyGql(() => gql `
    mutation deleteOrgEmailCustomization($org_identifiers: [String]) {
  deleteOrgEmailCustomization(org_identifiers: $org_identifiers)
}
    `);
export function useDeleteOrgEmailCustomizationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteOrgEmailCustomizationDocument, options);
}
export const ValidateEmailCustomizationDocument = lazyGql(() => gql `
    mutation validateEmailCustomization {
  validateEmailCustomization
}
    `);
export function useValidateEmailCustomizationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ValidateEmailCustomizationDocument, options);
}
export const UpdateFeatureManagementAssignmentDocument = lazyGql(() => gql `
    mutation UpdateFeatureManagementAssignment($feature_identifier: String!, $org_identifiers: [String!]!, $operation: Admin__FeatureManagementOperation) {
  Admin_updateFeatureManagementAssignment(
    feature_identifier: $feature_identifier
    org_identifiers: $org_identifiers
    operation: $operation
  ) {
    Data {
      featureId
      assignedOrgs {
        orgId
        orgName
      }
    }
    Error
  }
}
    `);
export function useUpdateFeatureManagementAssignmentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateFeatureManagementAssignmentDocument, options);
}
export const SetFeatureManagementValueDocument = lazyGql(() => gql `
    mutation SetFeatureManagementValue($scope: Admin__FeatureManagementScope!, $org_identifier: Int, $feature_identifier: String!, $feature_value: String!, $reset_org_overrides: Boolean) {
  Admin_setFeatureManagementValue(
    scope: $scope
    org_identifier: $org_identifier
    feature_identifier: $feature_identifier
    feature_value: $feature_value
    reset_org_overrides: $reset_org_overrides
  ) {
    Data {
      featureId
      featureValue
    }
    Error
  }
}
    `);
export function useSetFeatureManagementValueMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetFeatureManagementValueDocument, options);
}
export const GetFeatureManagementDocument = lazyGql(() => gql `
    query GetFeatureManagement($org_identifier: Int, $category: Admin__FeatureManagementCategory, $scope: Admin__FeatureManagementScope!) {
  Admin_getFeatureManagement(
    org_identifier: $org_identifier
    category: $category
    scope: $scope
  ) {
    Data
    Error
  }
}
    `);
export function useGetFeatureManagementQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetFeatureManagementDocument, options);
}
export function useGetFeatureManagementLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetFeatureManagementDocument, options);
}
export const GetTrendingListDocument = lazyGql(() => gql `
    query GetTrendingList {
  getTrendingList {
    pinboards {
      id
      type
      author
      authorDisplayName
      authorName
      name
    }
    answers {
      id
      type
      author
      authorDisplayName
      authorName
      name
    }
  }
}
    `);
export function useGetTrendingListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetTrendingListDocument, options);
}
export function useGetTrendingListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetTrendingListDocument, options);
}
export const GetCertificateStatusDocument = lazyGql(() => gql `
    query getCertificateStatus {
  getCertificateStatus
}
    `);
export function useGetCertificateStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCertificateStatusDocument, options);
}
export function useGetCertificateStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCertificateStatusDocument, options);
}
export const InstallCertificateDocument = lazyGql(() => gql `
    mutation installCertificate {
  InstallCertificate {
    Data
    Error
    Status
  }
}
    `);
export function useInstallCertificateMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(InstallCertificateDocument, options);
}
export const ListDependentsDocument = lazyGql(() => gql `
    mutation listDependents($ids: [String!]!, $type: DependencyListObjectType!) {
  Dependency__listDependents(ids: $ids, type: $type)
}
    `);
export function useListDependentsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ListDependentsDocument, options);
}
export const LlmGateway_PostTenantOrgMappingsDocument = lazyGql(() => gql `
    mutation LLMGateway_postTenantOrgMappings($tenantId: String!, $orgId: String!, $features: [LLMGatewayFeatureInput]) {
  LLMGateway_postTenantOrgMappings(
    tenantId: $tenantId
    orgId: $orgId
    features: $features
  ) {
    status
    data
    error {
      errorCode
      errorMessage
      status
    }
  }
}
    `);
export function useLlmGateway_PostTenantOrgMappingsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(LlmGateway_PostTenantOrgMappingsDocument, options);
}
export const GetLlmProvidersDocument = lazyGql(() => gql `
    query getLLMProviders {
  Admin_getLLMProviders {
    Data
    Error
  }
}
    `);
export function useGetLlmProvidersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLlmProvidersDocument, options);
}
export function useGetLlmProvidersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLlmProvidersDocument, options);
}
export const GetLlmProviderModelsDocument = lazyGql(() => gql `
    query getLLMProviderModels($providerName: String!) {
  Admin_getLLMProviderModels(providerName: $providerName) {
    Data
    Error
  }
}
    `);
export function useGetLlmProviderModelsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLlmProviderModelsDocument, options);
}
export function useGetLlmProviderModelsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLlmProviderModelsDocument, options);
}
export const GetLlmProviderConfigDocument = lazyGql(() => gql `
    query getLLMProviderConfig($providerName: String!) {
  Admin_getLLMProviderConfig(providerName: $providerName) {
    Data {
      default {
        apiKey
        apiVersion
        endpoint
        model
        provider
        region
        user
        passphrase
        account
        projectId
        usecustomaccount
      }
    }
    Error
  }
}
    `);
export function useGetLlmProviderConfigQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLlmProviderConfigDocument, options);
}
export function useGetLlmProviderConfigLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLlmProviderConfigDocument, options);
}
export const UpdateLlmProviderConfigDocument = lazyGql(() => gql `
    mutation updateLLMProviderConfig($providerName: String!, $configChanges: ProviderConfigInput!) {
  Admin_updateLLMProviderConfig(
    providerName: $providerName
    configChanges: $configChanges
  ) {
    Data
    Error
  }
}
    `);
export function useUpdateLlmProviderConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateLlmProviderConfigDocument, options);
}
export const DisableSageOnAllSourcesDocument = lazyGql(() => gql `
    mutation disableSageOnAllSources($id: [String]) {
  restapiV2__disableSageOnAllSources(id: $id)
}
    `);
export function useDisableSageOnAllSourcesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DisableSageOnAllSourcesDocument, options);
}
export const GetOrgsListDocument = lazyGql(() => gql `
    query getOrgsList($data: Org__ListInput!) {
  getOrgsList(data: $data) {
    Data {
      orgs {
        orgId
        orgName
        description
        allGroupUserId
        defaultAdminUserGroupId
        active
        deleted
        author
        authorName
        created
        groups {
          id
          name
        }
      }
      isLastBatch
      countOfUsersByOrg
      countOfGroupsByOrg
    }
    Error
  }
}
    `);
export function useGetOrgsListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetOrgsListDocument, options);
}
export function useGetOrgsListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetOrgsListDocument, options);
}
export const GetOrgByIdDocument = lazyGql(() => gql `
    query getOrgById($orgId: String!) {
  getOrgById(orgid: $orgId) {
    Data {
      orgId
      orgName
      description
      allGroupUserId
      defaultAdminUserGroupId
      active
      deleted
      author
      created
    }
    Error
  }
}
    `);
export function useGetOrgByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetOrgByIdDocument, options);
}
export function useGetOrgByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetOrgByIdDocument, options);
}
export const GetUserOrgsByUserIdDocument = lazyGql(() => gql `
    query getUserOrgsByUserId($userId: String!) {
  getUserOrgsByUserId(userId: $userId) {
    Data {
      orgs {
        orgId
        orgName
        description
        allUserGroupId
        defaultAdminUserGroupId
        privileges
        isActive
      }
      canAdministerAllOrgs
      currentOrgId
    }
    Error
  }
}
    `);
export function useGetUserOrgsByUserIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserOrgsByUserIdDocument, options);
}
export function useGetUserOrgsByUserIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserOrgsByUserIdDocument, options);
}
export const CreateOrgDocument = lazyGql(() => gql `
    mutation createOrg($data: Org__DataInput!) {
  Org_create(data: $data) {
    Data {
      orgId
      orgName
      description
      allGroupUserId
      defaultAdminUserGroupId
      active
      deleted
      author
      created
    }
    Error
  }
}
    `);
export function useCreateOrgMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateOrgDocument, options);
}
export const UpdateOrgDocument = lazyGql(() => gql `
    mutation updateOrg($data: Org__UpdateInput!) {
  Org_update(data: $data) {
    Data {
      orgId
      orgName
      description
      allGroupUserId
      defaultAdminUserGroupId
      active
      deleted
      author
      created
    }
    Error
    Status
  }
}
    `);
export function useUpdateOrgMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateOrgDocument, options);
}
export const DeleteOrgDocument = lazyGql(() => gql `
    mutation deleteOrg($orgId: String!) {
  Org_delete(orgid: $orgId)
}
    `);
export function useDeleteOrgMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteOrgDocument, options);
}
export const CanDeleteOrgDocument = lazyGql(() => gql `
    mutation canDeleteOrg($orgId: String!) {
  Org_canDelete(orgid: $orgId) {
    Data {
      allowDelete
      reason
    }
    Error
  }
}
    `);
export function useCanDeleteOrgMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CanDeleteOrgDocument, options);
}
export const GetOrgDetailDocument = lazyGql(() => gql `
    query getOrgDetail($data: Org__DetailInput!) {
  getOrgDetail(data: $data) {
    Data {
      users {
        data {
          id
          name
        }
        totalCount
        isLastBatch
      }
      userGroups {
        data {
          id
          name
        }
        totalCount
        isLastBatch
      }
      featureFlags {
        groupName
        features
      }
    }
    Error
  }
}
    `);
export function useGetOrgDetailQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetOrgDetailDocument, options);
}
export function useGetOrgDetailLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetOrgDetailDocument, options);
}
export const GetPinboardListDocument = lazyGql(() => gql `
    query GetPinboardList($params: MetadataListParamsInput) {
  getPinboardList(params: $params) {
    objects {
      id
      name
    }
    isLastBatch
  }
}
    `);
export function useGetPinboardListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetPinboardListDocument, options);
}
export function useGetPinboardListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetPinboardListDocument, options);
}
export const LoadPinboardForTranslationDocument = lazyGql(() => gql `
    mutation LoadPinboardForTranslation($id: GUID!) {
  Pinboard__load(id: $id) {
    id {
      sessionId
    }
    pinboard {
      id
      name
      description
      containers {
        id
        name
        description
        type
        noteTile {
          htmlParsedString
        }
      }
      tabs {
        id
        name
      }
    }
  }
}
    `);
export function useLoadPinboardForTranslationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(LoadPinboardForTranslationDocument, options);
}
export const GetPersonalisedViewsDocument = lazyGql(() => gql `
    query GetPersonalisedViews($pinboardId: String!) {
  getPersonalisedViews(pinboardId: $pinboardId) {
    id
    name
  }
}
    `);
export function useGetPersonalisedViewsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetPersonalisedViewsDocument, options);
}
export function useGetPersonalisedViewsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetPersonalisedViewsDocument, options);
}
export const CreateRoleDocument = lazyGql(() => gql `
    mutation createRole($payload: CreateRole_DataInput!) {
  Role_create(inputData: $payload) {
    Data {
      id
      name
      description
      privileges
      readOnly
    }
    Status
    Error
  }
}
    `);
export function useCreateRoleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateRoleDocument, options);
}
export const UpdateRoleDocument = lazyGql(() => gql `
    mutation updateRole($payload: UpdateRole_DataInput!) {
  Role_update(inputData: $payload) {
    Data {
      id
      name
      description
      privileges
      readOnly
    }
    Status
    Error
  }
}
    `);
export function useUpdateRoleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateRoleDocument, options);
}
export const DeleteRoleDocument = lazyGql(() => gql `
    mutation deleteRole($id: String!) {
  Role_delete(id: $id)
}
    `);
export function useDeleteRoleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteRoleDocument, options);
}
export const DeleteRolesDocument = lazyGql(() => gql `
    mutation deleteRoles($ids: [String!]!) {
  Roles_delete(ids: $ids)
}
    `);
export function useDeleteRolesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteRolesDocument, options);
}
export const GetRolesDocument = lazyGql(() => gql `
    query getRoles($data: Role__ListInput!) {
  getRoles(data: $data) {
    Data {
      roles {
        id
        name
        description
        privileges
        author
        created
        modified
        isDeleted
        readOnly
        numberOfGroupsAssigned
      }
      isLastBatch
    }
    Status
    Error
  }
}
    `);
export function useGetRolesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetRolesDocument, options);
}
export function useGetRolesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetRolesDocument, options);
}
export const SearchRolesDocument = lazyGql(() => gql `
    query searchRoles($data: SearchRoles_Input) {
  searchRoles(data: $data) {
    Data {
      roles {
        id
        name
        description
        privileges
        groups {
          id
          name
        }
        permission
        author_id
        creation_time_in_millis
        modification_time_in_millis
        deleted
        hidden
      }
      isLastBatch
    }
    Status
    Error
  }
}
    `);
export function useSearchRolesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(SearchRolesDocument, options);
}
export function useSearchRolesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(SearchRolesDocument, options);
}
export const GetRoleByIdDocument = lazyGql(() => gql `
    query getRoleById($id: String!) {
  getRoleById(id: $id) {
    Data {
      id
      name
      description
      privileges
      readOnly
    }
    Status
    Error
  }
}
    `);
export function useGetRoleByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetRoleByIdDocument, options);
}
export function useGetRoleByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetRoleByIdDocument, options);
}
export const GetPrivilegeGroupsDocument = lazyGql(() => gql `
    query getPrivilegeGroups {
  getPrivilegeGroups {
    Data {
      groupName
      privileges
    }
    Status
    Error
  }
}
    `);
export function useGetPrivilegeGroupsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetPrivilegeGroupsDocument, options);
}
export function useGetPrivilegeGroupsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetPrivilegeGroupsDocument, options);
}
export const UploadMetatDataDocument = lazyGql(() => gql `
    mutation uploadMetatData($data: Admin__MetaDataFile!) {
  Saml_uploadMetaData(data: $data) {
    Data {
      ssoServices {
        binding
      }
      issuer
      certData {
        kid
      }
    }
  }
}
    `);
export function useUploadMetatDataMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UploadMetatDataDocument, options);
}
export const CreateSamlConnectionDocument = lazyGql(() => gql `
    mutation createSamlConnection($data: Admin__SamlConnection!) {
  Saml_createConnection(data: $data) {
    Data {
      name
      id
    }
  }
}
    `);
export function useCreateSamlConnectionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateSamlConnectionDocument, options);
}
export const CreateOidcConnectionDocument = lazyGql(() => gql `
    mutation createOidcConnection($data: Admin__Connection!) {
  OIDC_createConnection(data: $data) {
    Data {
      id
    }
  }
}
    `);
export function useCreateOidcConnectionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateOidcConnectionDocument, options);
}
export const SamlActDeactConnectionDocument = lazyGql(() => gql `
    mutation samlActDeactConnection($data: Saml_StateUpdate!) {
  Saml_updateConnectionStatus(data: $data) {
    Status
  }
}
    `);
export function useSamlActDeactConnectionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SamlActDeactConnectionDocument, options);
}
export const SamlDeleteConnectionDocument = lazyGql(() => gql `
    mutation samlDeleteConnection($data: Saml_DeleteConnData!) {
  Saml_deleteConnection(data: $data) {
    Status
  }
}
    `);
export function useSamlDeleteConnectionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SamlDeleteConnectionDocument, options);
}
export const UpdateSamlConnectionDocument = lazyGql(() => gql `
    mutation updateSamlConnection($data: Admin_SamlUpdate!) {
  Saml_updateConnection(data: $data) {
    Data {
      id
      name
      type
      status
      sso {
        url
        binding
      }
      issuer
      certData {
        x5c
      }
      requestSignatureAlgorithm
      responseSignatureAlgorithm
      maxClockSkew
    }
  }
}
    `);
export function useUpdateSamlConnectionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateSamlConnectionDocument, options);
}
export const UpdateOidcConnectionDocument = lazyGql(() => gql `
    mutation updateOIDCConnection($data: Admin__UpdateConnection!) {
  Oidc_updateConnection(data: $data) {
    Data {
      id
    }
  }
}
    `);
export function useUpdateOidcConnectionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateOidcConnectionDocument, options);
}
export const UpdateAttributeMappingDocument = lazyGql(() => gql `
    mutation updateAttributeMapping($data: Saml_UpdateAttributeMapping!) {
  Saml_updateAttributeMapping(data: $data) {
    Data {
      username
      email
      displayName
      locale
      timezone
      roles
      groupsWithOrg
      orgs
      defaultOrg
    }
  }
}
    `);
export function useUpdateAttributeMappingMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateAttributeMappingDocument, options);
}
export const UpdateMfaConifgDocument = lazyGql(() => gql `
    mutation updateMFAConifg($data: Update_Mfa_Config_Payload!) {
  Mfa_updateConfig(data: $data) {
    Data {
      groupName
      providerConfig {
        OKTA_OTP
        OKTA_PUSH
        GOOGLE_OTP
        OKTA_EMAIL
      }
    }
  }
}
    `);
export function useUpdateMfaConifgMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateMfaConifgDocument, options);
}
export const SetMfaTscliCommandDocument = lazyGql(() => gql `
    mutation setMFATscliCommand($featureName: String!, $params: Params!) {
  Admin_setTscliCommand(featureName: $featureName, params: $params) {
    Data {
      settings {
        configs {
          configName
          value
        }
      }
    }
    Error
  }
}
    `);
export function useSetMfaTscliCommandMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetMfaTscliCommandDocument, options);
}
export const CreateScimAuthTokenDocument = lazyGql(() => gql `
    mutation createScimAuthToken($viewMode: String!) {
  Admin_createScimAuthToken(viewMode: $viewMode) {
    Data {
      tokenAuthStatus
      token
      org
    }
    Error
  }
}
    `);
export function useCreateScimAuthTokenMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateScimAuthTokenDocument, options);
}
export const DeleteScimAuthTokenDocument = lazyGql(() => gql `
    mutation deleteScimAuthToken($viewMode: String!) {
  Admin_deleteScimAuthToken(viewMode: $viewMode) {
    Data {
      tokenAuthStatus
      token
      org
    }
    Error
  }
}
    `);
export function useDeleteScimAuthTokenMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteScimAuthTokenDocument, options);
}
export const SamlConnectionListDocument = lazyGql(() => gql `
    query samlConnectionList($data: Admin__ListConnection!) {
  Saml_getConnectionList(data: $data) {
    Data {
      samlList {
        id
        name
        type
        status
        sso {
          url
          binding
        }
        issuer
        certData {
          x5c
        }
        requestSignatureAlgorithm
        responseSignatureAlgorithm
        maxClockSkew
        connectionName
        scopes
        clientId
        clientSecret
        authorizationEndpoint
        tokenEndpoint
        userinfoEndpoint
        jwksEndpoint
        autoCreateUser
      }
    }
  }
}
    `);
export function useSamlConnectionListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(SamlConnectionListDocument, options);
}
export function useSamlConnectionListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(SamlConnectionListDocument, options);
}
export const ConfigCallDocument = lazyGql(() => gql `
    query configCall {
  Config_Query {
    Data {
      clientId
      externalAuth
    }
  }
}
    `);
export function useConfigCallQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(ConfigCallDocument, options);
}
export function useConfigCallLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(ConfigCallDocument, options);
}
export const Saml_DownloadDocument = lazyGql(() => gql `
    query Saml_Download($data: Saml_DeleteConnData!) {
  Saml_downloadMetadata(data: $data) {
    Status
  }
}
    `);
export function useSaml_DownloadQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(Saml_DownloadDocument, options);
}
export function useSaml_DownloadLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(Saml_DownloadDocument, options);
}
export const GetSamlConnectionDocument = lazyGql(() => gql `
    query getSamlConnection($data: Saml_DeleteConnData!) {
  Saml_getConnection(data: $data) {
    Data {
      id
      name
      type
      status
      sso {
        url
        binding
      }
      issuer
      certData {
        x5c
      }
      requestSignatureAlgorithm
      responseSignatureAlgorithm
      maxClockSkew
    }
  }
}
    `);
export function useGetSamlConnectionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSamlConnectionDocument, options);
}
export function useGetSamlConnectionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSamlConnectionDocument, options);
}
export const GetSamlMetadataInfoDocument = lazyGql(() => gql `
    query getSamlMetadataInfo($data: Saml_MetadataProperties!) {
  Saml_metadataInfo(data: $data) {
    Data {
      acsUrl
      audienceUri
    }
    Error
  }
}
    `);
export function useGetSamlMetadataInfoQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSamlMetadataInfoDocument, options);
}
export function useGetSamlMetadataInfoLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSamlMetadataInfoDocument, options);
}
export const GetAttributeMappingDocument = lazyGql(() => gql `
    query getAttributeMapping($data: Saml_MapAttributeProperties!) {
  Saml_getAttributeMapping(data: $data) {
    Data {
      username
      email
      displayName
      locale
      timezone
      roles
      groupsWithOrg
      orgs
      defaultOrg
    }
    Error
  }
}
    `);
export function useGetAttributeMappingQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAttributeMappingDocument, options);
}
export function useGetAttributeMappingLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAttributeMappingDocument, options);
}
export const GetOidcAttributeMappingsDocument = lazyGql(() => gql `
    query getOIDCAttributeMappings($data: Get_Attribute_Mappings_Params!) {
  OIDC_getMappings(data: $data) {
    Data {
      username
      email
      timezone
      locale
      roles
      groupsWithOrg
      defaultOrg
      orgs
      displayName
    }
  }
}
    `);
export function useGetOidcAttributeMappingsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetOidcAttributeMappingsDocument, options);
}
export function useGetOidcAttributeMappingsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetOidcAttributeMappingsDocument, options);
}
export const GetMfaConfigDocument = lazyGql(() => gql `
    query getMfaConfig($data: Get_Mfa_Config_Payload!) {
  Mfa__GetConfigInfo(data: $data) {
    Data {
      groupName
      providerConfig {
        OKTA_OTP
        OKTA_PUSH
        GOOGLE_OTP
        OKTA_EMAIL
      }
    }
  }
}
    `);
export function useGetMfaConfigQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetMfaConfigDocument, options);
}
export function useGetMfaConfigLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetMfaConfigDocument, options);
}
export const GetScimAuthTokenDocument = lazyGql(() => gql `
    query getScimAuthToken($viewMode: String!) {
  Admin_getScimAuthToken(viewMode: $viewMode) {
    Data {
      tokenAuthStatus
      token
      org
    }
    Error
  }
}
    `);
export function useGetScimAuthTokenQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetScimAuthTokenDocument, options);
}
export function useGetScimAuthTokenLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetScimAuthTokenDocument, options);
}
export const GetIdpConfigDocument = lazyGql(() => gql `
    query getIdpConfig($viewMode: String!) {
  Admin_getIdpConfig(viewMode: $viewMode) {
    Data {
      enableAllConnectionsOnLoginPage
      defaultConnectionId
    }
    Error
  }
}
    `);
export function useGetIdpConfigQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetIdpConfigDocument, options);
}
export function useGetIdpConfigLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetIdpConfigDocument, options);
}
export const SetIdpConfigEnableAllDocument = lazyGql(() => gql `
    mutation setIdpConfigEnableAll($viewMode: String!, $enableAllConnectionsOnLoginPage: Boolean!) {
  Admin_setIdpConfigEnableAll(
    viewMode: $viewMode
    enableAllConnectionsOnLoginPage: $enableAllConnectionsOnLoginPage
  ) {
    Data {
      enableAllConnectionsOnLoginPage
      defaultConnectionId
    }
    Error
  }
}
    `);
export function useSetIdpConfigEnableAllMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetIdpConfigEnableAllDocument, options);
}
export const SetIdpConfigDefaultConnectionDocument = lazyGql(() => gql `
    mutation setIdpConfigDefaultConnection($viewMode: String!, $defaultConnectionId: String!) {
  Admin_setIdpConfigDefaultConnection(
    viewMode: $viewMode
    defaultConnectionId: $defaultConnectionId
  ) {
    Data {
      enableAllConnectionsOnLoginPage
      defaultConnectionId
    }
    Error
  }
}
    `);
export function useSetIdpConfigDefaultConnectionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetIdpConfigDefaultConnectionDocument, options);
}
export const DoLogoutDocument = lazyGql(() => gql `
    mutation DoLogout {
  Session__doLogout {
    Data
    Error
  }
}
    `);
export function useDoLogoutMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DoLogoutDocument, options);
}
export const IsSessionActiveDocument = lazyGql(() => gql `
    query isSessionActive {
  isSessionActive {
    status
    statusText
  }
}
    `);
export function useIsSessionActiveQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(IsSessionActiveDocument, options);
}
export function useIsSessionActiveLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(IsSessionActiveDocument, options);
}
export const SwitchOrgDocument = lazyGql(() => gql `
    mutation switchOrg($orgId: String!) {
  Session__switchOrg(orgid: $orgId)
}
    `);
export function useSwitchOrgMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SwitchOrgDocument, options);
}
export const InvalidateUsersDocument = lazyGql(() => gql `
    mutation invalidateUsers($ids: [String!]!, $isAllOrgContext: Boolean) {
  Session__invalidateUsers(ids: $ids, isAllOrgContext: $isAllOrgContext)
}
    `);
export function useInvalidateUsersMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(InvalidateUsersDocument, options);
}
export const SetBannerConfigDocument = lazyGql(() => gql `
    mutation setBannerConfig($level: BannerLevel!, $bannerData: BannerInput!) {
  Session__setBannerConfig(level: $level, bannerData: $bannerData)
}
    `);
export function useSetBannerConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetBannerConfigDocument, options);
}
export const GetBannerConfigDocument = lazyGql(() => gql `
    query getBannerConfig($level: BannerLevel!) {
  getBannerConfig(level: $level) {
    banner {
      content
      type
      linkText
      linkUrl
      startTime
      endTime
      enabled
      version
    }
  }
}
    `);
export function useGetBannerConfigQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetBannerConfigDocument, options);
}
export function useGetBannerConfigLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetBannerConfigDocument, options);
}
export const DeleteBannerConfigDocument = lazyGql(() => gql `
    mutation deleteBannerConfig($level: BannerLevel!) {
  Session__deleteBannerConfig(level: $level)
}
    `);
export function useDeleteBannerConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteBannerConfigDocument, options);
}
export const GetUserAccessibleOrgsDocument = lazyGql(() => gql `
    query getUserAccessibleOrgs {
  getUserAccessibleOrgs {
    Data {
      orgs {
        orgId
        orgName
        description
        allUserGroupId
        defaultAdminUserGroupId
        privileges
        isActive
      }
      canAdministerAllOrgs
      currentOrgId
    }
    Error
  }
}
    `);
export function useGetUserAccessibleOrgsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserAccessibleOrgsDocument, options);
}
export function useGetUserAccessibleOrgsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserAccessibleOrgsDocument, options);
}
export const GetSidebarConfigDocument = lazyGql(() => gql `
    query GetSidebarConfig($viewMode: String) {
  Admin_getSidebarConfig(viewMode: $viewMode) {
    Data {
      sections {
        title
        items
        itemTabs {
          id
          tabs
        }
      }
    }
    Error
  }
}
    `);
export function useGetSidebarConfigQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSidebarConfigDocument, options);
}
export function useGetSidebarConfigLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSidebarConfigDocument, options);
}
export const GetStatusDocument = lazyGql(() => gql `
    query GetStatus($viewMode: String, $orgsEnabled: Boolean) {
  Admin_getStatus(viewMode: $viewMode, orgsEnabled: $orgsEnabled) {
    Data {
      status {
        org_management {
          org
          content
        }
        user_management {
          users
          groups
          roles
        }
        authentication {
          internal_auth
          active_dir
          saml
        }
        system_activities {
          user_activity
          app_performance
          content_activities
          object_usages
          indexing_queries
          ai_bi_liveboard
        }
        application_settings {
          onboarding
          search
          action_customization
          help_customization
          style_customization
          embed_ui_customisation
          chart_customization
          csv_upload
          early_access_feature
          version_control_system
          sage_feature
          data_modelling
          downloads_and_schedules
          administration
          homepage_and_discovery
          email_customizations
          variables
          feature_management
          config_management
        }
        billing {
          credit_consumption
          query_stats
        }
        system {
          alerts
          backup
          cluster_details
          scheduled_maintenance
          smtp
          upgrade
          system_information
          table_status
          user_agreement
          security {
            ssl
            rev_ssh
          }
          backup_storage {
            nas
            snapshot
          }
        }
        tscli_ui
      }
    }
    bothTabsDisplayed
    Error
  }
}
    `);
export function useGetStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetStatusDocument, options);
}
export function useGetStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetStatusDocument, options);
}
export const GetVendorsListDocument = lazyGql(() => gql `
    query getVendorsList {
  SpotIQ__getVendorsList {
    Data
    Status
    Error
  }
}
    `);
export function useGetVendorsListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetVendorsListDocument, options);
}
export function useGetVendorsListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetVendorsListDocument, options);
}
export const GetIntegrationsListDocument = lazyGql(() => gql `
    query getIntegrationsList {
  SpotIQ__getIntegrationsList {
    Data {
      integrationId
      vendor
      vendorName
      endPointUrl
      apiKey
      integrationName
      createdAt
      updatedAt
    }
    Status
    Error
  }
}
    `);
export function useGetIntegrationsListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetIntegrationsListDocument, options);
}
export function useGetIntegrationsListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetIntegrationsListDocument, options);
}
export const SetIntegrationDocument = lazyGql(() => gql `
    mutation setIntegration($payload: SpotIQSetIntegrationInput!) {
  SpotIQ__setIntegration(data: $payload) {
    Data {
      integrationId
      vendor
      vendorName
      endPointUrl
      apiKey
      integrationName
      createdAt
      updatedAt
    }
    Status
    Error
  }
}
    `);
export function useSetIntegrationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetIntegrationDocument, options);
}
export const GetStatsDocument = lazyGql(() => gql `
    query getStats {
  Admin_getStats {
    cluster_name
    release_name
    last_update_time_since_epoch
    node_info {
      node_name
      ipmi_address
      start_time_since_epoch
      service_unit_info {
        service_unit_name
        status
        start_time
      }
    }
    cluster_id
    config {
      oreo_port
      orion_master_port
      zoo_server {
        host
        port
      }
      hdfs {
        default_cluster {
          name_service
          name_node {
            host
            port
          }
          root
        }
      }
      relative_pack_dir
      installer_spec {
        remote_root
        log_file
      }
      installer_config {
        service_name
        file_name
        setup_script
      }
      oreo_config {
        service_name
        file_name
        setup_script
      }
      orion_master_config {
        service_name
        file_name
        setup_script
      }
      monitoring {
        config {
          cluster_alert_email
          heartbeat_interval_seconds
        }
      }
      version {
        major
        minor
      }
      id {
        name
        id
        display_name
      }
      release {
        name
      }
      release_dir
      snapshot_dir
      stats {
        varz_interval_seconds
        cluster_stats_service {
          orion_address {
            service_name
            task_name
            port_name
          }
        }
        falcon_config {
          falcon_manager {
            orion_address {
              service_name
              task_name
              port_name
            }
          }
          falcon_worker {
            orion_address {
              service_name
              task_name
              port_name
            }
          }
          db_name
          schema_name
          load_interval_seconds
        }
      }
      log_manager_config {
        active {
          compress_after_secs
          delete_after_secs
          archive_threshold_bytes
          move_before_deletion
        }
        inactive {
          compress_after_secs
          delete_after_secs
          archive_threshold_bytes
          move_before_deletion
        }
        space_quota_percentage
      }
      alert_manager_config {
        service_name
        file_name
        setup_script
      }
      kvstore_zoo_dir
      kvstore_hdfs_dir
      release_cache_dir
    }
    log {
      event {
        timestamp_seconds
        type
        attribute {
          key
          value
        }
      }
    }
    monitoring {
      config {
        cluster_alert_email
        heartbeat_interval_seconds
      }
    }
    periodic_snapshot {
      schedule {
        period {
          number
          unit
        }
        retention_policy {
          bucket {
            time {
              number
              unit
            }
            capacity
          }
        }
        offset_minutes_from_sunday_midnight
      }
      enabled
    }
    heterogeneous
    node_group {
      node_info {
        machine {
          memory {
            size_kb
          }
          cpu {
            size
          }
          cloud_provider {
            provider_name
          }
        }
      }
      count
    }
  }
}
    `);
export function useGetStatsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetStatsDocument, options);
}
export function useGetStatsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetStatsDocument, options);
}
export const GetClusterInfoDocument = lazyGql(() => gql `
    query getClusterInfo {
  Admin_getClusterInfo {
    heterogeneous
    persistentStorage
    cloudProvider
    nodes {
      node_info {
        machine {
          memory {
            size_kb
          }
          cpu {
            size
          }
          cloud_provider {
            provider_name
          }
        }
      }
      count
    }
  }
}
    `);
export function useGetClusterInfoQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetClusterInfoDocument, options);
}
export function useGetClusterInfoLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetClusterInfoDocument, options);
}
export const GetListSnapshotsDocument = lazyGql(() => gql `
    query getListSnapshots {
  Admin_getListSnapshots {
    periodic_snapshot {
      name
      reason
      start_timestamp_seconds
      finish_timestamp_seconds
      size_bytes
      lw_size_bytes
      dataless_size_bytes
      storage_snapshot_name
    }
  }
}
    `);
export function useGetListSnapshotsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetListSnapshotsDocument, options);
}
export function useGetListSnapshotsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetListSnapshotsDocument, options);
}
export const SignEulaDocument = lazyGql(() => gql `
    mutation signEula($emailId: String!) {
  Admin_signEula(emailId: $emailId) {
    Data {
      Message
      org_id
    }
    Error
  }
}
    `);
export function useSignEulaMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SignEulaDocument, options);
}
export const GetEulaListDocument = lazyGql(() => gql `
    query getEulaList {
  Admin_getEulaList {
    Data {
      eula {
        version
        grace_period
        grace_period_start_time
        reminder1
        reminder2
        reminder3
        is_signed
        signed_date
        signed_email
        signed_user_id
        file_path
        sent_reminder
        product_type
      }
      acceptance_required
      org_id
    }
    Error
  }
}
    `);
export function useGetEulaListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetEulaListDocument, options);
}
export function useGetEulaListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetEulaListDocument, options);
}
export const SetHelpConfigDocument = lazyGql(() => gql `
    mutation SetHelpConfig($inputData: HelpConfigInfoInput!) {
  Actions_addHelpConfig(inputData: $inputData) {
    Data {
      id
      enabled
      title
      url
      iconFilePath
    }
    Error
  }
}
    `);
export function useSetHelpConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetHelpConfigDocument, options);
}
export const SetEditHelpConfigDocument = lazyGql(() => gql `
    mutation SetEditHelpConfig($inputData: HelpConfigInfoInput!) {
  Actions_editHelpConfig(inputData: $inputData) {
    Data {
      id
      enabled
      title
      url
      iconFilePath
    }
    Error
  }
}
    `);
export function useSetEditHelpConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetEditHelpConfigDocument, options);
}
export const DeleteHelpConfigDocument = lazyGql(() => gql `
    mutation DeleteHelpConfig($id: String!) {
  Actions_deleteHelpConfig(id: $id) {
    Data {
      id
      enabled
      title
      url
      iconFilePath
    }
    Error
  }
}
    `);
export function useDeleteHelpConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteHelpConfigDocument, options);
}
export const ResetHelpConfigDocument = lazyGql(() => gql `
    mutation ResetHelpConfig {
  Actions_resetHelpConfig {
    Data {
      id
      enabled
      title
      url
      iconFilePath
    }
    Error
  }
}
    `);
export function useResetHelpConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ResetHelpConfigDocument, options);
}
export const SetSmtpDocument = lazyGql(() => gql `
    mutation SetSmtp($data: Admin__SetSmtpInput!) {
  Admin_setSmtp(data: $data) {
    Data {
      configured_status
      is_host_reachable
      from_name
      mail_from
      port_number
      real_name
      relay_host
      smtp_auth_status
    }
    Error
  }
}
    `);
export function useSetSmtpMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetSmtpDocument, options);
}
export const SetRevSshDocument = lazyGql(() => gql `
    mutation SetRevSsh($data: Admin__SetRevSshInput!) {
  Admin_setRevSsh(data: $data) {
    Data {
      configured_status
      reverse_ssh_status
    }
    Error
  }
}
    `);
export function useSetRevSshMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetRevSshDocument, options);
}
export const SetNasDocument = lazyGql(() => gql `
    mutation SetNas($data: Admin__SetNasInput!) {
  Admin_setNas(data: $data) {
    Data {
      server_address
      path_on_server
      mount_point
      mount_type
      status
    }
    Error
  }
}
    `);
export function useSetNasMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetNasDocument, options);
}
export const SetSnapshotDocument = lazyGql(() => gql `
    mutation SetSnapshot($data: Admin__SetSnapshotInput!) {
  Admin_setSnapshot(data: $data) {
    Data {
      name
      start_timestamp_seconds
      snapshotStatus
      type
    }
    Error
  }
}
    `);
export function useSetSnapshotMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetSnapshotDocument, options);
}
export const SetSslDocument = lazyGql(() => gql `
    mutation SetSsl($data: Admin__SetSslInput!) {
  Admin_setSsl(data: $data) {
    Data {
      ssl_status
      tls_version
      is_configured
      ssl_info {
        signature_algorithm
        signing_algorithm
        not_after
        organization
        organizational_unit
        company_name
        state
        country
        location
      }
    }
    Error
  }
}
    `);
export function useSetSslMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetSslDocument, options);
}
export const DeleteSmtpDocument = lazyGql(() => gql `
    mutation DeleteSmtp {
  Admin_deleteSmtp {
    Data {
      configured_status
      is_host_reachable
      from_name
      mail_from
      port_number
      real_name
      relay_host
      smtp_auth_status
    }
    Error
  }
}
    `);
export function useDeleteSmtpMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteSmtpDocument, options);
}
export const DeleteSslDocument = lazyGql(() => gql `
    mutation DeleteSsl {
  Admin_deleteSsl {
    Data {
      ssl_status
      tls_version
      is_configured
      ssl_info {
        signature_algorithm
        signing_algorithm
        not_after
        organization
        organizational_unit
        company_name
        state
        country
        location
      }
    }
    Error
  }
}
    `);
export function useDeleteSslMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteSslDocument, options);
}
export const DeleteNasDocument = lazyGql(() => gql `
    mutation DeleteNas($data: Admin__DeleteNasInput!) {
  Admin_deleteNas(data: $data) {
    Data {
      server_address
      path_on_server
      mount_point
      mount_type
      status
    }
    Error
  }
}
    `);
export function useDeleteNasMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteNasDocument, options);
}
export const DeleteSnapshotDocument = lazyGql(() => gql `
    mutation DeleteSnapshot($snapshotName: String!) {
  Admin_deleteSnapshot(snapshotName: $snapshotName) {
    Data {
      name
      start_timestamp_seconds
      snapshotStatus
      type
    }
    Error
  }
}
    `);
export function useDeleteSnapshotMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteSnapshotDocument, options);
}
export const DeleteSamlIamV1Document = lazyGql(() => gql `
    mutation DeleteSamlIamV1 {
  Admin_deleteSaml {
    Data {
      server_name
      protocol
      server_port
      service_name
      response_skew
      idp_metadata
      enable_saml
      automatically_create_users
    }
    Error
  }
}
    `);
export function useDeleteSamlIamV1Mutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteSamlIamV1Document, options);
}
export const SetLocalIamV1Document = lazyGql(() => gql `
    mutation SetLocalIamV1($data: Admin__SetLocalInput!) {
  Admin_setLocal(data: $data) {
    Error
    Data {
      status
    }
  }
}
    `);
export function useSetLocalIamV1Mutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetLocalIamV1Document, options);
}
export const SetLdapAdIamV1Document = lazyGql(() => gql `
    mutation SetLdapAdIamV1($data: Admin__SetLdapAdInput!) {
  Admin_setLdapAd(data: $data) {
    Data {
      automatically_create_users
      domain
      enable_ldap
      is_configured
      search_base
      ssl
      url
    }
    Error
  }
}
    `);
export function useSetLdapAdIamV1Mutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetLdapAdIamV1Document, options);
}
export const DeleteLdapAdIamV1Document = lazyGql(() => gql `
    mutation DeleteLdapAdIamV1 {
  Admin_deleteLdapAd {
    Data {
      automatically_create_users
      domain
      enable_ldap
      is_configured
      search_base
      ssl
      url
    }
    Error
  }
}
    `);
export function useDeleteLdapAdIamV1Mutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteLdapAdIamV1Document, options);
}
export const CheckSslCertDocument = lazyGql(() => gql `
    mutation CheckSSLCert($url: String!) {
  Admin_checkSSLCert(url: $url) {
    Data
    Error
  }
}
    `);
export function useCheckSslCertMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CheckSslCertDocument, options);
}
export const UpdateConfigInfoDocument = lazyGql(() => gql `
    mutation UpdateConfigInfo($changes: JSON!) {
  Admin_updateConfigInfo(changes: $changes) {
    Data
    Error
  }
}
    `);
export function useUpdateConfigInfoMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateConfigInfoDocument, options);
}
export const GetHelpConfigListDocument = lazyGql(() => gql `
    query getHelpConfigList {
  Actions_getHelpConfig {
    Data {
      id
      enabled
      title
      url
      iconFilePath
    }
    Error
  }
}
    `);
export function useGetHelpConfigListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetHelpConfigListDocument, options);
}
export function useGetHelpConfigListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetHelpConfigListDocument, options);
}
export const GetReleaseVersionDocument = lazyGql(() => gql `
    query getReleaseVersion {
  Actions_getReleaseVersion {
    Data
    Error
  }
}
    `);
export function useGetReleaseVersionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetReleaseVersionDocument, options);
}
export function useGetReleaseVersionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetReleaseVersionDocument, options);
}
export const GetSmtpDocument = lazyGql(() => gql `
    query GetSmtp {
  Admin_getSmtp {
    Data {
      configured_status
      is_host_reachable
      from_name
      mail_from
      port_number
      real_name
      relay_host
      smtp_auth_status
    }
    Error
  }
}
    `);
export function useGetSmtpQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSmtpDocument, options);
}
export function useGetSmtpLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSmtpDocument, options);
}
export const GetSslDocument = lazyGql(() => gql `
    query GetSsl {
  Admin_getSsl {
    Data {
      ssl_status
      tls_version
      is_configured
      ssl_info {
        signature_algorithm
        signing_algorithm
        not_after
        organization
        organizational_unit
        company_name
        state
        country
        location
      }
    }
    Error
  }
}
    `);
export function useGetSslQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSslDocument, options);
}
export function useGetSslLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSslDocument, options);
}
export const GetRevSshDocument = lazyGql(() => gql `
    query GetRevSsh {
  Admin_getRevSsh {
    Data {
      configured_status
      reverse_ssh_status
    }
    Error
  }
}
    `);
export function useGetRevSshQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetRevSshDocument, options);
}
export function useGetRevSshLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetRevSshDocument, options);
}
export const GetNasDocument = lazyGql(() => gql `
    query GetNas {
  Admin_getNas {
    Data {
      server_address
      path_on_server
      mount_point
      mount_type
      status
    }
    Error
  }
}
    `);
export function useGetNasQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetNasDocument, options);
}
export function useGetNasLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetNasDocument, options);
}
export const GetSnapshotDocument = lazyGql(() => gql `
    query GetSnapshot {
  Admin_getSnapshot {
    Data {
      name
      start_timestamp_seconds
      snapshotStatus
      type
    }
    Error
  }
}
    `);
export function useGetSnapshotQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSnapshotDocument, options);
}
export function useGetSnapshotLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSnapshotDocument, options);
}
export const GetSamlIamV1Document = lazyGql(() => gql `
    query GetSamlIamV1 {
  Admin_getSaml {
    Data {
      automatically_create_users
      enable_saml
      idp_metadata
      protocol
      response_skew
      server_name
      server_port
      service_name
    }
    Error
  }
}
    `);
export function useGetSamlIamV1Query(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSamlIamV1Document, options);
}
export function useGetSamlIamV1LazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSamlIamV1Document, options);
}
export const GetLocalIamV1Document = lazyGql(() => gql `
    query getLocalIamV1 {
  Admin_getLocal {
    Data {
      status
    }
    Error
  }
}
    `);
export function useGetLocalIamV1Query(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLocalIamV1Document, options);
}
export function useGetLocalIamV1LazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLocalIamV1Document, options);
}
export const GetLdapAdIamV1Document = lazyGql(() => gql `
    query getLdapAdIamV1 {
  Admin_getLdapAd {
    Error
    Data {
      automatically_create_users
      domain
      enable_ldap
      is_configured
      search_base
      ssl
      url
    }
  }
}
    `);
export function useGetLdapAdIamV1Query(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLdapAdIamV1Document, options);
}
export function useGetLdapAdIamV1LazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLdapAdIamV1Document, options);
}
export const GetAdminAlertsDocument = lazyGql(() => gql `
    query getAdminAlerts {
  Admin_getAlerts {
    total_alerts
    alert {
      id
      guid
      at
      system_info {
        msg
      }
    }
  }
}
    `);
export function useGetAdminAlertsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAdminAlertsDocument, options);
}
export function useGetAdminAlertsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAdminAlertsDocument, options);
}
export const GetAdminEventsDocument = lazyGql(() => gql `
    query getAdminEvents {
  Admin_getEvents {
    event {
      system_info {
        at
      }
      user
      summary
      type
    }
  }
}
    `);
export function useGetAdminEventsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAdminEventsDocument, options);
}
export function useGetAdminEventsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAdminEventsDocument, options);
}
export const GetConfigInfoOverridesDocument = lazyGql(() => gql `
    query GetConfigInfoOverrides {
  Admin_getConfigInfoOverrides {
    Data
    Error
  }
}
    `);
export function useGetConfigInfoOverridesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetConfigInfoOverridesDocument, options);
}
export function useGetConfigInfoOverridesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetConfigInfoOverridesDocument, options);
}
export const GetFalconSummaryDocument = lazyGql(() => gql `
    query getFalconSummary {
  Admin_getFalconSummary {
    status
    numTables
    numRows
    numReady
    numInProgress
    numStale
    numError
    lastUpdateTime
    numLoadedInLastDay
    sizeInBytes
    uncompressedSizeInBytes
  }
}
    `);
export function useGetFalconSummaryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetFalconSummaryDocument, options);
}
export function useGetFalconSummaryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetFalconSummaryDocument, options);
}
export const GetSageSummaryDocument = lazyGql(() => gql `
    query getSageSummary {
  Admin_getSageSummary {
    status
    errorReason
    pendingTime
    numReady
    numBuildingAndServing
    numBuildingAndNotServing
    numKnownTables
    numWillNotIndex
    numWillRemove
    lastBuildFinish
    numberActiveWorkers
    numberIndexedTokens
    sizeIndexedTokens
  }
}
    `);
export function useGetSageSummaryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSageSummaryDocument, options);
}
export function useGetSageSummaryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSageSummaryDocument, options);
}
export const AdminCombinedNodeInfoDocument = lazyGql(() => gql `
    query adminCombinedNodeInfo {
  Admin_combinedNodeInfo {
    nodes {
      id
      ip
      ramdisk
      capacity
    }
  }
}
    `);
export function useAdminCombinedNodeInfoQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(AdminCombinedNodeInfoDocument, options);
}
export function useAdminCombinedNodeInfoLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(AdminCombinedNodeInfoDocument, options);
}
export const AdminCombinedTableInfoDocument = lazyGql(() => gql `
    query adminCombinedTableInfo($node: String) {
  Admin_combinedTableInfo(node: $node) {
    tables {
      database
      schema
      name
      guid
      state
      databaseVersion
      servingVersion
      buildingVersion
      buildDuration
      lastBuildTime
      isKnown
      databaseStatus
      lastUploadedAt
      numOfRows
      approxByteSize
      uncompressedByteSize
      rowSkew
      numShards
      csvSizeWithReplicationMB
      replicated
      ip
    }
  }
}
    `);
export function useAdminCombinedTableInfoQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(AdminCombinedTableInfoDocument, options);
}
export function useAdminCombinedTableInfoLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(AdminCombinedTableInfoDocument, options);
}
export const SetTscliCommandDocument = lazyGql(() => gql `
    mutation setTscliCommand($featureName: String!, $params: Params!, $viewMode: String) {
  Admin_setTscliCommand(
    featureName: $featureName
    params: $params
    viewMode: $viewMode
  ) {
    Data {
      groupName
      settings {
        settingName
        resetToDefault
        learnMore {
          url
          newWindow
        }
        actions {
          type
        }
        configs {
          configName
          elementType
          elementConfig {
            type
            groups {
              options
            }
          }
          value
          infoTooltip
        }
      }
    }
    Error
  }
}
    `);
export function useSetTscliCommandMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetTscliCommandDocument, options);
}
export const GetFeatureDocument = lazyGql(() => gql `
    query GetFeature($featureName: String!, $viewMode: String) {
  Admin_getFeature(featureName: $featureName, viewMode: $viewMode) {
    Data {
      groupName
      settings {
        settingName
        resetToDefault
        learnMore {
          url
          newWindow
        }
        actions {
          type
        }
        configs {
          configName
          elementType
          elementConfig {
            type
            groups {
              options
            }
          }
          value
          validation {
            required
            regex
            isNumeric
            range
            minLength
            maxLength
          }
          infoTooltip
          orgAware
        }
      }
    }
    Error
  }
}
    `);
export function useGetFeatureQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetFeatureDocument, options);
}
export function useGetFeatureLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetFeatureDocument, options);
}
export const GetUsersPrincipalListDocument = lazyGql(() => gql `
    query GetUsersPrincipalList($data: MetadataListParamsInput) {
  getUsersPrincipalList(params: $data) {
    objects {
      id
      name
      displayName
      type
      orgIds
      created
      statistics {
        userState
      }
    }
    isLastBatch
  }
}
    `);
export function useGetUsersPrincipalListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUsersPrincipalListDocument, options);
}
export function useGetUsersPrincipalListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUsersPrincipalListDocument, options);
}
export const SendWelcomeEmailDocument = lazyGql(() => gql `
    mutation SendWelcomeEmail($id: String!, $message: String!, $resend: Boolean!) {
  Metadata_sendWelcomeEmail(id: $id, message: $message, resend: $resend)
}
    `);
export function useSendWelcomeEmailMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SendWelcomeEmailDocument, options);
}
export const GenerateOtpDocument = lazyGql(() => gql `
    mutation GenerateOtp($userId: String!) {
  Session__generateOtp(userId: $userId)
}
    `);
export function useGenerateOtpMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateOtpDocument, options);
}
export const ResendGroupWelcomeEmailDocument = lazyGql(() => gql `
    mutation ResendGroupWelcomeEmail($id: String!, $message: String!, $resend: Boolean!) {
  Metadata_resendGroupWelcomeEmail(id: $id, message: $message, resend: $resend)
}
    `);
export function useResendGroupWelcomeEmailMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ResendGroupWelcomeEmailDocument, options);
}
export const GetUserGroupsPrincipalListDocument = lazyGql(() => gql `
    query GetUserGroupsPrincipalList($pattern: String, $skipIds: [String!], $batchSize: Float) {
  getUserGroupsPrincipalList(
    params: {pattern: $pattern, skipIds: $skipIds, batchSize: $batchSize}
  ) {
    objects {
      id
      name
      displayName
      numMemberUsers
      type
      orgIds
    }
  }
}
    `);
export function useGetUserGroupsPrincipalListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserGroupsPrincipalListDocument, options);
}
export function useGetUserGroupsPrincipalListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserGroupsPrincipalListDocument, options);
}
export const GetGroupsPrincipalListDocument = lazyGql(() => gql `
    query GetGroupsPrincipalList($data: MetadataListParamsInput) {
  getGroupsPrincipalList(params: $data) {
    objects {
      id
      name
      displayName
      numMemberUsers
      type
      numDefaultPinboards
      created
      description
    }
    isLastBatch
  }
}
    `);
export function useGetGroupsPrincipalListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetGroupsPrincipalListDocument, options);
}
export function useGetGroupsPrincipalListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetGroupsPrincipalListDocument, options);
}
export const GetUserAndGroupPrincipalListDocument = lazyGql(() => gql `
    query GetUserAndGroupPrincipalList($pattern: String, $skipIds: [String!], $isAllOrg: Boolean!) {
  getUsersPrincipalListForOrg(
    params: {pattern: $pattern, skipIds: $skipIds}
    isAllOrg: $isAllOrg
  ) {
    objects {
      id
      name
      displayName
      type
      orgIds
    }
  }
  getUserGroupsPrincipalListForOrg(
    params: {pattern: $pattern, skipIds: $skipIds}
    isAllOrg: $isAllOrg
  ) {
    objects {
      id
      name
      displayName
      numMemberUsers
      type
      orgIds
    }
  }
}
    `);
export function useGetUserAndGroupPrincipalListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserAndGroupPrincipalListDocument, options);
}
export function useGetUserAndGroupPrincipalListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserAndGroupPrincipalListDocument, options);
}
export const GetUserAndGroupsDocument = lazyGql(() => gql `
    query GetUserAndGroups($pattern: String, $skipIds: [String!], $batchSize: Float) {
  getUsersPrincipalList(
    params: {pattern: $pattern, skipIds: $skipIds, batchSize: $batchSize}
  ) {
    objects {
      id
      name
      displayName
      type
      orgIds
    }
  }
  getUserGroupsPrincipalList(
    params: {pattern: $pattern, skipIds: $skipIds, batchSize: $batchSize}
  ) {
    objects {
      id
      name
      displayName
      numMemberUsers
      type
      orgIds
    }
  }
}
    `);
export function useGetUserAndGroupsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserAndGroupsDocument, options);
}
export function useGetUserAndGroupsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserAndGroupsDocument, options);
}
export const GetGroupMembersDocument = lazyGql(() => gql `
    query GetGroupMembers($id: GUID!) {
  getGroupMembers(id: $id) {
    objects {
      id
      name
      displayName
    }
  }
}
    `);
export function useGetGroupMembersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetGroupMembersDocument, options);
}
export function useGetGroupMembersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetGroupMembersDocument, options);
}
export const GetUserDetailsByIdDocument = lazyGql(() => gql `
    query GetUserDetailsById($ids: [String!]!, $orgOverride: String) {
  getUserDetailById(ids: $ids, orgOverride: $orgOverride) {
    id
    userContent {
      userPreferences {
        notifyOnShare
        showWalkMe
        analystOnboardingComplete
        preferredLocale
      }
      userProperties {
        mail
        displayNameLastUpdatedBy
        persona
      }
      userActivityProto {
        first_login
        welcome_email_sent
      }
      oidcUserType
    }
    state
    assignedGroups
    inheritedGroups
    privileges
    type
    parenttype
    tenantId
    visibility
    displayName
    header {
      aiAnswerGenerationDisabled
      author
      created
      id
      indexVersion
      generationNum
      name
      type
      tags {
        author
        color
        id
        created
        modified
        name
        owner
      }
      description
      displayName
      isDeleted
      isDeprecated
      isExternal
      isHidden
      isSharedViaConnection
      modified
      modifiedBy
      orgIds
      owner
      belongToAllOrgs
      contentUpgradeId
      headerUpgradeId
    }
    complete
    incompleteDetail
    isSuperUser
    isSystemPrincipal
    state
  }
}
    `);
export function useGetUserDetailsByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserDetailsByIdDocument, options);
}
export function useGetUserDetailsByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserDetailsByIdDocument, options);
}
export const GetUserDetailsByIdWithUsersListDocument = lazyGql(() => gql `
    query GetUserDetailsByIdWithUsersList($ids: [String!]!, $id: String!, $orgOverride: String) {
  getUserDetailById(ids: $ids, orgOverride: $orgOverride) {
    id
    userContent {
      userPreferences {
        notifyOnShare
        showWalkMe
        analystOnboardingComplete
        preferredLocale
      }
      userProperties {
        mail
        displayNameLastUpdatedBy
        persona
      }
      userActivityProto {
        first_login
        welcome_email_sent
      }
      oidcUserType
    }
    state
    assignedGroups
    inheritedGroups
    privileges
    type
    parenttype
    tenantId
    visibility
    displayName
    header {
      aiAnswerGenerationDisabled
      author
      created
      id
      indexVersion
      generationNum
      name
      type
      tags {
        author
        color
        id
        created
        modified
        name
        owner
      }
      description
      displayName
      isDeleted
      isDeprecated
      isExternal
      isHidden
      isSharedViaConnection
      modified
      modifiedBy
      orgIds
      owner
      belongToAllOrgs
      contentUpgradeId
      headerUpgradeId
    }
    complete
    incompleteDetail
    isSuperUser
    isSystemPrincipal
    state
  }
  listUserGroupById(id: $id) {
    name
    displayName
    id
    visibility
    assignedGroups
    assignedRoles
    privileges
    granularPrivileges
  }
}
    `);
export function useGetUserDetailsByIdWithUsersListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserDetailsByIdWithUsersListDocument, options);
}
export function useGetUserDetailsByIdWithUsersListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserDetailsByIdWithUsersListDocument, options);
}
export const GetGroupDetailsByIdDocument = lazyGql(() => gql `
    query GetGroupDetailsById($ids: [String!]!, $id: String!) {
  getGroupDetailsById(ids: $ids) {
    id
    privileges
    publishAcrossOrgs
    relationships
    type
    isSystemPrincipal
    inheritedGroups
    assignedGroups
    authorName
    columns {
      author
      authorDisplayName
      created
      id
      name
      modifiedBy
      modified
      type
    }
    authorDisplayName
    created
    description
    isDeleted
    modifiedBy
    modified
    name
    owner
    displayName
    granularPrivileges
    assignedRoles
    assignedPinboards
    visibility
    parenttype
    userGroupContent
    groupIdx
    header {
      aiAnswerGenerationDisabled
      author
      created
      id
      indexVersion
      generationNum
      name
      type
      tags {
        author
        color
        id
        created
        modified
        name
        owner
      }
      description
      displayName
      isDeleted
      isDeprecated
      isExternal
      isHidden
      isSharedViaConnection
      modified
      modifiedBy
      orgIds
      owner
      contentUpgradeId
      headerUpgradeId
    }
    tenantId
    metadataVersion
    incompleteDetail
    complete
  }
  listUsersHeaderInGroupById(id: $id) {
    author
    created
    description
    displayName
    id
    isDeleted
    modified
    isHidden
    modifiedBy
    name
    orgIds
    type
  }
  listGroupsInGroupById(id: $id) {
    assignedGroups
    assignedPinboards
    assignedRoles
    header {
      created
      author
      description
      displayName
      id
      isDeleted
      isHidden
      modified
      modifiedBy
      name
      orgIds
      owner
      type
    }
  }
}
    `);
export function useGetGroupDetailsByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetGroupDetailsByIdDocument, options);
}
export function useGetGroupDetailsByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetGroupDetailsByIdDocument, options);
}
export const CreateGroupDocument = lazyGql(() => gql `
    mutation createGroup($params: CreateGroupInput!) {
  Session__createGroup(params: $params) {
    id
    name
    displayName
    visibility
    assignedGroups
    assignedRoles
    privileges
    granularPrivileges
  }
}
    `);
export function useCreateGroupMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateGroupDocument, options);
}
export const UpdateGroupDocument = lazyGql(() => gql `
    mutation updateGroup($params: UpdateGroupInput!) {
  Session__updateGroup(params: $params)
}
    `);
export function useUpdateGroupMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateGroupDocument, options);
}
export const DeleteGroupDocument = lazyGql(() => gql `
    mutation deleteGroup($ids: [String!]!) {
  Session__deleteGroups(ids: $ids)
}
    `);
export function useDeleteGroupMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteGroupDocument, options);
}
export const CreateUserDocument = lazyGql(() => gql `
    mutation createUser($params: CreateUserInput!) {
  Session__createUser(params: $params) {
    id
    name
    displayName
    state
    type
  }
}
    `);
export function useCreateUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateUserDocument, options);
}
export const UpdateUserDocument = lazyGql(() => gql `
    mutation updateUser($params: UpdateUsersInput!) {
  Session__updateUser(params: $params) {
    Data
    Error
  }
}
    `);
export function useUpdateUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateUserDocument, options);
}
export const Teams_ReInviteMemberDocument = lazyGql(() => gql `
    mutation Teams_reInviteMember($inviteeId: GUID!) {
  Teams_reInviteMember(inviteeId: $inviteeId)
}
    `);
export function useTeams_ReInviteMemberMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(Teams_ReInviteMemberDocument, options);
}
export const DeleteUserDocument = lazyGql(() => gql `
    mutation deleteUser($ids: [String!]!, $isAllOrgContext: Boolean) {
  Session__deleteUsers(ids: $ids, isAllOrgContext: $isAllOrgContext)
}
    `);
export function useDeleteUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteUserDocument, options);
}
export const GetEdocDocument = lazyGql(() => gql `
    query GetEdoc($objectsToExport: [EdocObjectInfo!]!, $shouldExportDependencies: Boolean!, $exportFQN: Boolean!, $allOrgsOverride: Boolean!, $includeObjId: Boolean!, $includeObjIdRef: Boolean!, $includeGuid: Boolean!) {
  Metadata__getEdoc(
    objectsToExport: $objectsToExport
    shouldExportDependencies: $shouldExportDependencies
    exportFQN: $exportFQN
    allOrgsOverride: $allOrgsOverride
    includeObjId: $includeObjId
    includeObjIdRef: $includeObjIdRef
    includeGuid: $includeGuid
  ) {
    zipFile
    object {
      edoc
      id
      name
      filename
      type
      statusCode
      errorMessage
    }
  }
}
    `);
export function useGetEdocQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetEdocDocument, options);
}
export function useGetEdocLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetEdocDocument, options);
}
export const GetDefaultLiveboardsDocument = lazyGql(() => gql `
    query getDefaultLiveboards($params: MetadataListAsParamsInput) {
  getMetadataListAs(params: $params) {
    isLastBatch
    objects {
      id
      name
      description
      author
      authorName
      authorDisplayName
      modifiedBy
      owner
      created
      modified
      type
      displayName
      isDeprecated
      numDefaultPinboards
    }
  }
}
    `);
export function useGetDefaultLiveboardsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetDefaultLiveboardsDocument, options);
}
export function useGetDefaultLiveboardsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetDefaultLiveboardsDocument, options);
}
export const GetOrgStatisticsDocument = lazyGql(() => gql `
    mutation GetOrgStatistics($type: String!, $allOrgs: Boolean) {
  Session__getOrgStatistics(type: $type, allOrgs: $allOrgs)
}
    `);
export function useGetOrgStatisticsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GetOrgStatisticsDocument, options);
}
export const AssignPinboardsToGroupDocument = lazyGql(() => gql `
    mutation assignPinboardsToGroup($ids: [String]!, $groupId: String!) {
  Session__assignPinboardsToGroup(ids: $ids, groupId: $groupId)
}
    `);
export function useAssignPinboardsToGroupMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AssignPinboardsToGroupDocument, options);
}
export const AssignUsersToGroupsFromUserDocument = lazyGql(() => gql `
    mutation assignUsersToGroupsFromUser($params: AssignUsersToGroupsInput!) {
  Session__assignUsersToGroupsFromUser(params: $params) {
    Data
    Error
  }
}
    `);
export function useAssignUsersToGroupsFromUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AssignUsersToGroupsFromUserDocument, options);
}
export const AddUsersToOrgDocument = lazyGql(() => gql `
    mutation addUsersToOrg($data: AddUsersToOrgInput!) {
  Session__addUsersToOrg(inputData: $data)
}
    `);
export function useAddUsersToOrgMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AddUsersToOrgDocument, options);
}
export const ResetMfaConifgDocument = lazyGql(() => gql `
    mutation resetMFAConifg($data: Reset_Mfa_Payload!) {
  Mfa_resetUserConfig(data: $data) {
    Status
  }
}
    `);
export function useResetMfaConifgMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ResetMfaConifgDocument, options);
}
export const SearchUsersV2Document = lazyGql(() => gql `
    query SearchUsersV2($name_pattern: String, $record_offset: Int, $record_size: Int, $sort_options: Users__SortOptions, $group_identifiers: [String], $org_identifiers: [String], $account_status: Users__AccountStatus) {
  Users__searchUsers(
    name_pattern: $name_pattern
    record_offset: $record_offset
    record_size: $record_size
    sort_options: $sort_options
    group_identifiers: $group_identifiers
    org_identifiers: $org_identifiers
    account_status: $account_status
  ) {
    isLastBatch
    data {
      id
      name
      display_name
      email
      account_status
      account_type
      creation_time_in_millis
      user_groups {
        id
        name
      }
      orgs {
        id
        name
      }
    }
  }
}
    `);
export function useSearchUsersV2Query(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(SearchUsersV2Document, options);
}
export function useSearchUsersV2LazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(SearchUsersV2Document, options);
}
export const CheckUserNameExistsDocument = lazyGql(() => gql `
    query CheckUserNameExists($user_identifier: String, $org_identifiers: [String]) {
  Users__searchUsers(
    user_identifier: $user_identifier
    org_identifiers: $org_identifiers
    record_size: 1
  ) {
    data {
      id
    }
  }
}
    `);
export function useCheckUserNameExistsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(CheckUserNameExistsDocument, options);
}
export function useCheckUserNameExistsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(CheckUserNameExistsDocument, options);
}
export const CheckGroupNameExistsDocument = lazyGql(() => gql `
    query CheckGroupNameExists($group_identifier: String, $org_identifiers: [String]) {
  Groups__searchGroups(
    group_identifier: $group_identifier
    org_identifiers: $org_identifiers
    record_size: 1
  ) {
    data {
      id
    }
  }
}
    `);
export function useCheckGroupNameExistsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(CheckGroupNameExistsDocument, options);
}
export function useCheckGroupNameExistsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(CheckGroupNameExistsDocument, options);
}
export const SearchVariablesDocument = lazyGql(() => gql `
    query searchVariables($request: VariableSearchRequestInput) {
  restapiV2__searchVariables(request: $request) {
    data {
      id
      name
      variable_type
      sensitive
      values
      org {
        id
        name
      }
    }
    last_batch
  }
}
    `);
export function useSearchVariablesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(SearchVariablesDocument, options);
}
export function useSearchVariablesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(SearchVariablesDocument, options);
}
export const CreateVariableDocument = lazyGql(() => gql `
    mutation createVariable($request: CreateVariableInput!) {
  restapiV2__createVariables(request: $request) {
    id
    name
    variable_type
    sensitive
  }
}
    `);
export function useCreateVariableMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateVariableDocument, options);
}
export const UpdateVariableValuesDocument = lazyGql(() => gql `
    mutation updateVariableValues($request: UpdateVariableValuesInput!) {
  restapiV2__updateVariableValues(request: $request) {
    success
  }
}
    `);
export function useUpdateVariableValuesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateVariableValuesDocument, options);
}
export const UpdateVariableDocument = lazyGql(() => gql `
    mutation updateVariable($request: PutVariableValuesInput!) {
  restapiV2__updateVariable(request: $request) {
    success
  }
}
    `);
export function useUpdateVariableMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateVariableDocument, options);
}
export const DeleteVariablesDocument = lazyGql(() => gql `
    mutation deleteVariables($ids: [String!]!) {
  restapiV2__deleteVariables(ids: $ids)
}
    `);
export function useDeleteVariablesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteVariablesDocument, options);
}
export const DeleteVariableDocument = lazyGql(() => gql `
    mutation deleteVariable($id: String!) {
  restapiV2__deleteVariable(id: $id)
}
    `);
export function useDeleteVariableMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteVariableDocument, options);
}
export const UpdateVariableNameDocument = lazyGql(() => gql `
    mutation updateVariableName($identifier: String!, $request: UpdateVariableNameInput!) {
  restapiV2__updateVariableName(identifier: $identifier, request: $request) {
    success
  }
}
    `);
export function useUpdateVariableNameMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateVariableNameDocument, options);
}
export const FetchGitBranchesDocument = lazyGql(() => gql `
    query fetchGitBranches($data: FetchGitBranchesInput!) {
  VersionControl__fetchGitBranches(inputData: $data)
}
    `);
export function useFetchGitBranchesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(FetchGitBranchesDocument, options);
}
export function useFetchGitBranchesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(FetchGitBranchesDocument, options);
}
export const GetGitConfigDocument = lazyGql(() => gql `
    query getGitConfig($data: GetGitConfigsInput) {
  VersionControl__getGitConfig(request: $data) {
    data {
      repository_url
      username
      commit_branch_name
      configuration_branch_name
      org {
        id
        name
      }
      properties_acquired
      enable_version_history
      status
    }
    last_batch
  }
}
    `);
export function useGetGitConfigQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetGitConfigDocument, options);
}
export function useGetGitConfigLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetGitConfigDocument, options);
}
export const GetAllOrgsListDocument = lazyGql(() => gql `
    query getAllOrgsList($data: Org__ListInput!) {
  getOrgsList(data: $data) {
    Data {
      orgs {
        orgId
        orgName
      }
    }
  }
}
    `);
export function useGetAllOrgsListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAllOrgsListDocument, options);
}
export function useGetAllOrgsListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAllOrgsListDocument, options);
}
export const CreateGitConfigDocument = lazyGql(() => gql `
    mutation createGitConfig($data: VCSCreateConfigInput!) {
  VersionControl__createGitConfig(inputData: $data) {
    repository_url
    username
    commit_branch_name
    branches
    configuration_branch_name
    org {
      id
      name
    }
    enable_version_history
  }
}
    `);
export function useCreateGitConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateGitConfigDocument, options);
}
export const UpdateGitConfigDocument = lazyGql(() => gql `
    mutation updateGitConfig($data: VCSUpdateConfigInput) {
  VersionControl__updateGitConfig(inputData: $data) {
    repository_url
    username
    commit_branch_name
    branches
    configuration_branch_name
    org {
      id
      name
    }
    enable_version_history
  }
}
    `);
export function useUpdateGitConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateGitConfigDocument, options);
}
export const ResetGitConfigDocument = lazyGql(() => gql `
    mutation resetGitConfig($clusterLevel: Boolean) {
  VersionControl__resetGitConfig(clusterLevel: $clusterLevel)
}
    `);
export function useResetGitConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ResetGitConfigDocument, options);
}
export const ResetGitConfigWithOrgDocument = lazyGql(() => gql `
    mutation resetGitConfigWithOrg($orgIdentifier: String!) {
  VersionControl__resetGitConfigWithOrg(orgIdentifier: $orgIdentifier)
}
    `);
export function useResetGitConfigWithOrgMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ResetGitConfigWithOrgDocument, options);
}
//# sourceMappingURL=graphql-types.js.map